//перевод контента на карточке торгового сигнала
const translation: Record<string, Record<string, string>> = {
  inviteHookOpen1: {
    ru: "Открыл позицию 🔥 по Apple Inc",
    en: "Just opened 🔥 Apple Inc",
    es: "Abrí posición 🔥 en Apple Inc",
    pt: "Acabei de abrir 🔥 posição em Apple Inc",
    de: "Gerade Apple Inc 🔥 geöffnet",
    fr: "Vient d’ouvrir 🔥 Apple Inc",
  },
  inviteHookOpen2: {
    ru: "Взял позицию 🔥 по Apple Inc",
    en: "Took a position 🔥 in Apple Inc",
    es: "Tomé posición 🔥 en Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Eine Position in 🔥 Apple Inc eröffnet",
    fr: "Pris position 🔥 sur Apple Inc",
  },
  inviteHookOpen3: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen4: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen5: {
    ru: "Старт по 🔥 Apple Inc",
    en: "Apple Inc move 🔥 initiated",
    es: "Movimiento iniciado 🔥 en Apple Inc",
    pt: "Movimento iniciado 🔥 em Apple Inc",
    de: "Bewegung bei 🔥 Apple Inc gestartet",
    fr: "Mouvement lancé 🔥 sur Apple Inc",
  },
  inviteHookOpen6: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen7: {
    ru: "Вход по 🔥 Apple Inc",
    en: "Entry on Apple Inc 🔥 confirmed",
    es: "Entrada en 🔥 Apple Inc confirmada",
    pt: "Entrada em 🔥 Apple Inc confirmada",
    de: "Einstieg bei 🔥 Apple Inc bestätigt",
    fr: "Entrée sur 🔥 Apple Inc confirmée",
  },
  inviteHookOpen8: {
    ru: "Я в 🔥 Apple Inc",
    en: "I'm in 🔥 Apple Inc",
    es: "Estoy en 🔥 Apple Inc",
    pt: "Tô em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc drin",
    fr: "Je suis sur 🔥 Apple Inc",
  },
  inviteHookOpen9: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen10: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen11: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen12: {
    ru: "Открыл 🔥 Apple Inc",
    en: "I opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Ouvert 🔥 Apple Inc",
  },
  inviteHookOpen13: {
    ru: "Открыл сделку 🔥 по Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí trade 🔥 en Apple Inc",
    pt: "Abri trade 🔥 em Apple Inc",
    de: "Trade bei 🔥 Apple Inc eröffnet",
    fr: "Trade ouvert 🔥 sur Apple Inc",
  },
  inviteHookOpen14: {
    ru: "Зашёл в 🔥 Apple Inc тихо",
    en: "Entered 🔥 Apple Inc quietly",
    es: "Entré en Apple Inc 🔥 en silencio",
    pt: "Entrei em Apple Inc 🔥 em silêncio",
    de: "Leise in Apple Inc 🔥 eingestiegen",
    fr: "Entré discrètement 🔥 sur Apple Inc",
  },
  inviteHookOpen15: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen16: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Ouvert 🔥 Apple Inc",
  },
  inviteHookOpen17: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen18: {
    ru: "Зашёл в Apple Inc 🔥 с холодной головой",
    en: "I entered Apple Inc 🔥 with a calm mind",
    es: "Entré en Apple Inc 🔥 con la mente tranquila",
    pt: "Entrei em Apple Inc 🔥 com a mente tranquila",
    de: "Bin in Apple Inc 🔥 eingestiegen mit klarem Kopf",
    fr: "Je suis entré sur Apple Inc 🔥 avec l’esprit calme",
  },
  inviteHookOpen19: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen20: {
    ru: "Первый шаг 🔥 по Apple Inc",
    en: "First step taken 🔥 on Apple Inc",
    es: "Primer paso tomado 🔥 en Apple Inc",
    pt: "Primeiro passo 🔥 dado em Apple Inc",
    de: "Erster Schritt bei 🔥 Apple Inc getan",
    fr: "Première étape sur 🔥 Apple Inc faite",
  },
  inviteHookOpen21: {
    ru: "Официально 🔥 в Apple Inc",
    en: "I'm officially 🔥 in Apple Inc",
    es: "Oficialmente dentro 🔥 de Apple Inc",
    pt: "Oficialmente dentro 🔥 de Apple Inc",
    de: "Offiziell in 🔥 Apple Inc",
    fr: "Officiellement 🔥 dans Apple Inc",
  },
  inviteHookOpen22: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen23: {
    ru: "Только что 🔥 купил Apple Inc",
    en: "Just bought 🔥 Apple Inc",
    es: "Recién compré 🔥 Apple Inc",
    pt: "Acabei de 🔥 comprar Apple Inc",
    de: "Gerade Apple Inc 🔥 gekauft",
    fr: "Vient d’acheter 🔥 Apple Inc",
  },
  inviteHookOpen24: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen25: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Je suis entré 🔥 sur Apple Inc",
  },
  inviteHookOpen26: {
    ru: "Спокойный вход 🔥 по Apple Inc",
    en: "Took a calm entry 🔥 on Apple Inc",
    es: "Entrada tranquila 🔥 en Apple Inc",
    pt: "Entrada tranquila 🔥 em Apple Inc",
    de: "Ruhiger Einstieg 🔥 in Apple Inc",
    fr: "Entré tranquillement 🔥 sur Apple Inc",
  },
  inviteHookOpen27: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen28: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Ouvert 🔥 Apple Inc",
  },
  inviteHookOpen29: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen30: {
    ru: "Я зашёл в 🔥 Apple Inc",
    en: "I entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Je suis entré 🔥 sur Apple Inc",
  },
  inviteHookOpen31: {
    ru: "Только что встал 🔥 в Apple Inc",
    en: "Just in: 🔥 Apple Inc",
    es: "Recién dentro 🔥 de Apple Inc",
    pt: "Acabei de entrar 🔥 em Apple Inc",
    de: "Gerade in Apple Inc 🔥 eingestiegen",
    fr: "Juste entré 🔥 sur Apple Inc",
  },
  inviteHookOpen32: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen33: {
    ru: "Купил 🔥 Apple Inc",
    en: "Bought 🔥 Apple Inc",
    es: "Compré 🔥 Apple Inc",
    pt: "Comprei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Acheté 🔥 Apple Inc",
  },
  inviteHookOpen34: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen35: {
    ru: "Сделал вход 🔥 по Apple Inc",
    en: "Took an entry 🔥 in Apple Inc",
    es: "Tomé entrada 🔥 en Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Pris une position 🔥 sur Apple Inc",
  },
  inviteHookOpen36: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen37: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen38: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen39: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Ouvert 🔥 Apple Inc",
  },
  inviteHookOpen40: {
    ru: "Тихий заход 🔥 по Apple Inc",
    en: "Took a quiet move 🔥 on Apple Inc",
    es: "Movimiento tranquilo 🔥 en Apple Inc",
    pt: "Movimento tranquilo 🔥 em Apple Inc",
    de: "Ruhiger Einstieg 🔥 in Apple Inc",
    fr: "Mouvement tranquille 🔥 sur Apple Inc",
  },
  inviteHookOpen41: {
    ru: "Apple Inc — 🔥 я в позиции",
    en: "Apple Inc 🔥 — I'm in",
    es: "Apple Inc — 🔥 estoy dentro",
    pt: "Apple Inc 🔥 — tô dentro",
    de: "Apple Inc 🔥 — bin drin",
    fr: "Apple Inc — je 🔥 suis dedans",
  },
  inviteHookOpen42: {
    ru: "Начал позицию 🔥 по Apple Inc",
    en: "Started a position 🔥 in Apple Inc",
    es: "Empecé posición 🔥 en Apple Inc",
    pt: "Comecei posição 🔥 em Apple Inc",
    de: "Position gestartet 🔥 in Apple Inc",
    fr: "Position lancée 🔥 sur Apple Inc",
  },
  inviteHookOpen43: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen44: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen45: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen46: {
    ru: "Сейчас я в 🔥 Apple Inc",
    en: "I'm now in 🔥 Apple Inc",
    es: "Ahora estoy 🔥 en Apple Inc",
    pt: "Agora tô em 🔥 Apple Inc",
    de: "Jetzt in 🔥 Apple Inc drin",
    fr: "Je suis maintenant 🔥 dans Apple Inc",
  },
  inviteHookOpen47: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen48: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen49: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen50: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Ouvert 🔥 Apple Inc",
  },
  inviteHookOpen51: {
    ru: "Я в 🔥 Apple Inc",
    en: "I'm in 🔥 Apple Inc",
    es: "Estoy en 🔥 Apple Inc",
    pt: "Tô em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Je suis dans 🔥 Apple Inc",
  },
  inviteHookOpen52: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen53: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Ouvert 🔥 Apple Inc",
  },
  inviteHookOpen54: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen55: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen56: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen57: {
    ru: "Только что 🔥 открыл Apple Inc",
    en: "Just opened 🔥 Apple Inc",
    es: "Recién abrí 🔥 Apple Inc",
    pt: "Acabei de 🔥 abrir Apple Inc",
    de: "Gerade Apple Inc 🔥 eröffnet",
    fr: "Vient d’ouvrir 🔥 Apple Inc",
  },
  inviteHookOpen58: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen59: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "I entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen60: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen61: {
    ru: "Купил 🔥 Apple Inc",
    en: "Bought 🔥 Apple Inc",
    es: "Compré 🔥 Apple Inc",
    pt: "Comprei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Acheté 🔥 Apple Inc",
  },
  inviteHookOpen62: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen63: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen64: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen65: {
    ru: "Я в 🔥 Apple Inc",
    en: "I'm in 🔥 Apple Inc",
    es: "Estoy en 🔥 Apple Inc",
    pt: "Tô em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Je suis dans 🔥 Apple Inc",
  },
  inviteHookOpen66: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen67: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen68: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen69: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen70: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen71: {
    ru: "Только что 🔥 взял Apple Inc",
    en: "Just took 🔥 Apple Inc",
    es: "Recién tomé 🔥 Apple Inc",
    pt: "Acabei de 🔥 pegar Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen72: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen73: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "I entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen74: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen75: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen76: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen77: {
    ru: "Зашёл в Apple Inc 🔥 сосредоточенно и логично",
    en: "Entered Apple Inc 🔥 with focus and logic",
    es: "Entré en Apple Inc 🔥 con enfoque y lógica",
    pt: "Entrei em Apple Inc 🔥 com foco e lógica",
    de: "In Apple Inc eingestiegen 🔥 mit Fokus und Logik",
    fr: "Entré sur Apple Inc 🔥 avec focus et logique",
  },
  inviteHookOpen78: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen79: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen80: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen81: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Ouvert 🔥 Apple Inc",
  },
  inviteHookOpen82: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen83: {
    ru: "Тихо взял 🔥 Apple Inc",
    en: "Took Apple Inc 🔥 quietly",
    es: "Tomé Apple Inc 🔥 en silencio",
    pt: "Peguei Apple Inc 🔥 em silêncio",
    de: "Leise in Apple Inc 🔥 eingestiegen",
    fr: "Entré discrètement 🔥 sur Apple Inc",
  },
  inviteHookOpen84: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen85: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "I entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen86: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen87: {
    ru: "Купил 🔥 Apple Inc",
    en: "Bought 🔥 Apple Inc",
    es: "Compré 🔥 Apple Inc",
    pt: "Comprei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Acheté 🔥 Apple Inc",
  },
  inviteHookOpen88: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen89: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen90: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen91: {
    ru: "Только что 🔥 открыл Apple Inc",
    en: "Just opened 🔥 Apple Inc",
    es: "Recién abrí 🔥 Apple Inc",
    pt: "Acabei de 🔥 abrir Apple Inc",
    de: "Gerade Apple Inc 🔥 eröffnet",
    fr: "Vient d’ouvrir 🔥 Apple Inc",
  },
  inviteHookOpen92: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen93: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen94: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen95: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen96: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen97: {
    ru: "Купил 🔥 Apple Inc",
    en: "Bought 🔥 Apple Inc",
    es: "Compré 🔥 Apple Inc",
    pt: "Comprei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Acheté 🔥 Apple Inc",
  },
  inviteHookOpen98: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen99: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen100: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen101: {
    ru: "Открыл позицию 🔥 по Apple Inc",
    en: "Opened a position 🔥 on Apple Inc",
    es: "Abrí posición 🔥 en Apple Inc",
    pt: "Abri posição 🔥 em Apple Inc",
    de: "Position in 🔥 Apple Inc eröffnet",
    fr: "Position ouverte 🔥 sur Apple Inc",
  },
  inviteHookOpen102: {
    ru: "Взял позицию 🔥 по Apple Inc",
    en: "Took a position 🔥 on Apple Inc",
    es: "Tomé posición 🔥 en Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin bei Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen103: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen104: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen105: {
    ru: "Старт по 🔥 Apple Inc",
    en: "Starting with 🔥 Apple Inc",
    es: "Inicio en 🔥 Apple Inc",
    pt: "Início em 🔥 Apple Inc",
    de: "Start mit 🔥 Apple Inc",
    fr: "Départ sur 🔥 Apple Inc",
  },
  inviteHookOpen106: {
    ru: "Взял 🔥 Apple Inc",
    en: "Picked up 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen107: {
    ru: "Вход по 🔥 Apple Inc",
    en: "Entry on 🔥 Apple Inc",
    es: "Entrada en 🔥 Apple Inc",
    pt: "Entrada em 🔥 Apple Inc",
    de: "Einstieg bei 🔥 Apple Inc",
    fr: "Entrée sur 🔥 Apple Inc",
  },
  inviteHookOpen108: {
    ru: "Я в 🔥 Apple Inc",
    en: "I’m in 🔥 Apple Inc",
    es: "Estoy en 🔥 Apple Inc",
    pt: "Estou em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Je suis sur 🔥 Apple Inc",
  },
  inviteHookOpen109: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin bei 🔥 Apple Inc drin",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen110: {
    ru: "Взял 🔥 Apple Inc",
    en: "Took 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen111: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen112: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Apple Inc 🔥 ouverte",
  },
  inviteHookOpen113: {
    ru: "Открыл сделку 🔥 по Apple Inc",
    en: "Opened a trade 🔥 on Apple Inc",
    es: "Abrí operación 🔥 en Apple Inc",
    pt: "Abri operação 🔥 em Apple Inc",
    de: "Trade eröffnet 🔥 bei Apple Inc",
    fr: "Trade ouvert 🔥 sur Apple Inc",
  },
  inviteHookOpen114: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Apple Inc 🔥 Einstieg",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen115: {
    ru: "Apple Inc — 🔥 позиция активна",
    en: "Apple Inc — 🔥 position active",
    es: "Apple Inc — 🔥 posición activa",
    pt: "Apple Inc — 🔥 posição ativa",
    de: "Apple Inc — 🔥 Position aktiv",
    fr: "Apple Inc — 🔥 position active",
  },
  inviteHookOpen116: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Apple Inc 🔥 ouverte",
  },
  inviteHookOpen117: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen118: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Einstieg bei 🔥 Apple Inc",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen119: {
    ru: "Apple Inc — 🔥 сделка стартовала",
    en: "Apple Inc — 🔥 trade’s live",
    es: "Apple Inc — 🔥 operación iniciada",
    pt: "Apple Inc — 🔥 operação iniciada",
    de: "Apple Inc — 🔥 Trade läuft",
    fr: "Apple Inc — 🔥 trade lancé",
  },
  inviteHookOpen120: {
    ru: "Первый шаг 🔥 по Apple Inc",
    en: "First step 🔥 on Apple Inc",
    es: "Primer paso 🔥 en Apple Inc",
    pt: "Primeiro passo 🔥 em Apple Inc",
    de: "Erster Schritt 🔥 bei Apple Inc",
    fr: "Premier pas 🔥 sur Apple Inc",
  },
  inviteHookOpen121: {
    ru: "Официально 🔥 в Apple Inc",
    en: "Officially 🔥 in Apple Inc",
    es: "Oficialmente 🔥 en Apple Inc",
    pt: "Oficialmente 🔥 em Apple Inc",
    de: "Offiziell in 🔥 Apple Inc",
    fr: "Officiellement 🔥 sur Apple Inc",
  },
  inviteHookOpen122: {
    ru: "Apple Inc 🔥 — вошёл",
    en: "Apple Inc 🔥 — entered",
    es: "Apple Inc 🔥 — entré",
    pt: "Apple Inc 🔥 — entrei",
    de: "Apple Inc — 🔥 Einstieg gemacht",
    fr: "Apple Inc 🔥 — Entré",
  },
  inviteHookOpen123: {
    ru: "Только что 🔥 купил Apple Inc",
    en: "Just bought 🔥 Apple Inc",
    es: "Acabo de comprar 🔥 Apple Inc",
    pt: "Acabei de 🔥 comprar Apple Inc",
    de: "Gerade Apple Inc 🔥 gekauft",
    fr: "Je viens d’acheter 🔥 Apple Inc",
  },
  inviteHookOpen124: {
    ru: "Apple Inc — открылся 🔥 небольшим объёмом",
    en: "Apple Inc — 🔥 opened small",
    es: "Apple Inc — abrí con 🔥 un tamaño pequeño",
    pt: "Apple Inc — abri com 🔥 um tamanho pequeno",
    de: "Apple Inc — kleine 🔥 Position eröffnet",
    fr: "Apple Inc — petite 🔥 position ouverte",
  },
  inviteHookOpen125: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin bei 🔥 Apple Inc drin",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen126: {
    ru: "Спокойный вход 🔥 по Apple Inc",
    en: "Calm entry 🔥 on Apple Inc",
    es: "Entrada tranquila 🔥 en Apple Inc",
    pt: "Entrada tranquila 🔥 em Apple Inc",
    de: "Ruhiger Einstieg 🔥 bei Apple Inc",
    fr: "Entrée tranquille 🔥 sur Apple Inc",
  },
  inviteHookOpen127: {
    ru: "Apple Inc — 🔥 позиция в рынке",
    en: "Apple Inc — 🔥 position in play",
    es: "Apple Inc — 🔥 posición abierta",
    pt: "Apple Inc — 🔥 posição aberta",
    de: "Apple Inc — 🔥 Position offen",
    fr: "Apple Inc — 🔥 position ouverte",
  },
  inviteHookOpen128: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Apple Inc 🔥 ouverte",
  },
  inviteHookOpen129: {
    ru: "Apple Inc 🔥 — вход",
    en: "Apple Inc 🔥 — entry",
    es: "Apple Inc 🔥 — entrada",
    pt: "Apple Inc 🔥 — entrada",
    de: "Apple Inc 🔥 — Einstieg",
    fr: "Apple Inc 🔥 — entrée",
  },
  inviteHookOpen130: {
    ru: "Я зашёл в 🔥 Apple Inc",
    en: "I’m in 🔥 Apple Inc",
    es: "Estoy en 🔥 Apple Inc",
    pt: "Estou em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Je suis sur 🔥 Apple Inc",
  },
  inviteHookOpen131: {
    ru: "Только что встал 🔥 в Apple Inc",
    en: "Just entered 🔥 Apple Inc",
    es: "Recién entré 🔥 en Apple Inc",
    pt: "Acabei de entrar 🔥 em Apple Inc",
    de: "Gerade in Apple Inc 🔥 eingestiegen",
    fr: "Je viens d’entrer 🔥 sur Apple Inc",
  },
  inviteHookOpen132: {
    ru: "Apple Inc 🔥 — вошел",
    en: "Apple Inc 🔥 — entered",
    es: "Apple Inc — 🔥 entrada hecha",
    pt: "Apple Inc — 🔥 entrada feita",
    de: "Apple Inc — 🔥 Einstieg gemacht",
    fr: "Apple Inc — 🔥 entrée faite",
  },
  inviteHookOpen133: {
    ru: "Купил 🔥 Apple Inc",
    en: "Bought 🔥 Apple Inc",
    es: "Compré 🔥 Apple Inc",
    pt: "Comprei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Acheté 🔥 Apple Inc",
  },
  inviteHookOpen134: {
    ru: "Apple Inc 🔥 — открылся",
    en: "Apple Inc 🔥 — opened",
    es: "Apple Inc 🔥 — abierta",
    pt: "Apple Inc 🔥 — aberta",
    de: "Apple Inc 🔥 — eröffnet",
    fr: "Apple Inc 🔥 — ouverte",
  },
  inviteHookOpen135: {
    ru: "Сделал вход 🔥 по Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Einstieg bei 🔥 Apple Inc",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen136: {
    ru: "Apple Inc — 🔥 сетап собран",
    en: "Apple Inc — 🔥 setup’s ready",
    es: "Apple Inc — 🔥 setup listo",
    pt: "Apple Inc — 🔥 setup montado",
    de: "Apple Inc — 🔥 Setup steht",
    fr: "Apple Inc — 🔥 setup prêt",
  },
  inviteHookOpen137: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin in Apple Inc 🔥 eingestiegen",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen138: {
    ru: "Apple Inc — 🔥 вход выполнен",
    en: "Apple Inc — 🔥 entry’s in",
    es: "Apple Inc — 🔥 entrada hecha",
    pt: "Apple Inc — 🔥 entrada feita",
    de: "Apple Inc — 🔥 Einstieg gemacht",
    fr: "Apple Inc — 🔥 entrée faite",
  },
  inviteHookOpen139: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Apple Inc 🔥 ouverte",
  },
  inviteHookOpen140: {
    ru: "Тихий заход 🔥 по Apple Inc",
    en: "Quiet entry 🔥 on Apple Inc",
    es: "Entrada tranquila 🔥 en Apple Inc",
    pt: "Entrada discreta 🔥 em Apple Inc",
    de: "Leiser Einstieg 🔥 bei Apple Inc",
    fr: "Entrée discrète 🔥 sur Apple Inc",
  },
  inviteHookOpen141: {
    ru: "Apple Inc — 🔥 я в позиции",
    en: "Apple Inc — 🔥 I’m in position",
    es: "Apple Inc — 🔥 Estoy en posición",
    pt: "Apple Inc — 🔥 Estou na posição",
    de: "Apple Inc — 🔥 Bin in Position",
    fr: "Apple Inc — 🔥 En position",
  },
  inviteHookOpen142: {
    ru: "Начал позицию 🔥 по Apple Inc",
    en: "Started a position 🔥 on Apple Inc",
    es: "Inicié posición 🔥 en Apple Inc",
    pt: "Iniciei posição 🔥 em Apple Inc",
    de: "Position gestartet 🔥 bei Apple Inc",
    fr: "Position lancée 🔥 sur Apple Inc",
  },
  inviteHookOpen143: {
    ru: "Apple Inc — 🔥 позиция в рынке",
    en: "Apple Inc — 🔥 position live",
    es: "Apple Inc — 🔥 posición abierta",
    pt: "Apple Inc — 🔥 posição ativa",
    de: "Apple Inc — 🔥 Position aktiv",
    fr: "Apple Inc — 🔥 position active",
  },
  inviteHookOpen144: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin bei 🔥 Apple Inc drin",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen145: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen146: {
    ru: "Сейчас я в 🔥 Apple Inc",
    en: "I’m in 🔥 Apple Inc",
    es: "Estoy en 🔥 Apple Inc",
    pt: "Estou em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Je suis sur 🔥 Apple Inc",
  },
  inviteHookOpen147: {
    ru: "Apple Inc — 🔥 чистый вход",
    en: "Apple Inc — 🔥 clean entry",
    es: "Apple Inc — 🔥 entrada limpia",
    pt: "Apple Inc — 🔥 entrada limpa",
    de: "Apple Inc — 🔥 sauberer Einstieg",
    fr: "Apple Inc — 🔥 entrée propre",
  },
  inviteHookOpen148: {
    ru: "Взял 🔥 Apple Inc",
    en: "Picked up 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen149: {
    ru: "Apple Inc — 🔥 позиция активна",
    en: "Apple Inc — 🔥 position active",
    es: "Apple Inc — 🔥 posición activa",
    pt: "Apple Inc — 🔥 posição ativa",
    de: "Apple Inc — 🔥 Position aktiv",
    fr: "Apple Inc — 🔥 position active",
  },
  inviteHookOpen150: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Apple Inc 🔥 ouverte",
  },
  inviteHookOpen151: {
    ru: "Я в 🔥 Apple Inc",
    en: "I’m in 🔥 Apple Inc",
    es: "Estoy en 🔥 Apple Inc",
    pt: "Estou em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Je suis sur 🔥 Apple Inc",
  },
  inviteHookOpen152: {
    ru: "Apple Inc 🔥 — вошёл",
    en: "Apple Inc 🔥 — entered",
    es: "Apple Inc — 🔥 entrada hecha",
    pt: "Apple Inc — 🔥 entrada feita",
    de: "Apple Inc — 🔥 Einstieg gemacht",
    fr: "Apple Inc — 🔥 entrée faite",
  },
  inviteHookOpen153: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Apple Inc 🔥 ouverte",
  },
  inviteHookOpen154: {
    ru: "Apple Inc — 🔥 спокойный вход",
    en: "Apple Inc — 🔥 calm entry",
    es: "Apple Inc — 🔥 entrada tranquila",
    pt: "Apple Inc — 🔥 entrada tranquila",
    de: "Apple Inc — 🔥 ruhiger Einstieg",
    fr: "Apple Inc — 🔥 entrée calme",
  },
  inviteHookOpen155: {
    ru: "Взял 🔥 Apple Inc",
    en: "Picked up 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen156: {
    ru: "Apple Inc — 🔥 уже трекаю",
    en: "Apple Inc — 🔥 tracking already",
    es: "Apple Inc — 🔥 ya siguiendo",
    pt: "Apple Inc — já 🔥 acompanhando",
    de: "Apple Inc — 🔥 schon im Blick",
    fr: "Apple Inc — 🔥 déjà en suivi",
  },
  inviteHookOpen157: {
    ru: "Только что 🔥 открыл Apple Inc",
    en: "Just opened 🔥 Apple Inc",
    es: "Recién abrí 🔥 Apple Inc",
    pt: "Acabei de 🔥 abrir Apple Inc",
    de: "Gerade Apple Inc 🔥 eröffnet",
    fr: "Je viens d’ouvrir 🔥 Apple Inc",
  },
  inviteHookOpen158: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen159: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen160: {
    ru: "Apple Inc — 🔥 вошел чисто",
    en: "Apple Inc — 🔥 clean entry",
    es: "Apple Inc — 🔥 entrada limpia",
    pt: "Apple Inc — 🔥 entrada limpa",
    de: "Apple Inc — 🔥 sauberer Einstieg",
    fr: "Apple Inc — 🔥 entrée propre",
  },
  inviteHookOpen161: {
    ru: "Купил 🔥 Apple Inc",
    en: "Bought 🔥 Apple Inc",
    es: "Compré 🔥 Apple Inc",
    pt: "Comprei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Acheté 🔥 Apple Inc",
  },
  inviteHookOpen162: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen163: {
    ru: "Взял 🔥 Apple Inc",
    en: "Picked up 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen164: {
    ru: "Apple Inc — 🔥 позиция в рынке",
    en: "Apple Inc — 🔥 position live",
    es: "Apple Inc — 🔥 posición abierta",
    pt: "Apple Inc — 🔥 posição aberta",
    de: "Apple Inc — 🔥 Position offen",
    fr: "Apple Inc — 🔥 position ouverte",
  },
  inviteHookOpen165: {
    ru: "Я в 🔥 Apple Inc",
    en: "I’m in 🔥 Apple Inc",
    es: "Estoy en 🔥 Apple Inc",
    pt: "Estou em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Je suis sur 🔥 Apple Inc",
  },
  inviteHookOpen166: {
    ru: "Apple Inc 🔥 — вошёл",
    en: "Apple Inc 🔥 — entered",
    es: "Apple Inc — 🔥 entrada hecha",
    pt: "Apple Inc — 🔥 entrada feita",
    de: "Apple Inc — 🔥 Einstieg gemacht",
    fr: "Apple Inc — 🔥 entrée faite",
  },
  inviteHookOpen167: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Einstieg bei 🔥 Apple Inc",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen168: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen169: {
    ru: "Взял 🔥 Apple Inc",
    en: "Picked up 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen170: {
    ru: "Apple Inc — 🔥 спокойный вход",
    en: "Apple Inc — 🔥 calm entry",
    es: "Apple Inc — 🔥 entrada tranquila",
    pt: "Apple Inc — 🔥 entrada tranquila",
    de: "Apple Inc — 🔥 ruhiger Einstieg",
    fr: "Apple Inc — 🔥 entrée calme",
  },
  inviteHookOpen171: {
    ru: "Только что 🔥 взял Apple Inc",
    en: "Just picked 🔥 up Apple Inc",
    es: "Recién tomé 🔥 Apple Inc",
    pt: "Acabei de 🔥 pegar Apple Inc",
    de: "Gerade Apple Inc 🔥 genommen",
    fr: "Je viens de 🔥 prendre Apple Inc",
  },
  inviteHookOpen172: {
    ru: "Apple Inc — 🔥 сделка стартовала",
    en: "Apple Inc — 🔥 trade’s on",
    es: "Apple Inc — 🔥 operación iniciada",
    pt: "Apple Inc — 🔥 operação iniciada",
    de: "Apple Inc — 🔥 Trade gestartet",
    fr: "Apple Inc — 🔥 trade lancé",
  },
  inviteHookOpen173: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Einstieg bei 🔥 Apple Inc",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen174: {
    ru: "Apple Inc — 🔥 позиция активна",
    en: "Apple Inc — 🔥 position’s live",
    es: "Apple Inc — 🔥 posición activa",
    pt: "Apple Inc — 🔥 posição ativa",
    de: "Apple Inc — 🔥 Position aktiv",
    fr: "Apple Inc — 🔥 position active",
  },
  inviteHookOpen175: {
    ru: "Взял 🔥 Apple Inc",
    en: "Picked up 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen176: {
    ru: "Apple Inc — 🔥 сделка активна",
    en: "Apple Inc — 🔥 trade’s running",
    es: "Apple Inc — 🔥 operación activa",
    pt: "Apple Inc — 🔥 operação ativa",
    de: "Apple Inc — 🔥 Trade läuft",
    fr: "Apple Inc — 🔥 trade en cours",
  },
  inviteHookOpen177: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen178: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen179: {
    ru: "Взял 🔥 Apple Inc",
    en: "Picked up 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen180: {
    ru: "Apple Inc — 🔥 спокойное исполнение",
    en: "Apple Inc — 🔥 clean execution",
    es: "Apple Inc — 🔥 ejecución limpia",
    pt: "Apple Inc — 🔥 execução limpa",
    de: "Apple Inc — 🔥 sauber ausgeführt",
    fr: "Apple Inc — 🔥 exécution propre",
  },
  inviteHookOpen181: {
    ru: "Открыл 🔥 Apple Inc",
    en: "Opened 🔥 Apple Inc",
    es: "Abrí 🔥 Apple Inc",
    pt: "Abri 🔥 Apple Inc",
    de: "Apple Inc 🔥 eröffnet",
    fr: "Apple Inc 🔥 ouverte",
  },
  inviteHookOpen182: {
    ru: "Apple Inc — 🔥 вход выполнен",
    en: "Apple Inc — 🔥 entry complete",
    es: "Apple Inc — 🔥 entrada hecha",
    pt: "Apple Inc — 🔥 entrada concluída",
    de: "Apple Inc — Einstieg 🔥 abgeschlossen",
    fr: "Apple Inc — 🔥 entrée terminée",
  },
  inviteHookOpen183: {
    ru: "Тихо взял 🔥 Apple Inc",
    en: "Quietly picked 🔥 up Apple Inc",
    es: "Tomé discretamente 🔥 Apple Inc",
    pt: "Peguei silenciosamente 🔥 Apple Inc",
    de: "Apple Inc 🔥 still genommen",
    fr: "Pris discrètement 🔥 Apple Inc",
  },
  inviteHookOpen184: {
    ru: "Взял 🔥 Apple Inc",
    en: "Picked up 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen185: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen186: {
    ru: "Apple Inc — 🔥 позиция открыта",
    en: "Apple Inc — 🔥 position open",
    es: "Apple Inc — 🔥 posición abierta",
    pt: "Apple Inc — 🔥 posição aberta",
    de: "Apple Inc — 🔥 Position offen",
    fr: "Apple Inc — 🔥 position ouverte",
  },
  inviteHookOpen187: {
    ru: "Купил 🔥 Apple Inc",
    en: "Bought 🔥 Apple Inc",
    es: "Compré 🔥 Apple Inc",
    pt: "Comprei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Acheté 🔥 Apple Inc",
  },
  inviteHookOpen188: {
    ru: "Apple Inc — вход 🔥 подтверждён",
    en: "Apple Inc — 🔥 entry confirmed",
    es: "Apple Inc — 🔥 entrada confirmada",
    pt: "Apple Inc — 🔥 entrada confirmada",
    de: "Apple Inc — 🔥 Einstieg bestätigt",
    fr: "Apple Inc — 🔥 entrée confirmée",
  },
  inviteHookOpen189: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Einstieg bei 🔥 Apple Inc",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen190: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen191: {
    ru: "Только что 🔥 открыл Apple Inc",
    en: "Just opened 🔥 Apple Inc",
    es: "Recién abrí 🔥 Apple Inc",
    pt: "Acabei de 🔥 abrir Apple Inc",
    de: "Gerade Apple Inc 🔥 eröffnet",
    fr: "Je viens d’ouvrir 🔥 Apple Inc",
  },
  inviteHookOpen192: {
    ru: "Apple Inc — 🔥 позиция в рынке",
    en: "Apple Inc — 🔥 position live",
    es: "Apple Inc — 🔥 posición abierta",
    pt: "Apple Inc — 🔥 posição ativa",
    de: "Apple Inc — 🔥 Position aktiv",
    fr: "Apple Inc — 🔥 position active",
  },
  inviteHookOpen193: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin bei 🔥 Apple Inc drin",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen194: {
    ru: "Apple Inc — 🔥 открыл осознанно",
    en: "Apple Inc — entered 🔥 intentionally",
    es: "Apple Inc — 🔥 entrada intencional",
    pt: "Apple Inc — 🔥 entrada consciente",
    de: "Apple Inc — 🔥 bewusster Einstieg",
    fr: "Apple Inc — 🔥 entrée réfléchie",
  },
  inviteHookOpen195: {
    ru: "Взял 🔥 Apple Inc",
    en: "Picked up 🔥 Apple Inc",
    es: "Tomé 🔥 Apple Inc",
    pt: "Peguei 🔥 Apple Inc",
    de: "Apple Inc 🔥 genommen",
    fr: "Pris 🔥 Apple Inc",
  },
  inviteHookOpen196: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen197: {
    ru: "Купил 🔥 Apple Inc",
    en: "Bought 🔥 Apple Inc",
    es: "Compré 🔥 Apple Inc",
    pt: "Comprei 🔥 Apple Inc",
    de: "Apple Inc 🔥 gekauft",
    fr: "Acheté 🔥 Apple Inc",
  },
  inviteHookOpen198: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookOpen199: {
    ru: "Зашёл в 🔥 Apple Inc",
    en: "Entered 🔥 Apple Inc",
    es: "Entré en 🔥 Apple Inc",
    pt: "Entrei em 🔥 Apple Inc",
    de: "Bin in 🔥 Apple Inc",
    fr: "Entré sur 🔥 Apple Inc",
  },
  inviteHookOpen200: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookSecondTitleOpen1: {
    ru: "Посмотрим, как пойдёт",
    en: "Let's see where this goes",
    es: "Vamos a ver hacia dónde va",
    pt: "Vamos ver como isso vai",
    de: "Mal sehen, wohin das führt",
    fr: "On va voir où ça mène",
  },
  inviteHookSecondTitleOpen2: {
    ru: "Интересно, как отработает",
    en: "Curious how it goes",
    es: "Curioso por ver cómo resulta",
    pt: "Curioso pra ver no que dá",
    de: "Bin gespannt, wie es läuft",
    fr: "Curieux de voir comment ça tourne",
  },
  inviteHookSecondTitleOpen3: {
    ru: "Я в позиции, держу",
    en: "I'm in, keeping it simple",
    es: "Ya dentro, manteniéndolo simple",
    pt: "Já dentro, mantendo simples",
    de: "Bin drin, halte es einfach",
    fr: "Je suis dedans, simple et clair",
  },
  inviteHookSecondTitleOpen4: {
    ru: "Спокойно и сосредоточенно",
    en: "Calm and focused",
    es: "Tranquilo y enfocado",
    pt: "Calmo e focado",
    de: "Ruhig und fokussiert",
    fr: "Calme et concentré",
  },
  inviteHookSecondTitleOpen5: {
    ru: "Включаю терпение",
    en: "Patience on",
    es: "Paciencia activada",
    pt: "Paciência ligada",
    de: "Geduld eingeschaltet",
    fr: "Patience activée",
  },
  inviteHookSecondTitleOpen6: {
    ru: "Чистый сетап, понятный план",
    en: "Clean setup, clear plan",
    es: "Setup limpio, plan claro",
    pt: "Setup limpo, plano claro",
    de: "Sauberes Setup, klarer Plan",
    fr: "Setup propre, plan clair",
  },
  inviteHookSecondTitleOpen7: {
    ru: "Теперь жду",
    en: "Now I wait",
    es: "Ahora a esperar",
    pt: "Agora é esperar",
    de: "Jetzt warten",
    fr: "J’attends maintenant",
  },
  inviteHookSecondTitleOpen8: {
    ru: "Дальше время и терпение",
    en: "Time and patience from here",
    es: "De aquí en adelante, paciencia y tiempo",
    pt: "A partir daqui, é tempo e paciência",
    de: "Ab jetzt zählt Zeit und Geduld",
    fr: "Temps et patience à partir d’ici",
  },
  inviteHookSecondTitleOpen9: {
    ru: "Без лишнего, только логика",
    en: "Nothing fancy, just logic",
    es: "Pura lógica, nada de alardes",
    pt: "Nada demais, só lógica",
    de: "Nichts Kompliziertes, nur Logik",
    fr: "Rien de compliqué, juste logique",
  },
  inviteHookSecondTitleOpen10: {
    ru: "Рынок покажет результат",
    en: "Outcome will tell",
    es: "El mercado dirá",
    pt: "O resultado vai mostrar",
    de: "Das Ergebnis wird’s zeigen",
    fr: "Le résultat dira le reste",
  },
  inviteHookSecondTitleOpen11: {
    ru: "Сетап крепкий, вход сделан",
    en: "Solid setup, entry done",
    es: "Buen setup, entrada hecha",
    pt: "Bom setup, entrada concluída",
    de: "Solides Setup, Einstieg erledigt",
    fr: "Setup solide, entrée faite",
  },
  inviteHookSecondTitleOpen12: {
    ru: "Двигаюсь пошагово",
    en: "Step by step",
    es: "Paso a paso",
    pt: "Passo a passo",
    de: "Schritt für Schritt",
    fr: "Étape par étape",
  },
  inviteHookSecondTitleOpen13: {
    ru: "Без суеты",
    en: "No rush",
    es: "Sin prisa",
    pt: "Sem pressa",
    de: "Keine Eile",
    fr: "Sans se presser",
  },
  inviteHookSecondTitleOpen14: {
    ru: "Без суеты",
    en: "No rush",
    es: "Sin prisa",
    pt: "Sem pressa",
    de: "Keine Eile",
    fr: "Sans se presser",
  },
  inviteHookSecondTitleOpen15: {
    ru: "Позиция активна, эмоции в ноль",
    en: "Trade active, emotions off",
    es: "Operación activa, sin emociones",
    pt: "Trade ativo, sem emoção",
    de: "Trade aktiv, Emotionen aus",
    fr: "Trade actif, émotions coupées",
  },
  inviteHookSecondTitleOpen16: {
    ru: "Посмотрим, подтвердится ли идея",
    en: "Let's see if the read holds",
    es: "Vamos a ver si la lectura se confirma",
    pt: "Vamos ver se a leitura se confirma",
    de: "Mal sehen, ob die Analyse stimmt",
    fr: "Voyons si la lecture tient",
  },
  inviteHookSecondTitleOpen17: {
    ru: "Без хайпа, просто исполнение",
    en: "No hype, just execution",
    es: "Sin ruido, solo ejecución",
    pt: "Sem barulho, só execução",
    de: "Kein Hype, nur Ausführung",
    fr: "Pas de hype, juste l’exécution",
  },
  inviteHookSecondTitleOpen18: {
    ru: "Без суеты",
    en: "No rush",
    es: "Sin prisa",
    pt: "Sem pressa",
    de: "Keine Eile",
    fr: "Sans se presser",
  },
  inviteHookSecondTitleOpen19: {
    ru: "Сделка стартовала, добавлять нечего",
    en: "Trade started, nothing to add",
    es: "Operación iniciada, nada más que agregar",
    pt: "Operação iniciada, nada a acrescentar",
    de: "Trade gestartet, nichts hinzuzufügen",
    fr: "Trade lancé, rien à ajouter",
  },
  inviteHookSecondTitleOpen20: {
    ru: "Наблюдаю",
    en: "Watching",
    es: "Observando",
    pt: "Observando",
    de: "Beobachte",
    fr: "J’observe",
  },
  inviteHookSecondTitleOpen21: {
    ru: "Отслеживаю",
    en: "Tracking it",
    es: "Siguiendo el movimiento",
    pt: "Acompanhando o movimento",
    de: "Verfolge den Trade",
    fr: "Je surveille le trade",
  },
  inviteHookSecondTitleOpen22: {
    ru: "Вошёл дисциплинированно",
    en: "Entered with discipline",
    es: "Entrada con disciplina",
    pt: "Entrada com disciplina",
    de: "Disziplinierter Einstieg",
    fr: "Entrée disciplinée",
  },
  inviteHookSecondTitleOpen23: {
    ru: "Посмотрим поведение",
    en: "Let's see how it behaves",
    es: "Vamos a ver cómo se comporta",
    pt: "Vamos ver como se comporta",
    de: "Mal sehen, wie es sich entwickelt",
    fr: "On verra comment ça évolue",
  },
  inviteHookSecondTitleOpen24: {
    ru: "Открылся небольшим объёмом, думаю на дистанцию",
    en: "Opened small, thinking long",
    es: "Posición pequeña, pensando a largo plazo",
    pt: "Posição pequena, pensando no longo prazo",
    de: "Kleine Position, langfristig gedacht",
    fr: "Petite position, vision long terme",
  },
  inviteHookSecondTitleOpen25: {
    ru: "Логика важнее удачи",
    en: "Logic over luck",
    es: "Lógica antes que suerte",
    pt: "Lógica acima da sorte",
    de: "Logik über Glück",
    fr: "La logique avant la chance",
  },
  inviteHookSecondTitleOpen26: {
    ru: "Наблюдаю",
    en: "Watching",
    es: "Observando",
    pt: "Observando",
    de: "Beobachte",
    fr: "J’observe",
  },
  inviteHookSecondTitleOpen27: {
    ru: "Позиция в рынке, режим терпения",
    en: "Trade live, patience mode",
    es: "Posición viva, modo paciencia",
    pt: "Posição ativa, modo paciência",
    de: "Position aktiv, Geduldmodus",
    fr: "Position active, mode patience",
  },
  inviteHookSecondTitleOpen28: {
    ru: "Теперь сетап пусть доказывает себя",
    en: "Now the setup proves itself",
    es: "Ahora el setup tiene que probarse",
    pt: "Agora o setup precisa provar",
    de: "Jetzt muss sich das Setup beweisen",
    fr: "Maintenant le setup doit prouver",
  },
  inviteHookSecondTitleOpen29: {
    ru: "Вход подтверждён, эмоции на парковку",
    en: "Entry confirmed, emotions parked",
    es: "Entrada confirmada, emociones fuera",
    pt: "Entrada confirmada, emoções de lado",
    de: "Einstieg bestätigt, Emotionen geparkt",
    fr: "Entrée confirmée, émotions rangées",
  },
  inviteHookSecondTitleOpen30: {
    ru: "График был логичным",
    en: "The chart made sense",
    es: "El gráfico tenía sentido",
    pt: "O gráfico fazia sentido",
    de: "Der Chart ergab Sinn",
    fr: "Le graphique était logique",
  },
  inviteHookSecondTitleOpen31: {
    ru: "Терплю",
    en: "Staying patient",
    es: "Paciencia ahora",
    pt: "Paciência a partir de agora",
    de: "Geduld ab jetzt",
    fr: "Patience à partir de maintenant",
  },
  inviteHookSecondTitleOpen32: {
    ru: "Чистая база, риск определён",
    en: "Clean base, defined risk",
    es: "Base limpia, riesgo definido",
    pt: "Base limpa, risco definido",
    de: "Saubere Basis, Risiko definiert",
    fr: "Base propre, risque défini",
  },
  inviteHookSecondTitleOpen33: {
    ru: "Теперь игра на ожидание",
    en: "Waiting game now",
    es: "Ahora toca esperar",
    pt: "Agora é o jogo da espera",
    de: "Jetzt heißt es warten",
    fr: "Maintenant on attend",
  },
  inviteHookSecondTitleOpen34: {
    ru: "Открылся тихо, без шума",
    en: "Opened quietly, nothing loud",
    es: "Apertura silenciosa, sin ruido",
    pt: "Abertura silenciosa, sem barulho",
    de: "Ruhig eröffnet, kein Lärm",
    fr: "Ouvert calmement, sans bruit",
  },
  inviteHookSecondTitleOpen35: {
    ru: "Спокойно, как обычно",
    en: "Calm as usual",
    es: "Calma como siempre",
    pt: "Calmo como sempre",
    de: "Ganz entspannt wie immer",
    fr: "Calme comme d’habitude",
  },
  inviteHookSecondTitleOpen36: {
    ru: "Сетап собран, сделка в работе",
    en: "Setup complete, trade live",
    es: "Setup completo, operación activa",
    pt: "Setup completo, trade ativo",
    de: "Setup komplett, Trade läuft",
    fr: "Setup complet, trade en cours",
  },
  inviteHookSecondTitleOpen37: {
    ru: "Рынок решит",
    en: "Market will decide",
    es: "El mercado decidirá",
    pt: "O mercado vai decidir",
    de: "Der Markt wird entscheiden",
    fr: "Le marché décidera",
  },
  inviteHookSecondTitleOpen38: {
    ru: "Вход выполнен, возвращаюсь к рутине",
    en: "Entry done, back to routine",
    es: "Entrada hecha, de vuelta a la rutina",
    pt: "Entrada feita, de volta à rotina",
    de: "Einstieg erledigt, zurück zur Routine",
    fr: "Entrée faite, retour à la routine",
  },
  inviteHookSecondTitleOpen39: {
    ru: "Терпение стартует",
    en: "Patience starts here",
    es: "La paciencia empieza aquí",
    pt: "A paciência começa aqui",
    de: "Die Geduld beginnt hier",
    fr: "La patience commence ici",
  },
  inviteHookSecondTitleOpen40: {
    ru: "Наблюдаю",
    en: "Watching",
    es: "Observando",
    pt: "Observando",
    de: "Beobachte",
    fr: "J’observe",
  },
  inviteHookSecondTitleOpen41: {
    ru: "Слежу за графиком",
    en: "Watching the chart",
    es: "Mirando el gráfico",
    pt: "Acompanhando o gráfico",
    de: "Beobachte den Chart",
    fr: "Je regarde le graphique",
  },
  inviteHookSecondTitleOpen42: {
    ru: "Слежу за графиком",
    en: "Watching the chart",
    es: "Mirando el gráfico",
    pt: "Acompanhando o gráfico",
    de: "Beobachte den Chart",
    fr: "Je regarde le graphique",
  },
  inviteHookSecondTitleOpen43: {
    ru: "Позиция в рынке, фокус держу",
    en: "Trade live, staying focused",
    es: "Operación viva, concentrado",
    pt: "Trade ativo, foco total",
    de: "Trade aktiv, Fokus an",
    fr: "Trade actif, focus total",
  },
  inviteHookSecondTitleOpen44: {
    ru: "Тихо и уверенно",
    en: "Quiet and confident",
    es: "Tranquilo y seguro",
    pt: "Tranquilo e confiante",
    de: "Ruhig und zuversichtlich",
    fr: "Calme et confiant",
  },
  inviteHookSecondTitleOpen45: {
    ru: "Простой сетап, без накруток",
    en: "Simple setup, no overthinking",
    es: "Setup simple, sin complicar",
    pt: "Setup simples, sem complicar",
    de: "Einfaches Setup, kein Overthinking",
    fr: "Setup simple, pas de suranalyse",
  },
  inviteHookSecondTitleOpen46: {
    ru: "Терпение включено",
    en: "Patience on",
    es: "Paciencia activada",
    pt: "Paciência ativada",
    de: "Geduld an",
    fr: "Patience enclenchée",
  },
  inviteHookSecondTitleOpen47: {
    ru: "Чистый вход, эмоции нейтральны",
    en: "Opened clean, emotions neutral",
    es: "Entrada limpia, emociones neutrales",
    pt: "Entrada limpa, emoções neutras",
    de: "Sauberer Einstieg, neutrale Emotionen",
    fr: "Entrée propre, émotions neutres",
  },
  inviteHookSecondTitleOpen48: {
    ru: "Проверим, выдержу ли дисциплину",
    en: "Let's see if discipline holds",
    es: "Veremos si mantengo la disciplina",
    pt: "Vamos ver se a disciplina se mantém",
    de: "Mal sehen, ob die Disziplin hält",
    fr: "Voyons si la discipline tient",
  },
  inviteHookSecondTitleOpen49: {
    ru: "Позиция активна, без спешки",
    en: "Position live, no rush",
    es: "Posición activa, sin apuro",
    pt: "Posição ativa, sem pressa",
    de: "Position aktiv, keine Eile",
    fr: "Position active, pas de précipitation",
  },
  inviteHookSecondTitleOpen50: {
    ru: "Время покажет",
    en: "Time will tell",
    es: "El tiempo lo dirá",
    pt: "O tempo vai dizer",
    de: "Die Zeit wird es zeigen",
    fr: "Le temps le dira",
  },
  inviteHookSecondTitleOpen51: {
    ru: "Дальше — терпение",
    en: "It's patience from here",
    es: "De aquí, pura paciencia",
    pt: "Daqui pra frente, é paciência",
    de: "Ab hier zählt Geduld",
    fr: "À partir d’ici, patience",
  },
  inviteHookSecondTitleOpen52: {
    ru: "Вошёл с намерением",
    en: "Entered with purpose",
    es: "Entrada con intención",
    pt: "Entrada com propósito",
    de: "Einstieg mit Absicht",
    fr: "Entrée avec intention",
  },
  inviteHookSecondTitleOpen53: {
    ru: "Посмотрим, удержится ли идея",
    en: "Let's see if the idea holds",
    es: "Vamos a ver si la idea se mantiene",
    pt: "Vamos ver se a ideia se confirma",
    de: "Mal sehen, ob die Idee hält",
    fr: "Voyons si l’idée tient",
  },
  inviteHookSecondTitleOpen54: {
    ru: "Чистый график, спокойный вход",
    en: "Clean chart, calm entry",
    es: "Gráfico limpio, entrada tranquila",
    pt: "Gráfico limpo, entrada calma",
    de: "Sauberer Chart, ruhiger Einstieg",
    fr: "Graphique clair, entrée tranquille",
  },
  inviteHookSecondTitleOpen55: {
    ru: "Скоро рынок всё покажет",
    en: "Market will show soon",
    es: "Pronto el mercado mostrará todo",
    pt: "Logo o mercado mostra o resultado",
    de: "Der Markt zeigt es bald",
    fr: "Le marché montrera bientôt",
  },
  inviteHookSecondTitleOpen56: {
    ru: "Уже трекаю, позиция активна",
    en: "Tracking now, position active",
    es: "Seguimiento activo, posición viva",
    pt: "Acompanhando agora, posição ativa",
    de: "Jetzt am Verfolgen, Position aktiv",
    fr: "Suivi en cours, position active",
  },
  inviteHookSecondTitleOpen57: {
    ru: "Дальше терплю",
    en: "Patience from here",
    es: "Paciencia a partir de ahora",
    pt: "Paciência a partir de agora",
    de: "Geduld ab jetzt",
    fr: "Patience à partir de maintenant",
  },
  inviteHookSecondTitleOpen58: {
    ru: "Вход оформлен, эмоции убраны",
    en: "Entry done, emotions parked",
    es: "Entrada lista, emociones fuera",
    pt: "Entrada feita, emoções controladas",
    de: "Einstieg abgeschlossen, Emotionen ruhig",
    fr: "Entrée faite, émotions calmes",
  },
  inviteHookSecondTitleOpen59: {
    ru: "Спокойная сделка, чёткое чтение",
    en: "Calm trade, solid read",
    es: "Operación tranquila, lectura clara",
    pt: "Trade calmo, leitura clara",
    de: "Ruhiger Trade, klare Analyse",
    fr: "Trade calme, lecture claire",
  },
  inviteHookSecondTitleOpen60: {
    ru: "Ровный ход, чистая голова",
    en: "Fresh move, steady mindset",
    es: "Movimiento nuevo, mente estable",
    pt: "Movimento novo, mente estável",
    de: "Neue Bewegung, stabiler Fokus",
    fr: "Nouveau move, mental stable",
  },
  inviteHookSecondTitleOpen61: {
    ru: "Рутинное исполнение",
    en: "Routine execution",
    es: "Ejecución de rutina",
    pt: "Execução de rotina",
    de: "Routine-Trade",
    fr: "Exécution de routine",
  },
  inviteHookSecondTitleOpen62: {
    ru: "Зашёл без колебаний",
    en: "Entered without hesitation",
    es: "Entré sin dudar",
    pt: "Entrei sem hesitar",
    de: "Ohne Zögern eingestiegen",
    fr: "Entré sans hésitation",
  },
  inviteHookSecondTitleOpen63: {
    ru: "Тестирую сетап",
    en: "Testing the setup",
    es: "Probando el setup",
    pt: "Testando o setup",
    de: "Setup wird getestet",
    fr: "Test du setup",
  },
  inviteHookSecondTitleOpen64: {
    ru: "Позиция в рынке, эмоции выключены",
    en: "Trade live, emotions off",
    es: "Operación activa, emociones apagadas",
    pt: "Trade ativo, emoções desligadas",
    de: "Trade aktiv, Emotionen aus",
    fr: "Trade actif, émotions à zéro",
  },
  inviteHookSecondTitleOpen65: {
    ru: "Спокойный ход, простой план",
    en: "Calm move, simple plan",
    es: "Movimiento tranquilo, plan claro",
    pt: "Movimento tranquilo, plano claro",
    de: "Ruhige Bewegung, klarer Plan",
    fr: "Mouvement calme, plan clair",
  },
  inviteHookSecondTitleOpen66: {
    ru: "Вошёл дисциплинированно",
    en: "Opened with discipline",
    es: "Entrada con disciplina",
    pt: "Entrada disciplinada",
    de: "Disziplinierter Einstieg",
    fr: "Entrée disciplinée",
  },
  inviteHookSecondTitleOpen67: {
    ru: "Риск определён, план на месте",
    en: "Risk defined, plan set",
    es: "Riesgo definido, plan listo",
    pt: "Risco definido, plano pronto",
    de: "Risiko definiert, Plan steht",
    fr: "Risque défini, plan en place",
  },
  inviteHookSecondTitleOpen68: {
    ru: "Вход завершён — возвращаюсь к работе",
    en: "Entry complete — back to work",
    es: "Entrada completa — de vuelta al trabajo",
    pt: "Entrada completa — de volta ao trabalho",
    de: "Einstieg komplett — zurück an die Arbeit",
    fr: "Entrée complète — retour au travail",
  },
  inviteHookSecondTitleOpen69: {
    ru: "Доверяю правилам",
    en: "Trusting the rules",
    es: "Confiando en las reglas",
    pt: "Confiando nas regras",
    de: "Den Regeln vertraut",
    fr: "Confiance dans les règles",
  },
  inviteHookSecondTitleOpen70: {
    ru: "Спокойный вход, чистое исполнение",
    en: "Calm entry, clean execution",
    es: "Entrada calmada, ejecución limpia",
    pt: "Entrada calma, execução limpa",
    de: "Ruhiger Einstieg, saubere Ausführung",
    fr: "Entrée calme, exécution propre",
  },
  inviteHookSecondTitleOpen71: {
    ru: "По одному шагу",
    en: "One move at a time",
    es: "Un paso a la vez",
    pt: "Um passo de cada vez",
    de: "Schritt für Schritt",
    fr: "Un pas à la fois",
  },
  inviteHookSecondTitleOpen72: {
    ru: "Сделка стартовала, эмоции ровные",
    en: "Trade started, emotions steady",
    es: "Operación iniciada, emociones estables",
    pt: "Trade iniciado, emoções estáveis",
    de: "Trade gestartet, Emotionen ruhig",
    fr: "Trade lancé, émotions stables",
  },
  inviteHookSecondTitleOpen73: {
    ru: "Следую процессу",
    en: "Following the process",
    es: "Siguiendo el proceso",
    pt: "Seguindo o processo",
    de: "Dem Prozess folgen",
    fr: "Suivant le processus",
  },
  inviteHookSecondTitleOpen74: {
    ru: "Позиция активна, голова холодная",
    en: "Position live, calm mind",
    es: "Posición viva, mente fría",
    pt: "Posição ativa, mente fria",
    de: "Position aktiv, klarer Kopf",
    fr: "Position active, esprit clair",
  },
  inviteHookSecondTitleOpen75: {
    ru: "Без спешки и без страха",
    en: "No rush, no fear",
    es: "Sin prisa, sin miedo",
    pt: "Sem pressa, sem medo",
    de: "Keine Eile, keine Angst",
    fr: "Pas de stress, pas de peur",
  },
  inviteHookSecondTitleOpen76: {
    ru: "Сетап понятный, сделка активна",
    en: "Setup clear, trade active",
    es: "Setup claro, operación activa",
    pt: "Setup claro, operação viva",
    de: "Klares Setup, Trade aktiv",
    fr: "Setup clair, trade actif",
  },
  inviteHookSecondTitleOpen77: {
    ru: "Терпение включено",
    en: "Patience on",
    es: "Paciencia activada",
    pt: "Paciência ativada",
    de: "Geduld an",
    fr: "Patience enclenchée",
  },
  inviteHookSecondTitleOpen78: {
    ru: "Сделка в рынке, эмоции тихие",
    en: "Trade live, emotions quiet",
    es: "Operación viva, emociones bajo control",
    pt: "Trade ativo, emoções sob controle",
    de: "Trade aktiv, Emotionen ruhig",
    fr: "Trade en cours, émotions calmes",
  },
  inviteHookSecondTitleOpen79: {
    ru: "Сначала дисциплина, результат потом",
    en: "Discipline first, result later",
    es: "Primero disciplina, luego resultado",
    pt: "Disciplina primeiro, resultado depois",
    de: "Disziplin zuerst, Ergebnis später",
    fr: "Discipline d’abord, résultat après",
  },
  inviteHookSecondTitleOpen80: {
    ru: "Спокойное исполнение, без шума",
    en: "Calm execution, no noise",
    es: "Ejecución tranquila, sin ruido",
    pt: "Execução calma, sem barulho",
    de: "Ruhige Ausführung, kein Lärm",
    fr: "Exécution calme, sans bruit",
  },
  inviteHookSecondTitleOpen81: {
    ru: "Без дрожи в руках, с холодной головой",
    en: "Steady hands, clear mind",
    es: "Manos firmes y mente fría",
    pt: "Mãos firmes e mente fria",
    de: "Feste Hand und kühler Kopf",
    fr: "Mains sûres et esprit calme",
  },
  inviteHookSecondTitleOpen82: {
    ru: "Вход выполнен, терпение включается",
    en: "Entry done, patience begins",
    es: "Entrada lista, empieza la paciencia",
    pt: "Entrada feita, paciência começa",
    de: "Einstieg gemacht, Geduld beginnt",
    fr: "Entrée faite, patience commence",
  },
  inviteHookSecondTitleOpen83: {
    ru: "Сделка уже в работе",
    en: "Trade live now",
    es: "Operación activa",
    pt: "Trade ativo agora",
    de: "Trade jetzt aktiv",
    fr: "Trade actif maintenant",
  },
  inviteHookSecondTitleOpen84: {
    ru: "Без хайпа и суеты — просто трейдинг",
    en: "No hype, no rush — just trading",
    es: "Sin hype ni prisa — solo trading",
    pt: "Sem hype, sem pressa — só trading",
    de: "Kein Hype, keine Eile — nur Trading",
    fr: "Pas de hype, pas de stress — juste du trading",
  },
  inviteHookSecondTitleOpen85: {
    ru: "Время покажет",
    en: "Time will tell",
    es: "El tiempo lo dirá",
    pt: "O tempo vai dizer",
    de: "Die Zeit wird zeigen",
    fr: "Le temps parlera",
  },
  inviteHookSecondTitleOpen86: {
    ru: "Позиция открыта, режим спокойствия",
    en: "Position initiated, calm mode",
    es: "Posición abierta, modo tranquilo",
    pt: "Posição aberta, modo tranquilo",
    de: "Position offen, ruhig und fokussiert",
    fr: "Position ouverte, calme et concentré",
  },
  inviteHookSecondTitleOpen87: {
    ru: "Теперь ждём",
    en: "Now we wait",
    es: "Ahora esperamos",
    pt: "Agora é esperar",
    de: "Jetzt heißt es warten",
    fr: "Maintenant on attend",
  },
  inviteHookSecondTitleOpen88: {
    ru: "Вход подтверждён, план активен",
    en: "Entry confirmed, plan active",
    es: "Entrada confirmada, plan activo",
    pt: "Entrada confirmada, plano em andamento",
    de: "Einstieg bestätigt, Plan läuft",
    fr: "Entrée confirmée, plan actif",
  },
  inviteHookSecondTitleOpen89: {
    ru: "Сначала дисциплина, результат позже",
    en: "Discipline first, outcome later",
    es: "Primero disciplina, luego resultado",
    pt: "Disciplina primeiro, resultado depois",
    de: "Disziplin zuerst, Ergebnis später",
    fr: "Discipline d’abord, résultat ensuite",
  },
  inviteHookSecondTitleOpen90: {
    ru: "Вход оформлен, продолжаю трекинг",
    en: "Entry done, tracking continues",
    es: "Entrada hecha, siguiendo el plan",
    pt: "Entrada feita, acompanhando o plano",
    de: "Einstieg erledigt, Trade läuft weiter",
    fr: "Entrée faite, suivi en cours",
  },
  inviteHookSecondTitleOpen91: {
    ru: "Спокойная уверенность",
    en: "Quiet confidence",
    es: "Confianza tranquila",
    pt: "Confiança tranquila",
    de: "Ruhiges Vertrauen",
    fr: "Confiance tranquille",
  },
  inviteHookSecondTitleOpen92: {
    ru: "Позиция в рынке, терпение требуется",
    en: "Trade live, patience required",
    es: "Operación viva, requiere paciencia",
    pt: "Trade ativo, requer paciência",
    de: "Trade aktiv, Geduld erforderlich",
    fr: "Trade actif, patience requise",
  },
  inviteHookSecondTitleOpen93: {
    ru: "Спокойный старт, фокус на плане",
    en: "Calm start, focused plan",
    es: "Inicio calmado, foco en el plan",
    pt: "Começo calmo, foco no plano",
    de: "Ruhiger Start, klarer Fokus",
    fr: "Début calme, plan clair",
  },
  inviteHookSecondTitleOpen94: {
    ru: "Открыл осознанно, без натяжки",
    en: "Opened mindfully, nothing forced",
    es: "Entrada consciente, sin forzar",
    pt: "Entrada consciente, sem forçar",
    de: "Bewusster Einstieg, nichts erzwungen",
    fr: "Entrée réfléchie, rien de forcé",
  },
  inviteHookSecondTitleOpen95: {
    ru: "Простой ход, правила ясны",
    en: "Simple move, clear rules",
    es: "Movimiento simple, reglas claras",
    pt: "Movimento simples, regras claras",
    de: "Einfache Bewegung, klare Regeln",
    fr: "Mouvement simple, règles claires",
  },
  inviteHookSecondTitleOpen96: {
    ru: "Сделка в работе, план в движении",
    en: "Trade live, plan in motion",
    es: "Operación activa, plan en marcha",
    pt: "Trade ativo, plano em ação",
    de: "Trade aktiv, Plan in Aktion",
    fr: "Trade en cours, plan en action",
  },
  inviteHookSecondTitleOpen97: {
    ru: "Спокойно, точно, сосредоточено",
    en: "Calm, precise, focused",
    es: "Tranquilo, preciso, enfocado",
    pt: "Calmo, preciso e focado",
    de: "Ruhig, präzise, fokussiert",
    fr: "Calme, précis, concentré",
  },
  inviteHookSecondTitleOpen98: {
    ru: "Сделка идёт, голова чистая",
    en: "Trade on, mind clear",
    es: "Operación sigue, mente clara",
    pt: "Trade rolando, mente limpa",
    de: "Trade läuft, klarer Kopf",
    fr: "Trade en cours, esprit clair",
  },
  inviteHookSecondTitleOpen99: {
    ru: "Дальше рынок сделает своё",
    en: "Market will do the rest",
    es: "El mercado hará el resto",
    pt: "O mercado faz o resto",
    de: "Der Markt macht den Rest",
    fr: "Le marché fera le reste",
  },
  inviteHookSecondTitleOpen100: {
    ru: "Вход завершён, начинаю отслеживать",
    en: "Entry complete, tracking begins",
    es: "Entrada completa, seguimiento iniciado",
    pt: "Entrada completa, acompanhamento iniciado",
    de: "Einstieg komplett, Beobachtung läuft",
    fr: "Entrée complète, suivi en route",
  },
  inviteHookSecondTitleOpen101: {
    ru: "Посмотрим, отработает ли",
    en: "Let’s see if it plays out",
    es: "Veamos si funciona",
    pt: "Vamos ver se funciona",
    de: "Mal sehen, ob’s läuft",
    fr: "On va voir si ça bouge",
  },
  inviteHookSecondTitleOpen102: {
    ru: "Интересно",
    en: "Interesting",
    es: "Interesante",
    pt: "Interessante",
    de: "Interessant",
    fr: "Intéressant",
  },
  inviteHookSecondTitleOpen103: {
    ru: "Я в позиции, жду, как поведёт себя рынок",
    en: "I’m in the position, watching how the market moves",
    es: "Estoy en posición, viendo cómo se mueve el mercado",
    pt: "Estou na posição, observando como o mercado se move",
    de: "Bin in der Position und beobachte, wie sich der Markt bewegt",
    fr: "En position, j’observe comment le marché réagit",
  },
  inviteHookSecondTitleOpen104: {
    ru: "Теперь вопрос — где будет импульс",
    en: "Now the question is where the impulse shows up",
    es: "Ahora la pregunta es dónde vendrá el impulso",
    pt: "Agora a dúvida é onde virá o impulso",
    de: "Jetzt die Frage: Wo kommt der Impuls?",
    fr: "Maintenant la question, c’est où viendra l’impulsion",
  },
  inviteHookSecondTitleOpen105: {
    ru: "Всё выглядит готовым, но проверим",
    en: "Everything looks ready, but we’ll see",
    es: "Todo parece listo, pero veremos",
    pt: "Tudo parece pronto, mas vamos conferir",
    de: "Alles sieht bereit aus, aber wir werden sehen",
    fr: "Tout semble prêt, mais on verra bien",
  },
  inviteHookSecondTitleOpen106: {
    ru: "Осталось дождаться реакции",
    en: "Just waiting for the reaction",
    es: "Solo queda esperar la reacción",
    pt: "Só falta esperar a reação",
    de: "Jetzt heißt’s auf die Reaktion warten",
    fr: "Il ne reste plus qu’à attendre la réaction",
  },
  inviteHookSecondTitleOpen107: {
    ru: "Увидим, что покажет",
    en: "Let’s see what it does",
    es: "Veremos qué muestra",
    pt: "Vamos ver o que acontece",
    de: "Mal sehen, was passiert",
    fr: "On va voir ce que ça donne",
  },
  inviteHookSecondTitleOpen108: {
    ru: "Пока только начало истории",
    en: "Just the start of the story",
    es: "Apenas comienza la historia",
    pt: "Apenas o começo da história",
    de: "Erst der Anfang der Geschichte",
    fr: "Juste le début de l’histoire",
  },
  inviteHookSecondTitleOpen109: {
    ru: "Время покажет, насколько сетап точный",
    en: "Time will tell how clean the setup is",
    es: "El tiempo dirá qué tan preciso fue el setup",
    pt: "O tempo dirá quão preciso foi o setup",
    de: "Die Zeit wird zeigen, wie sauber das Setup war",
    fr: "Le temps dira à quel point le setup est propre",
  },
  inviteHookSecondTitleOpen110: {
    ru: "Наблюдаю, чем всё закончится",
    en: "Watching how it plays out",
    es: "Observando cómo termina todo",
    pt: "Acompanhando para ver como termina",
    de: "Beobachte, wie sich alles entwickelt",
    fr: "J’observe comment ça va se terminer",
  },
  inviteHookSecondTitleOpen111: {
    ru: "Скоро станет ясно, стоил ли вход ожидания",
    en: "Soon it’ll be clear if the entry was worth the wait",
    es: "Pronto se sabrá si la entrada valió la espera",
    pt: "Em breve ficará claro se a entrada valeu a pena",
    de: "Bald wird klar, ob sich der Einstieg gelohnt hat",
    fr: "Bientôt on saura si l’entrée valait l’attente",
  },
  inviteHookSecondTitleOpen112: {
    ru: "Посмотрим, принесёт ли терпение результат",
    en: "Let’s see if patience pays off",
    es: "Veamos si la paciencia da frutos",
    pt: "Vamos ver se a paciência compensa",
    de: "Schauen wir, ob sich Geduld auszahlt",
    fr: "Voyons si la patience paie",
  },
  inviteHookSecondTitleOpen113: {
    ru: "Через пару дней узнаем",
    en: "We’ll find out in a couple of days",
    es: "En unos días lo sabremos",
    pt: "Em alguns dias saberemos",
    de: "In ein paar Tagen wissen wir mehr",
    fr: "On saura dans quelques jours",
  },
  inviteHookSecondTitleOpen114: {
    ru: "Если всё пойдёт по плану — будет красиво",
    en: "If it all goes as planned — it’ll look good",
    es: "Si todo sale como está planeado — se verá bien",
    pt: "Se tudo correr como planejado — vai ficar bonito",
    de: "Wenn alles nach Plan läuft — wird’s gut aussehen",
    fr: "Si tout se passe comme prévu — ce sera beau",
  },
  inviteHookSecondTitleOpen115: {
    ru: "Скоро рынок сам всё подтвердит",
    en: "The market will confirm it soon",
    es: "El mercado lo confirmará pronto",
    pt: "O mercado logo vai confirmar",
    de: "Der Markt wird’s bald bestätigen",
    fr: "Le marché le confirmera bientôt",
  },
  inviteHookSecondTitleOpen116: {
    ru: "Проверим, как быстро сработает идея",
    en: "Let’s see how fast the idea plays out",
    es: "Veremos qué tan rápido se desarrolla la idea",
    pt: "Vamos ver quão rápido a ideia se desenrola",
    de: "Mal sehen, wie schnell sich die Idee entwickelt",
    fr: "Voyons à quelle vitesse l’idée se met en place",
  },
  inviteHookSecondTitleOpen117: {
    ru: "Через время увидим, насколько чист вход",
    en: "With time, we’ll see how clean the entry was",
    es: "Con el tiempo veremos qué tan limpia fue la entrada",
    pt: "Com o tempo veremos quão limpa foi a entrada",
    de: "Mit der Zeit werden wir sehen, wie sauber der Einstieg war",
    fr: "Avec le temps, on verra si l’entrée était propre",
  },
  inviteHookSecondTitleOpen118: {
    ru: "Возможно, это начало нового движения",
    en: "Maybe this is the start of a new move",
    es: "Tal vez este sea el inicio de un nuevo movimiento",
    pt: "Talvez seja o início de um novo movimento",
    de: "Vielleicht der Beginn einer neuen Bewegung",
    fr: "Peut-être le début d’un nouveau mouvement",
  },
  inviteHookSecondTitleOpen119: {
    ru: "Осталось дождаться подтверждения",
    en: "Just waiting for confirmation",
    es: "Solo espero confirmación",
    pt: "Só falta a confirmação",
    de: "Warte nur noch auf Bestätigung",
    fr: "J’attends juste la confirmation",
  },
  inviteHookSecondTitleOpen120: {
    ru: "Скоро увидим, что рынок придумает",
    en: "Soon we’ll see what the market’s got in mind",
    es: "Pronto veremos qué planea el mercado",
    pt: "Em breve veremos o que o mercado pretende",
    de: "Bald sehen wir, was der Markt vorhat",
    fr: "On verra bientôt ce que le marché prépare",
  },
  inviteHookSecondTitleOpen121: {
    ru: "График дышит спокойно, пока без резких движений",
    en: "The chart’s breathing calmly, no sharp moves yet",
    es: "El gráfico respira tranquilo, sin movimientos bruscos por ahora",
    pt: "O gráfico respira calmo, sem movimentos bruscos por enquanto",
    de: "Der Chart atmet ruhig, noch keine starken Bewegungen",
    fr: "Le graphique respire calmement, pas de mouvements brusques pour l’instant",
  },
  inviteHookSecondTitleOpen122: {
    ru: "Чувствуется давление",
    en: "Feeling some pressure",
    es: "Se siente la presión",
    pt: "Dá pra sentir a pressão",
    de: "Der Druck ist spürbar",
    fr: "On sent la pression",
  },
  inviteHookSecondTitleOpen123: {
    ru: "Картина выглядит чисто и уверенно",
    en: "Looks clean, looks confident",
    es: "El panorama se ve limpio y firme",
    pt: "O cenário parece limpo e confiante",
    de: "Das Bild wirkt klar und stabil",
    fr: "Le setup est clair et solide",
  },
  inviteHookSecondTitleOpen124: {
    ru: "Ждем",
    en: "Waiting",
    es: "Esperando",
    pt: "Aguardando",
    de: "Warten",
    fr: "On attend",
  },
  inviteHookSecondTitleOpen125: {
    ru: "Спокойно наблюдаю",
    en: "Calmly watching",
    es: "Observando con calma",
    pt: "Observando com calma",
    de: "Beobachte ruhig",
    fr: "J’observe calmement",
  },
  inviteHookSecondTitleOpen126: {
    ru: "Свечи выглядят живыми, динамика приятная",
    en: "Candles look alive, momentum’s decent",
    es: "Las velas se ven vivas, el ritmo agradable",
    pt: "Os candles parecem vivos, o ritmo é bom",
    de: "Die Kerzen leben, Dynamik passt",
    fr: "Les bougies sont vivantes, le rythme agréable",
  },
  inviteHookSecondTitleOpen127: {
    ru: "Фон спокойный, но энергия растёт",
    en: "The backdrop’s calm, but energy’s building",
    es: "El ambiente es tranquilo, pero la energía crece",
    pt: "O ambiente é calmo, mas a energia está crescendo",
    de: "Markt ruhig, aber Energie steigt",
    fr: "L’ambiance est calme, mais l’énergie monte",
  },
  inviteHookSecondTitleOpen128: {
    ru: "Всё ощущается сбалансированно",
    en: "Everything feels balanced",
    es: "Todo se siente equilibrado",
    pt: "Tudo parece equilibrado",
    de: "Alles wirkt ausgeglichen",
    fr: "Tout semble équilibré",
  },
  inviteHookSecondTitleOpen129: {
    ru: "Рынок собрался в пружину. Ждем",
    en: "The market’s coiled up like a spring. Waiting",
    es: "El mercado está comprimido como un resorte. Esperando",
    pt: "O mercado está comprimido como uma mola. Aguardando",
    de: "Der Markt spannt sich wie eine Feder. Warten",
    fr: "Le marché est tendu comme un ressort. On attend",
  },
  inviteHookSecondTitleOpen130: {
    ru: "Атмосфера перед движением чувствуется явно",
    en: "The atmosphere before the move feels clear",
    es: "La atmósfera antes del movimiento se siente claramente",
    pt: "A atmosfera antes do movimento é claramente perceptível",
    de: "Die Atmosphäre vor der Bewegung ist deutlich spürbar",
    fr: "L’atmosphère avant le mouvement est clairement perceptible",
  },
  inviteHookSecondTitleOpen131: {
    ru: "Сетап сильный, тайминг под вопросом",
    en: "Strong setup, timing’s uncertain",
    es: "Buen setup, pero el timing es incierto",
    pt: "Setup forte, tempo incerto",
    de: "Starkes Setup, Timing unklar",
    fr: "Setup fort, timing incertain",
  },
  inviteHookSecondTitleOpen132: {
    ru: "Всё выглядит уверенно, хотя рынок нервный",
    en: "Confident look, even in a nervous market",
    es: "Se ve firme, aunque el mercado está nervioso",
    pt: "Tudo parece firme, mesmo com o mercado nervoso",
    de: "Sieht solide aus, Markt bleibt nervös",
    fr: "Solide, même si le marché reste nerveux",
  },
  inviteHookSecondTitleOpen133: {
    ru: "Есть сигнал, но пока без импульса",
    en: "Got the signal, no impulse yet",
    es: "Hay señal, pero sin impulso todavía",
    pt: "Há sinal, mas ainda sem impulso",
    de: "Signal da, aber noch kein Impuls",
    fr: "Signal présent, mais pas encore d’impulsion",
  },
  inviteHookSecondTitleOpen134: {
    ru: "Отличная структура — посмотрим, даст ли продолжение",
    en: "Great structure — let’s see if it follows through",
    es: "Buena estructura — veremos si continúa",
    pt: "Boa estrutura — vamos ver se continua",
    de: "Gute Struktur — mal sehen, ob’s weiterläuft",
    fr: "Bonne structure — on verra si ça continue",
  },
  inviteHookSecondTitleOpen135: {
    ru: "Потенциал высокий, но нужно терпение",
    en: "Big potential, patience required",
    es: "Gran potencial, pero se necesita paciencia",
    pt: "Grande potencial, mas é preciso paciência",
    de: "Großes Potenzial, aber Geduld gefragt",
    fr: "Gros potentiel, mais il faut de la patience",
  },
  inviteHookSecondTitleOpen136: {
    ru: "Паттерн читается чётко, а поведение рынка — не так",
    en: "The pattern’s clear, the market’s not",
    es: "El patrón es claro, el mercado no tanto",
    pt: "O padrão é claro, o mercado nem tanto",
    de: "Muster klar, Markt weniger",
    fr: "Le pattern est clair, le marché un peu moins",
  },
  inviteHookSecondTitleOpen137: {
    ru: "Основание надёжное, движение — пока нет",
    en: "Solid base, but no move yet",
    es: "Base sólida, pero sin movimiento aún",
    pt: "Base sólida, mas ainda sem movimento",
    de: "Fundament solide, Bewegung fehlt noch",
    fr: "Base solide, mais pas encore de mouvement",
  },
  inviteHookSecondTitleOpen138: {
    ru: "Всё готово, но рынок молчит",
    en: "Everything’s set, market’s quiet",
    es: "Todo listo, pero el mercado está callado",
    pt: "Tudo pronto, mas o mercado está quieto",
    de: "Alles bereit, Markt bleibt still",
    fr: "Tout est prêt, mais le marché reste silencieux",
  },
  inviteHookSecondTitleOpen139: {
    ru: "Формально вход есть, фактически — ожидание",
    en: "Technically entered, practically waiting",
    es: "Entrada formal, práctica espera",
    pt: "Entrada formal, agora é esperar",
    de: "Formaler Einstieg, praktisch warten",
    fr: "Entrée formelle, maintenant on attend",
  },
  inviteHookSecondTitleOpen140: {
    ru: "Баланс между риском и возможностью",
    en: "Balance between risk and opportunity",
    es: "Equilibrio entre riesgo y oportunidad",
    pt: "Equilíbrio entre risco e oportunidade",
    de: "Balance zwischen Risiko und Chance",
    fr: "Équilibre entre risque et opportunité",
  },
  inviteHookSecondTitleOpen141: {
    ru: "Всё по плану, без суеты",
    en: "All according to plan, no rush",
    es: "Todo según el plan, sin prisa",
    pt: "Tudo conforme o plano, sem pressa",
    de: "Alles nach Plan, ohne Hektik",
    fr: "Tout selon le plan, sans précipitation",
  },
  inviteHookSecondTitleOpen142: {
    ru: "Сделал своё — теперь пусть говорит рынок",
    en: "Did my part — now the market decides",
    es: "Hice mi parte — ahora que hable el mercado",
    pt: "Fiz minha parte — agora é com o mercado",
    de: "Mein Teil getan — jetzt spricht der Markt",
    fr: "J’ai fait ma part — maintenant au marché de parler",
  },
  inviteHookSecondTitleOpen143: {
    ru: "Просто шаг по системе, не больше",
    en: "Just another system step, nothing more",
    es: "Solo otro paso del sistema, nada más",
    pt: "Só mais um passo dentro do sistema",
    de: "Nur ein weiterer Schritt im System",
    fr: "Juste une étape de plus dans le système",
  },
  inviteHookSecondTitleOpen144: {
    ru: "Рынок сам покажет, что делать дальше",
    en: "The market will show what’s next",
    es: "El mercado mostrará qué sigue",
    pt: "O mercado vai mostrar o próximo passo",
    de: "Der Markt wird zeigen, was kommt",
    fr: "Le marché montrera la suite",
  },
  inviteHookSecondTitleOpen145: {
    ru: "Простой сетап. Всё спокойно, контроль сохранён",
    en: "Simple setup. Calm and under control",
    es: "Setup sencillo. Todo tranquilo y bajo control",
    pt: "Setup simples. Tudo calmo e sob controle",
    de: "Einfaches Setup. Ruhig und unter Kontrolle",
    fr: "Setup simple. Calme et sous contrôle",
  },
  inviteHookSecondTitleOpen146: {
    ru: "Не спешу — ситуация под наблюдением",
    en: "No rush — keeping it under watch",
    es: "Sin prisa — observando la situación",
    pt: "Sem pressa — apenas acompanhando",
    de: "Keine Eile — Situation im Blick",
    fr: "Pas de hâte — j’observe la situation",
  },
  inviteHookSecondTitleOpen147: {
    ru: "Терпение — часть стратегии",
    en: "Patience’s part of the strategy",
    es: "La paciencia es parte de la estrategia",
    pt: "A paciência faz parte da estratégia",
    de: "Geduld ist Teil der Strategie",
    fr: "La patience fait partie de la stratégie",
  },
  inviteHookSecondTitleOpen148: {
    ru: "Всё под управлением — без эмоций",
    en: "Everything under control — no emotions",
    es: "Todo bajo control — sin emociones",
    pt: "Tudo sob controle — sem emoções",
    de: "Alles im Griff — keine Emotionen",
    fr: "Tout est sous contrôle — sans émotions",
  },
  inviteHookSecondTitleOpen149: {
    ru: "Вошёл осознанно, без лишних движений",
    en: "Entered intentionally, no extra moves",
    es: "Entrada consciente, sin movimientos extra",
    pt: "Entrada consciente, sem movimentos extras",
    de: "Bewusster Einstieg, keine Extras",
    fr: "Entrée réfléchie, sans gestes inutiles",
  },
  inviteHookSecondTitleOpen150: {
    ru: "План действует, как и задумано",
    en: "Plan’s in motion, just as intended",
    es: "El plan en marcha, como estaba previsto",
    pt: "Plano em ação, como foi planejado",
    de: "Plan läuft wie vorgesehen",
    fr: "Le plan se déroule comme prévu",
  },
  inviteHookSecondTitleOpen151: {
    ru: "Уважит ли рынок",
    en: "Let’s see if the market respects it",
    es: "Veremos si el mercado lo respeta",
    pt: "Vamos ver se o mercado respeita",
    de: "Mal sehen, ob der Markt’s respektiert",
    fr: "On verra si le marché respecte",
  },
  inviteHookSecondTitleOpen152: {
    ru: "Пойдет ли движение сразу или ждать",
    en: "Will the move kick in right away or take time?",
    es: "¿El movimiento empezará enseguida o tomará tiempo?",
    pt: "O movimento vai começar já ou vai demorar?",
    de: "Startet die Bewegung sofort oder später?",
    fr: "Le mouvement commence tout de suite ou il faudra attendre?",
  },
  inviteHookSecondTitleOpen153: {
    ru: "Быки или медведи, кто продавит?",
    en: "Bulls or bears — who’s taking the lead?",
    es: "¿Toros o osos — quién dominará?",
    pt: "Touros ou ursos — quem leva a melhor?",
    de: "Bullen oder Bären — wer setzt sich durch?",
    fr: "Taureaux ou ours — qui prendra le dessus?",
  },
  inviteHookSecondTitleOpen154: {
    ru: "Это начало или просто пауза?",
    en: "Is this the start or just a pause?",
    es: "¿Es el inicio o solo una pausa?",
    pt: "É o começo ou apenas uma pausa?",
    de: "Anfang oder nur Pause?",
    fr: "Début ou simple pause?",
  },
  inviteHookSecondTitleOpen155: {
    ru: "Кто окажется сильнее — быки или медведи?",
    en: "Who’s stronger — bulls or bears?",
    es: "¿Quién es más fuerte — toros o osos?",
    pt: "Quem é mais forte — touros ou ursos?",
    de: "Wer ist stärker — Bullen oder Bären?",
    fr: "Qui est le plus fort — taureaux ou ours?",
  },
  inviteHookSecondTitleOpen156: {
    ru: "Не рано ли я зашёл?",
    en: "Maybe entered a bit early?",
    es: "¿Quizás entré un poco antes?",
    pt: "Será que entrei um pouco cedo?",
    de: "Vielleicht etwas früh eingestiegen?",
    fr: "Suis-je entré un peu trop tôt?",
  },
  inviteHookSecondTitleOpen157: {
    ru: "Повторится ли предыдущий сценарий?",
    en: "Will the previous scenario repeat?",
    es: "¿Se repetirá el escenario anterior?",
    pt: "Será que o cenário anterior vai se repetir?",
    de: "Wiederholt sich das letzte Szenario?",
    fr: "Le scénario précédent va-t-il se répéter?",
  },
  inviteHookSecondTitleOpen158: {
    ru: "Вход оформлен. Покажет ли рынок характер?",
    en: "Entry’s done. Let’s see if the market shows some character",
    es: "Entrada lista. Veremos si el mercado muestra carácter",
    pt: "Entrada feita. Vamos ver se o mercado mostra personalidade",
    de: "Einstieg gemacht. Zeigt der Markt Charakter?",
    fr: "Entrée faite. On verra si le marché montre du caractère",
  },
  inviteHookSecondTitleOpen159: {
    ru: "Это просто шум или сигнал?",
    en: "Noise or signal?",
    es: "¿Ruido o señal?",
    pt: "Ruído ou sinal?",
    de: "Rauschen oder Signal?",
    fr: "Bruit ou signal?",
  },
  inviteHookSecondTitleOpen160: {
    ru: "Буду ли я прав в этом входе?",
    en: "Will this one prove right?",
    es: "¿Será correcta esta vez?",
    pt: "Será que vai dar certo dessa vez?",
    de: "Wird dieser passen?",
    fr: "Ce coup-là sera-t-il le bon?",
  },
  inviteHookSecondTitleOpen161: {
    ru: "По системе: вход, теперь терпение",
    en: "By the system: entry, now patience",
    es: "Según el sistema: entrada, ahora paciencia",
    pt: "Pelo sistema: entrada, agora paciência",
    de: "Nach System: Einstieg, jetzt Geduld",
    fr: "Selon le système: entrée, maintenant patience",
  },
  inviteHookSecondTitleOpen162: {
    ru: "Зашёл. Как всегда — спокойно и без спешки",
    en: "Entered. As always — calm and steady",
    es: "Entré. Como siempre — tranquilo y sin apuro",
    pt: "Entrei. Como sempre — calmo e sem pressa",
    de: "Eingestiegen. Wie immer — ruhig und ohne Eile",
    fr: "Entré. Comme toujours — calme et sans précipitation",
  },
  inviteHookSecondTitleOpen163: {
    ru: "Всё по правилам: план в работе",
    en: "All by the rules — plan in motion",
    es: "Todo según las reglas — plan en marcha",
    pt: "Tudo conforme as regras — plano em execução",
    de: "Alles nach den Regeln — Plan läuft",
    fr: "Tout selon les règles — plan en action",
  },
  inviteHookSecondTitleOpen164: {
    ru: "Терпение — неотъемлемая часть процесса",
    en: "Patience’s part of the process",
    es: "La paciencia es parte del proceso",
    pt: "A paciência faz parte do processo",
    de: "Geduld ist Teil des Prozesses",
    fr: "La patience fait partie du processus",
  },
  inviteHookSecondTitleOpen165: {
    ru: "Спокойный вход. Сценарий стандартный, никаких эмоций",
    en: "Smooth entry. Standard scenario, no emotions",
    es: "Entrada suave. Escenario estándar, sin emociones",
    pt: "Entrada suave. Cenário padrão, sem emoções",
    de: "Ruhiger Einstieg. Standard-Szenario, keine Emotionen",
    fr: "Entrée fluide. Scénario classique, aucune émotion",
  },
  inviteHookSecondTitleOpen166: {
    ru: "Дисциплина выше импульсов",
    en: "Discipline over impulse",
    es: "Disciplina sobre impulso",
    pt: "Disciplina acima do impulso",
    de: "Disziplin über Impuls",
    fr: "Discipline avant impulsion",
  },
  inviteHookSecondTitleOpen167: {
    ru: "Сначала план, потом движение",
    en: "First the plan, then the move",
    es: "Primero el plan, luego el movimiento",
    pt: "Primeiro o plano, depois o movimento",
    de: "Erst Plan, dann Bewegung",
    fr: "D’abord le plan, ensuite le mouvement",
  },
  inviteHookSecondTitleOpen168: {
    ru: "Вход завершён — действую по шаблону, не по чувствам",
    en: "Entry’s in — following the system, not emotions",
    es: "Entrada lista — siguiendo el sistema, no las emociones",
    pt: "Entrada concluída — seguindo o sistema, não as emoções",
    de: "Einstieg abgeschlossen — nach System, nicht nach Gefühl",
    fr: "Entrée terminée — suivant le système, pas les émotions",
  },
  inviteHookSecondTitleOpen169: {
    ru: "Всё как должно быть — Без импровизаций",
    en: "All as it should be — No improvising",
    es: "Todo como debe ser — Sin improvisar",
    pt: "Tudo como deve ser — Sem improvisos",
    de: "Alles wie’s sein soll — Keine Improvisation",
    fr: "Tout comme il faut — Sans improvisation",
  },
  inviteHookSecondTitleOpen170: {
    ru: "Система проверена — просто выполняю",
    en: "System tested — just execution",
    es: "Sistema probado — solo ejecución",
    pt: "Sistema testado — só executar",
    de: "System getestet — einfach umsetzen",
    fr: "Système testé — juste exécuter",
  },
  inviteHookSecondTitleOpen171: {
    ru: "Такой сетап уже работал раньше",
    en: "This setup’s worked before",
    es: "Este setup ya funcionó antes",
    pt: "Esse setup já funcionou antes",
    de: "Dieses Setup hat schon früher funktioniert",
    fr: "Ce setup a déjà fonctionné auparavant",
  },
  inviteHookSecondTitleOpen172: {
    ru: "Этот паттерн не раз приносил результат",
    en: "This pattern’s proven itself before",
    es: "Este patrón ha funcionado antes",
    pt: "Esse padrão já deu resultado antes",
    de: "Dieses Muster hat schon oft funktioniert",
    fr: "Ce pattern a déjà porté ses fruits",
  },
  inviteHookSecondTitleOpen173: {
    ru: "Видел подобную структуру — чаще отрабатывает",
    en: "Seen this setup — usually works fine",
    es: "He visto este setup — normalmente funciona",
    pt: "Já vi esse setup — normalmente funciona bem",
    de: "Kenne dieses Setup — funktioniert meist gut",
    fr: "Vu ce setup — il marche souvent bien",
  },
  inviteHookSecondTitleOpen174: {
    ru: "Опыт подсказывает: всё идёт по знакомому сценарию",
    en: "Familiar pattern, experience agrees",
    es: "La experiencia dice que es un patrón familiar",
    pt: "A experiência mostra que é um padrão conhecido",
    de: "Erfahrung sagt: vertrautes Muster",
    fr: "L’expérience montre un schéma familier",
  },
  inviteHookSecondTitleOpen175: {
    ru: "В прошлый раз рынок реагировал так же",
    en: "Last time the market reacted the same way",
    es: "La última vez el mercado reaccionó igual",
    pt: "Da última vez o mercado reagiu do mesmo jeito",
    de: "Letztes Mal hat der Markt genauso reagiert",
    fr: "La dernière fois, le marché a réagi pareil",
  },
  inviteHookSecondTitleOpen176: {
    ru: "Это не первый такой вход",
    en: "Not my first time with this setup",
    es: "No es mi primera vez con este setup",
    pt: "Não é minha primeira vez com esse setup",
    de: "Nicht das erste Mal mit diesem Setup",
    fr: "Pas ma première fois avec ce setup",
  },
  inviteHookSecondTitleOpen177: {
    ru: "Повторяющаяся картина — люблю такие сетапы",
    en: "Familiar look — I like these setups",
    es: "Escenario conocido — me gustan estos setups",
    pt: "Cenário familiar — gosto desses setups",
    de: "Vertrautes Bild — mag solche Setups",
    fr: "Scénario familier — j’aime ces setups",
  },
  inviteHookSecondTitleOpen178: {
    ru: "Сделка в рынке. История повторяется чаще, чем кажется",
    en: "Trade in motion. History repeats more often than it seems",
    es: "Operación en curso. La historia se repite más de lo que parece",
    pt: "Operação em andamento. A história se repete mais do que parece",
    de: "Trade läuft. Geschichte wiederholt sich öfter, als man denkt",
    fr: "Trade en cours. L’histoire se répète plus souvent qu’on ne le pense",
  },
  inviteHookSecondTitleOpen179: {
    ru: "Уже видел, чем это заканчивается",
    en: "Seen this ending before",
    es: "Ya he visto cómo termina esto",
    pt: "Já vi esse final antes",
    de: "Hab das Ende schon gesehen",
    fr: "Déjà vu comment ça se termine",
  },
  inviteHookSecondTitleOpen180: {
    ru: "Вероятность на моей стороне — паттерн знакомый",
    en: "Odds in my favor — familiar setup",
    es: "Las probabilidades a mi favor — patrón conocido",
    pt: "Probabilidade a meu favor — padrão conhecido",
    de: "Wahrscheinlichkeiten auf meiner Seite — bekanntes Muster",
    fr: "Les probabilités sont avec moi — pattern familier",
  },
  inviteHookSecondTitleOpen181: {
    ru: "Лучше дождаться подтверждения, чем ловить шум",
    en: "Better to wait for confirmation than chase noise",
    es: "Mejor esperar confirmación que perseguir ruido",
    pt: "Melhor esperar confirmação do que correr atrás de ruído",
    de: "Lieber auf Bestätigung warten, als dem Rauschen hinterherlaufen",
    fr: "Mieux vaut attendre la confirmation que courir après le bruit",
  },
  inviteHookSecondTitleOpen182: {
    ru: "Не гонюсь за движением — держу качество",
    en: "No rush — quality first",
    es: "Sin apuro — calidad ante todo",
    pt: "Sem pressa — qualidade em primeiro lugar",
    de: "Keine Eile — Qualität zuerst",
    fr: "Pas de hâte — la qualité d’abord",
  },
  inviteHookSecondTitleOpen183: {
    ru: "Главное — не потерять ясность",
    en: "Clarity above all",
    es: "Claridad ante todo",
    pt: "Clareza acima de tudo",
    de: "Klarheit über alles",
    fr: "La clarté avant tout",
  },
  inviteHookSecondTitleOpen184: {
    ru: "Без суеты — лучше недозаработать, чем спешить",
    en: "No rush — better earn less than rush in",
    es: "Sin prisa — mejor ganar menos que apresurarse",
    pt: "Sem pressa — melhor ganhar menos do que se apressar",
    de: "Keine Eile — lieber weniger verdienen als hetzen",
    fr: "Pas de précipitation — mieux vaut gagner moins que se presser",
  },
  inviteHookSecondTitleOpen185: {
    ru: "Избегаю суеты, сохраняю позицию",
    en: "Avoiding noise, staying steady",
    es: "Evitando el ruido, manteniendo la calma",
    pt: "Evitando o ruído, mantendo a calma",
    de: "Meide Hektik, bleibe ruhig",
    fr: "J’évite le bruit, je garde mon calme",
  },
  inviteHookSecondTitleOpen186: {
    ru: "Осторожность важнее азарта",
    en: "Caution beats excitement",
    es: "La cautela vale más que la emoción",
    pt: "A cautela vale mais do que o entusiasmo",
    de: "Vorsicht ist mehr wert als Euphorie",
    fr: "La prudence vaut mieux que l’euphorie",
  },
  inviteHookSecondTitleOpen187: {
    ru: "Теперь ждём. Пропустить шум — часть стратегии",
    en: "Now we wait. Ignoring noise’s part of the plan",
    es: "Ahora esperamos. Ignorar el ruido es parte de la estrategia",
    pt: "Agora é esperar. Ignorar o ruído faz parte da estratégia",
    de: "Jetzt heißt’s warten. Rauschen zu ignorieren gehört zur Strategie",
    fr: "Maintenant on attend. Ignorer le bruit fait partie de la stratégie",
  },
  inviteHookSecondTitleOpen188: {
    ru: "Главное — не рисковать без причин",
    en: "Key’s not to risk without reason",
    es: "Lo importante es no arriesgar sin motivo",
    pt: "O importante é não arriscar sem motivo",
    de: "Wichtig: kein Risiko ohne Grund",
    fr: "L’essentiel est de ne pas risquer sans raison",
  },
  inviteHookSecondTitleOpen189: {
    ru: "Сначала дисциплина — лучше стабильно, чем случайно",
    en: "Discipline first — better consistent than lucky",
    es: "Primero disciplina — mejor constante que afortunado",
    pt: "Primeiro disciplina — melhor consistência que sorte",
    de: "Erst Disziplin — lieber konstant als zufällig",
    fr: "D’abord la discipline — mieux vaut la constance que la chance",
  },
  inviteHookSecondTitleOpen190: {
    ru: "Вход оформлен. Защищаю капитал, не самомнение",
    en: "Entry’s done. Protecting capital, not ego",
    es: "Entrada hecha. Protegiendo el capital, no el ego",
    pt: "Entrada feita. Protegendo o capital, não o ego",
    de: "Einstieg gemacht. Kapital schützen, nicht das Ego",
    fr: "Entrée faite. Protéger le capital, pas l’ego",
  },
  inviteHookSecondTitleOpen191: {
    ru: "Всё по ритуалу: вход — терпение — результат",
    en: "Routine: entry — patience — result",
    es: "Rutina: entrada — paciencia — resultado",
    pt: "Rotina: entrada — paciência — resultado",
    de: "Routine: Einstieg — Geduld — Ergebnis",
    fr: "Routine: entrée — patience — résultat",
  },
  inviteHookSecondTitleOpen192: {
    ru: "Начал как всегда — дальше наблюдение",
    en: "Started as usual — now observing",
    es: "Empecé como siempre — ahora a observar",
    pt: "Comecei como sempre — agora é observar",
    de: "Wie immer begonnen — jetzt beobachten",
    fr: "Commencé comme d’habitude — maintenant observation",
  },
  inviteHookSecondTitleOpen193: {
    ru: "Первый шаг сделан, теперь тишина",
    en: "First step’s done, now silence",
    es: "Primer paso hecho, ahora silencio",
    pt: "Primeiro passo feito, agora silêncio",
    de: "Erster Schritt getan, jetzt Ruhe",
    fr: "Première étape faite, maintenant silence",
  },
  inviteHookSecondTitleOpen194: {
    ru: "Обычный процесс: анализ — вход — ожидание",
    en: "Standard process: analysis — entry — wait",
    es: "Proceso normal: análisis — entrada — espera",
    pt: "Processo padrão: análise — entrada — espera",
    de: "Standardprozess: Analyse — Einstieg — Warten",
    fr: "Processus standard: analyse — entrée — attente",
  },
  inviteHookSecondTitleOpen195: {
    ru: "Ритуал повторяется, день за днём",
    en: "Routine repeats, day after day",
    es: "La rutina se repite, día tras día",
    pt: "A rotina se repete, dia após dia",
    de: "Routine wiederholt sich, Tag für Tag",
    fr: "La routine se répète, jour après jour",
  },
  inviteHookSecondTitleOpen196: {
    ru: "Сделка в работе. Всё в привычном ритме — без сюрпризов",
    en: "Trade in progress. Same rhythm — no surprises",
    es: "Operación en progreso. Todo en el ritmo habitual — sin sorpresas",
    pt: "Operação em andamento. Tudo no ritmo de sempre — sem surpresas",
    de: "Trade läuft. Alles im gewohnten Rhythmus — keine Überraschungen",
    fr: "Trade en cours. Tout dans le rythme habituel — sans surprises",
  },
  inviteHookSecondTitleOpen197: {
    ru: "Шаг за шагом, без отклонений",
    en: "Step by step, no deviations",
    es: "Paso a paso, sin desvíos",
    pt: "Passo a passo, sem desvios",
    de: "Schritt für Schritt, ohne Abweichungen",
    fr: "Étape par étape, sans déviation",
  },
  inviteHookSecondTitleOpen198: {
    ru: "Сделка идёт. Повторение ритуала — ключ к стабильности",
    en: "Trade’s running. Repetition builds stability",
    es: "Operación en marcha. La repetición construye estabilidad",
    pt: "Operação em curso. A repetição constrói estabilidade",
    de: "Trade läuft. Wiederholung schafft Stabilität",
    fr: "Trade en marche. La répétition construit la stabilité",
  },
  inviteHookSecondTitleOpen199: {
    ru: "Всё по привычному сценарию — спокойствие в деталях",
    en: "Everything as usual — calm in the details",
    es: "Todo como siempre — calma en los detalles",
    pt: "Tudo como sempre — calma nos detalhes",
    de: "Alles wie gewohnt — Ruhe in den Details",
    fr: "Tout comme toujours — calme dans les détails",
  },
  inviteHookSecondTitleOpen200: {
    ru: "Вход совершен. Начало стандартное, как и должно быть",
    en: "Entry’s in. Standard start — just as it should be",
    es: "Entrada lista. Inicio estándar, como debe ser",
    pt: "Entrada feita. Início padrão, como deve ser",
    de: "Einstieg gemacht. Standardstart, wie’s sein soll",
    fr: "Entrée faite. Début standard, comme il se doit",
  },
  inviteHookAdd1: {
    ru: "Добавил ещё к 🔥 позиции по Apple Inc",
    en: "Added more 🔥 to Apple Inc",
    es: "Agregué más a mi 🔥 posición en Apple Inc",
    pt: "Adicionei mais 🔥 em Apple Inc",
    de: "Habe mehr zu 🔥 Apple Inc hinzugefügt",
    fr: "J’ai ajouté un peu 🔥 plus sur Apple Inc",
  },
  inviteHookAdd2: {
    ru: "Увеличил позицию 🔥 по Apple Inc",
    en: "Increased my 🔥 Apple Inc position",
    es: "Aumenté mi posición 🔥 en Apple Inc",
    pt: "Aumentei minha 🔥 posição em Apple Inc",
    de: "Meine Position in 🔥 Apple Inc vergrößert",
    fr: "Augmenté ma position 🔥 sur Apple Inc",
  },
  inviteHookAdd3: {
    ru: "Немного добрал 🔥 по Apple Inc",
    en: "Scaled in a bit 🔥 more on Apple Inc",
    es: "Sumé un poco 🔥 más en Apple Inc",
    pt: "Somei um pouco 🔥 mais em Apple Inc",
    de: "Etwas bei Apple Inc 🔥 nachgelegt",
    fr: "Ajouté un peu 🔥 sur Apple Inc",
  },
  inviteHookAdd4: {
    ru: "Укрепил позицию 🔥 по Apple Inc",
    en: "Reinforced my 🔥 Apple Inc position",
    es: "Reforcé mi posición 🔥 en Apple Inc",
    pt: "Reforcei minha 🔥 posição em Apple Inc",
    de: "Meine Position in 🔥 Apple Inc verstärkt",
    fr: "Renforcé ma position 🔥 sur Apple Inc",
  },
  inviteHookAdd5: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Añadí a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd6: {
    ru: "Увеличил позицию 🔥 по Apple Inc",
    en: "Increased my 🔥 Apple Inc position",
    es: "Aumenté mi posición 🔥 en Apple Inc",
    pt: "Aumentei minha 🔥 posição em Apple Inc",
    de: "Meine Position in 🔥 Apple Inc vergrößert",
    fr: "Augmenté ma position 🔥 sur Apple Inc",
  },
  inviteHookAdd7: {
    ru: "Расширил позицию 🔥 по Apple Inc",
    en: "Expanded my 🔥 Apple Inc exposure",
    es: "Expandí exposición 🔥 en Apple Inc",
    pt: "Expandi minha 🔥 exposição em Apple Inc",
    de: "Exposition in 🔥 Apple Inc erweitert",
    fr: "Exposition élargie 🔥 sur Apple Inc",
  },
  inviteHookAdd8: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Añadí a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd9: {
    ru: "Небольшое добавление 🔥 к Apple Inc",
    en: "Light add to 🔥 Apple Inc",
    es: "Pequeña adición 🔥 a Apple Inc",
    pt: "Pequena adição 🔥 em Apple Inc",
    de: "Kleine Ergänzung 🔥 zu Apple Inc",
    fr: "Petit ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd10: {
    ru: "Расширил позицию 🔥 по Apple Inc",
    en: "Expanded my 🔥 Apple Inc exposure",
    es: "Expandí exposición 🔥 en Apple Inc",
    pt: "Expandi minha 🔥 exposição em Apple Inc",
    de: "Exposition in 🔥 Apple Inc erweitert",
    fr: "Exposition élargie 🔥 sur Apple Inc",
  },
  inviteHookAdd11: {
    ru: "Небольшое добавление 🔥 к Apple Inc",
    en: "Light add to 🔥 Apple Inc",
    es: "Pequeña adición 🔥 a Apple Inc",
    pt: "Pequena adição 🔥 em Apple Inc",
    de: "Kleine Ergänzung 🔥 zu Apple Inc",
    fr: "Petit ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd12: {
    ru: "Усреднил по 🔥 Apple Inc",
    en: "Averaged up 🔥 on Apple Inc",
    es: "Promedié al alza 🔥 en Apple Inc",
    pt: "Fiz média pra 🔥 cima em Apple Inc",
    de: "Apple Inc 🔥 aufgestockt",
    fr: "Renforcé 🔥 Apple Inc",
  },
  inviteHookAdd13: {
    ru: "Небольшое добавление 🔥 к Apple Inc",
    en: "Slight add 🔥 to Apple Inc",
    es: "Pequeña adición 🔥 a Apple Inc",
    pt: "Pequeno reforço 🔥 em Apple Inc",
    de: "Kleine Aufstockung 🔥 bei Apple Inc",
    fr: "Petit ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd14: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Añadí a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd15: {
    ru: "Apple Inc — 🔥 немного увеличил",
    en: "Apple Inc — nudged 🔥 it up a bit",
    es: "Apple Inc — 🔥 aumenté un poco",
    pt: "Apple Inc — 🔥 aumentei um pouco",
    de: "Apple Inc — 🔥 etwas erhöht",
    fr: "Apple Inc — 🔥 légèrement augmenté",
  },
  inviteHookAdd16: {
    ru: "Слегка добавил 🔥 по Apple Inc",
    en: "Light add on 🔥 Apple Inc",
    es: "Agregué ligeramente 🔥 en Apple Inc",
    pt: "Adicionei de leve 🔥 em Apple Inc",
    de: "Leicht nachgelegt 🔥 bei Apple Inc",
    fr: "Petit ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd17: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Añadí a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd18: {
    ru: "Слегка добавил 🔥 по Apple Inc",
    en: "Light add on 🔥 Apple Inc",
    es: "Agregué ligeramente 🔥 en Apple Inc",
    pt: "Adicionei de leve 🔥 em Apple Inc",
    de: "Leicht nachgelegt 🔥 bei Apple Inc",
    fr: "Petit ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd19: {
    ru: "Продолжаю добавлять 🔥 в Apple Inc",
    en: "Continuing to 🔥 add in Apple Inc",
    es: "Sigo agregando 🔥 en Apple Inc",
    pt: "Continuo adicionando 🔥 em Apple Inc",
    de: "Baue weiter in 🔥 Apple Inc aus",
    fr: "Je continue à 🔥 ajouter sur Apple Inc",
  },
  inviteHookAdd20: {
    ru: "Apple Inc — 🔥 увеличил позицию",
    en: "Apple Inc — increased 🔥 the position",
    es: "Apple Inc — 🔥 aumenté la posición",
    pt: "Apple Inc — 🔥 aumentei a posição",
    de: "Apple Inc — 🔥 Position vergrößert",
    fr: "Apple Inc — 🔥 position augmentée",
  },
  inviteHookAdd21: {
    ru: "Apple Inc — 🔥 добавил спокойно",
    en: "Apple Inc — 🔥 added calmly",
    es: "Apple Inc — 🔥 agregué con calma",
    pt: "Apple Inc — 🔥 adicionei com calma",
    de: "Apple Inc — 🔥 ruhig nachgelegt",
    fr: "Apple Inc — 🔥 ajouté calmement",
  },
  inviteHookAdd22: {
    ru: "Увеличил объём 🔥 по Apple Inc",
    en: "Increased size 🔥 on Apple Inc",
    es: "Aumenté el tamaño 🔥 en Apple Inc",
    pt: "Aumentei o tamanho 🔥 em Apple Inc",
    de: "Volumen bei 🔥 Apple Inc erhöht",
    fr: "Taille augmentée 🔥 sur Apple Inc",
  },
  inviteHookAdd23: {
    ru: "Добрал позицию 🔥 по Apple Inc",
    en: "Layered into 🔥 Apple Inc",
    es: "Sigo acumulando 🔥 Apple Inc",
    pt: "Fui adicionando em 🔥 camadas em Apple Inc",
    de: "Schichtweise in 🔥 Apple Inc aufgebaut",
    fr: "Ajouté en couches 🔥 sur Apple Inc",
  },
  inviteHookAdd24: {
    ru: "Углубился в позицию 🔥 по Apple Inc",
    en: "Scaled in deeper 🔥 on Apple Inc",
    es: "Entré más profundo 🔥 en Apple Inc",
    pt: "Entrei mais fundo 🔥 em Apple Inc",
    de: "Tiefer in Apple Inc 🔥 eingestiegen",
    fr: "Entré un peu plus 🔥 sur Apple Inc",
  },
  inviteHookAdd25: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd26: {
    ru: "Добавил выборочно 🔥 к Apple Inc",
    en: "Added selectively 🔥 to Apple Inc",
    es: "Agregué selectivamente 🔥 a Apple Inc",
    pt: "Adicionei seletivamente 🔥 em Apple Inc",
    de: "Selektiv zu 🔥 Apple Inc hinzugefügt",
    fr: "Ajout sélectif 🔥 sur Apple Inc",
  },
  inviteHookAdd27: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd28: {
    ru: "Добавил немного 🔥 к Apple Inc",
    en: "Added lightly 🔥 to Apple Inc",
    es: "Añadí ligero 🔥 a Apple Inc",
    pt: "Adicionei leve 🔥 em Apple Inc",
    de: "Leicht zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajout léger 🔥 sur Apple Inc",
  },
  inviteHookAdd29: {
    ru: "База по Apple Inc 🔥 формируется",
    en: "Apple Inc 🔥 base forming",
    es: "Base de Apple Inc 🔥 formando",
    pt: "Base de Apple Inc 🔥 formando",
    de: "Apple Inc 🔥 bildet Basis",
    fr: "Base en formation 🔥 sur Apple Inc",
  },
  inviteHookAdd30: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd31: {
    ru: "Apple Inc — 🔥 все стабильно",
    en: "Apple Inc — 🔥 all steady",
    es: "Apple Inc — 🔥 todo estable",
    pt: "Apple Inc — 🔥 tudo estável",
    de: "Apple Inc — 🔥 Alles stabil",
    fr: "Apple Inc — 🔥 tout est stable",
  },
  inviteHookAdd32: {
    ru: "Укрепил позицию 🔥 по Apple Inc",
    en: "Reinforced 🔥 Apple Inc",
    es: "Reforcé 🔥 Apple Inc",
    pt: "Reforcei 🔥 Apple Inc",
    de: "Apple Inc 🔥 verstärkt",
    fr: "Position renforcée 🔥 sur Apple Inc",
  },
  inviteHookAdd33: {
    ru: "Сетап по 🔥 Apple Inc дозрел",
    en: "Apple Inc 🔥 setup matured",
    es: "El setup de 🔥 Apple Inc maduró",
    pt: "Setup de Apple Inc 🔥 amadureceu",
    de: "Setup von 🔥 Apple Inc gereift",
    fr: "Setup 🔥 Apple Inc mûr",
  },
  inviteHookAdd34: {
    ru: "Добавил по 🔥 Apple Inc тихо",
    en: "Quietly added 🔥 Apple Inc",
    es: "Sumé a Apple Inc 🔥 en silencio",
    pt: "Adicionei em silêncio 🔥 em Apple Inc",
    de: "Leise zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajout discret 🔥 sur Apple Inc",
  },
  inviteHookAdd35: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd36: {
    ru: "Добавил ещё 🔥 по Apple Inc",
    en: "Added more 🔥 Apple Inc",
    es: "Agregué más 🔥 Apple Inc",
    pt: "Adicionei mais 🔥 Apple Inc",
    de: "Mehr Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté plus 🔥 d’Apple Inc",
  },
  inviteHookAdd37: {
    ru: "Немного добавил 🔥 к Apple Inc",
    en: "Added a bit 🔥 to Apple Inc",
    es: "Añadí un poco 🔥 a Apple Inc",
    pt: "Adicionei um 🔥 pouco em Apple Inc",
    de: "Etwas zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté un peu 🔥 sur Apple Inc",
  },
  inviteHookAdd38: {
    ru: "Добавил в 🔥 Apple Inc",
    en: "Added into 🔥 Apple Inc",
    es: "Añadí en 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd39: {
    ru: "Добавил ещё 🔥 по Apple Inc",
    en: "Added more 🔥 Apple Inc",
    es: "Agregué más 🔥 Apple Inc",
    pt: "Adicionei mais 🔥 Apple Inc",
    de: "Mehr Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté plus 🔥 d’Apple Inc",
  },
  inviteHookAdd40: {
    ru: "Мнение по Apple Inc 🔥 сохраняется",
    en: "View on 🔥 Apple Inc remains",
    es: "La opinión sobre 🔥 Apple Inc se mantiene",
    pt: "A visão sobre 🔥 Apple Inc permanece",
    de: "Einschätzung zu 🔥 Apple Inc bleibt",
    fr: "L’avis sur Apple Inc 🔥 reste le même",
  },
  inviteHookAdd41: {
    ru: "Apple Inc. 🔥 Зашёл снова",
    en: "Apple Inc. 🔥 Stepped in again",
    es: "Apple Inc. 🔥 Entré otra vez",
    pt: "Apple Inc. 🔥 Entrei de novo",
    de: "Apple Inc. 🔥 Wieder eingestiegen",
    fr: "Apple Inc. 🔥 Repris position",
  },
  inviteHookAdd42: {
    ru: "Немного добавил 🔥 к Apple Inc",
    en: "Added a bit 🔥 to Apple Inc",
    es: "Añadí un poco 🔥 a Apple Inc",
    pt: "Adicionei um 🔥 pouco em Apple Inc",
    de: "Etwas zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté un peu 🔥 sur Apple Inc",
  },
  inviteHookAdd43: {
    ru: "Apple Inc. 🔥 Зашёл снова",
    en: "Apple Inc. 🔥 Stepped in again",
    es: "Apple Inc. 🔥 Entré otra vez",
    pt: "Apple Inc. 🔥 Entrei de novo",
    de: "Apple Inc. 🔥 Wieder eingestiegen",
    fr: "Apple Inc. 🔥 Repris position",
  },
  inviteHookAdd44: {
    ru: "Apple Inc — снова 🔥 немного добавил",
    en: "Apple Inc — added 🔥 a touch again",
    es: "Apple Inc — volví 🔥 a agregar un poco",
    pt: "Apple Inc — adicionei 🔥 mais um pouco",
    de: "Apple Inc — wieder 🔥 leicht nachgelegt",
    fr: "Apple Inc — ajouté 🔥 encore un peu",
  },
  inviteHookAdd45: {
    ru: "Apple Inc — 🔥 увеличил позицию",
    en: "Apple Inc — increased 🔥 the position",
    es: "Apple Inc — 🔥 aumenté la posición",
    pt: "Apple Inc — 🔥 aumentei a posição",
    de: "Apple Inc — 🔥 Position vergrößert",
    fr: "Apple Inc — 🔥 position augmentée",
  },
  inviteHookAdd46: {
    ru: "Снова усилил 🔥 позицию по Apple Inc",
    en: "Built up 🔥 Apple Inc further",
    es: "Construí más posición 🔥 en Apple Inc",
    pt: "Aumentei mais 🔥 Apple Inc",
    de: "Apple Inc weiter 🔥 aufgebaut",
    fr: "Apple Inc 🔥 renforcé",
  },
  inviteHookAdd47: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd48: {
    ru: "Apple Inc 🔥 идёт по плану",
    en: "Apple Inc steady 🔥 as planned",
    es: "Apple Inc sigue 🔥 según plan",
    pt: "Apple Inc firme 🔥 como planejado",
    de: "Apple Inc stabil 🔥 wie geplant",
    fr: "Apple Inc 🔥 reste stable",
  },
  inviteHookAdd49: {
    ru: "Apple Inc — 🔥 добавил спокойно",
    en: "Apple Inc — 🔥 added calmly",
    es: "Apple Inc — 🔥 agregué con calma",
    pt: "Apple Inc — 🔥 adicionei com calma",
    de: "Apple Inc — 🔥 ruhig nachgelegt",
    fr: "Apple Inc — 🔥 ajouté calmement",
  },
  inviteHookAdd50: {
    ru: "Добавил в 🔥 Apple Inc",
    en: "Added into 🔥 Apple Inc",
    es: "Añadí en 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd51: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd52: {
    ru: "Apple Inc — 🔥 немного добавил",
    en: "Apple Inc — 🔥 added a little",
    es: "Apple Inc — 🔥 agregué un poco",
    pt: "Apple Inc — 🔥 adicionei um pouco",
    de: "Apple Inc — 🔥 etwas nachgelegt",
    fr: "Apple Inc — 🔥 ajouté un peu",
  },
  inviteHookAdd53: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd54: {
    ru: "Нарастил размер 🔥 по Apple Inc",
    en: "Scaled up 🔥 Apple Inc",
    es: "Aumenté el tamaño 🔥 en Apple Inc",
    pt: "Aumentei o tamanho 🔥 em Apple Inc",
    de: "Größe bei 🔥 Apple Inc erhöht",
    fr: "Taille augmentée 🔥 sur Apple Inc",
  },
  inviteHookAdd55: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd56: {
    ru: "Небольшое добавление 🔥 к Apple Inc",
    en: "Light add to 🔥 Apple Inc",
    es: "Pequeña adición 🔥 a Apple Inc",
    pt: "Pequena adição 🔥 em Apple Inc",
    de: "Kleine Ergänzung 🔥 zu Apple Inc",
    fr: "Petit ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd57: {
    ru: "Apple Inc 🔥 — увеличил",
    en: "Apple Inc 🔥 — increased",
    es: "Apple Inc 🔥 — aumenté",
    pt: "Apple Inc 🔥 — aumentei",
    de: "Apple Inc 🔥 — erhöht",
    fr: "Apple Inc 🔥 — augmenté",
  },
  inviteHookAdd58: {
    ru: "Добавил по 🔥 Apple Inc",
    en: "Added on 🔥 Apple Inc",
    es: "Añadí en 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Hinzugefügt 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd59: {
    ru: "Apple Inc 🔥 — увеличил",
    en: "Apple Inc 🔥 — increased",
    es: "Apple Inc 🔥 — aumenté",
    pt: "Apple Inc 🔥 — aumentei",
    de: "Apple Inc 🔥 — erhöht",
    fr: "Apple Inc 🔥 — augmenté",
  },
  inviteHookAdd60: {
    ru: "Постепенно наращиваю 🔥 по Apple Inc",
    en: "Gradual build 🔥 on Apple Inc",
    es: "Construcción 🔥 gradual en Apple Inc",
    pt: "Construção gradual 🔥 em Apple Inc",
    de: "Schrittweiser Aufbau 🔥 bei Apple Inc",
    fr: "Construction graduelle 🔥 sur Apple Inc",
  },
  inviteHookAdd61: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd62: {
    ru: "Продолжаю добавлять 🔥 в Apple Inc",
    en: "Continuing to 🔥 add in Apple Inc",
    es: "Sigo agregando 🔥 en Apple Inc",
    pt: "Continuo adicionando 🔥 em Apple Inc",
    de: "Baue weiter in 🔥 Apple Inc aus",
    fr: "Je continue à 🔥 ajouter sur Apple Inc",
  },
  inviteHookAdd63: {
    ru: "Apple Inc — 🔥 расширил долю",
    en: "Apple Inc — 🔥 expanded the stake",
    es: "Apple Inc — amplié 🔥 la participación",
    pt: "Apple Inc — ampliei 🔥 a participação",
    de: "Apple Inc — 🔥 Anteil erweitert",
    fr: "Apple Inc — 🔥 part augmentée",
  },
  inviteHookAdd64: {
    ru: "Apple Inc — 🔥 добавил снова",
    en: "Apple Inc — 🔥 added again",
    es: "Apple Inc — 🔥 volví a agregar",
    pt: "Apple Inc — 🔥 adicionei de novo",
    de: "Apple Inc — 🔥 wieder nachgelegt",
    fr: "Apple Inc — 🔥 ajouté encore",
  },
  inviteHookAdd65: {
    ru: "Apple Inc — 🔥 добавил часть",
    en: "Apple Inc — 🔥 added a piece",
    es: "Apple Inc — 🔥 agregué una parte",
    pt: "Apple Inc — 🔥 adicionei uma parte",
    de: "Apple Inc — Teilposition 🔥 hinzugefügt",
    fr: "Apple Inc — 🔥 ajouté une part",
  },
  inviteHookAdd66: {
    ru: "Дальше усилил 🔥 позицию по Apple Inc",
    en: "Further increased the 🔥 Apple Inc position",
    es: "Aumenté más la 🔥 posición en Apple Inc",
    pt: "Aumentei mais a 🔥 posição em Apple Inc",
    de: "Position bei Apple Inc 🔥 weiter erhöht",
    fr: "Position encore 🔥 augmentée sur Apple Inc",
  },
  inviteHookAdd67: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd68: {
    ru: "Добавил аккуратно 🔥 по Apple Inc",
    en: "Added carefully 🔥 in Apple Inc",
    es: "Agregué con cuidado 🔥 en Apple Inc",
    pt: "Adicionei com 🔥 cuidado em Apple Inc",
    de: "Sorgfältig nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté avec prudence 🔥 sur Apple Inc",
  },
  inviteHookAdd69: {
    ru: "Немного добавил 🔥 к Apple Inc",
    en: "Added a bit 🔥 to Apple Inc",
    es: "Agregué un poco 🔥 a Apple Inc",
    pt: "Adicionei um 🔥 pouco em Apple Inc",
    de: "Etwas hinzugefügt 🔥 bei Apple Inc",
    fr: "Ajouté un peu 🔥 sur Apple Inc",
  },
  inviteHookAdd70: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd71: {
    ru: "Добавил спокойно 🔥 в Apple Inc",
    en: "Added calmly 🔥 in Apple Inc",
    es: "Agregué con calma 🔥 en Apple Inc",
    pt: "Adicionei com 🔥 calma em Apple Inc",
    de: "Ruhig nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté calmement 🔥 sur Apple Inc",
  },
  inviteHookAdd72: {
    ru: "Добавил по 🔥 Apple Inc",
    en: "Added in 🔥 Apple Inc",
    es: "Agregué en 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Nachgekauft 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd73: {
    ru: "Усилил позицию 🔥 по Apple Inc",
    en: "Scaled up the 🔥 Apple Inc position",
    es: "Aumenté la posición 🔥 en Apple Inc",
    pt: "Aumentei a posição 🔥 em Apple Inc",
    de: "Position bei 🔥 Apple Inc ausgebaut",
    fr: "Position renforcée 🔥 sur Apple Inc",
  },
  inviteHookAdd74: {
    ru: "Apple Inc, 🔥 увеличил позицию",
    en: "Apple Inc, increased 🔥 the position",
    es: "Apple Inc, aumenté 🔥 la posición",
    pt: "Apple Inc, 🔥 aumentei a posição",
    de: "Apple Inc, Position 🔥 vergrößert",
    fr: "Apple Inc, 🔥 position augmentée",
  },
  inviteHookAdd75: {
    ru: "Ещё одно добавление 🔥 по Apple Inc",
    en: "Another build 🔥 on Apple Inc",
    es: "Otro build 🔥 en Apple Inc",
    pt: "Mais uma adição 🔥 em Apple Inc",
    de: "Weiterer Aufbau 🔥 bei Apple Inc",
    fr: "Encore un build 🔥 sur Apple Inc",
  },
  inviteHookAdd76: {
    ru: "Добрал позицию 🔥 по Apple Inc",
    en: "Topped up 🔥 Apple Inc",
    es: "Sumé más en 🔥 Apple Inc",
    pt: "Aumentei em 🔥 Apple Inc",
    de: "Nachgekauft 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd77: {
    ru: "Добавил обратно 🔥 в Apple Inc",
    en: "Added back 🔥 into Apple Inc",
    es: "Volví a entrar 🔥 en Apple Inc",
    pt: "Voltei pra 🔥 Apple Inc",
    de: "Zurück in 🔥 Apple Inc",
    fr: "Revenu sur 🔥 Apple Inc",
  },
  inviteHookAdd78: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd79: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Agregué a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd80: {
    ru: "Apple Inc. 🔥 Зашёл снова",
    en: "Apple Inc. 🔥 Stepped in again",
    es: "Apple Inc. 🔥 Entré otra vez",
    pt: "Apple Inc. 🔥 Entrei de novo",
    de: "Apple Inc. 🔥 Wieder eingestiegen",
    fr: "Apple Inc. 🔥 Repris position",
  },
  inviteHookAdd81: {
    ru: "Немного добавил 🔥 к Apple Inc",
    en: "Added a bit 🔥 to Apple Inc",
    es: "Añadí un poco 🔥 a Apple Inc",
    pt: "Adicionei um 🔥 pouco em Apple Inc",
    de: "Etwas zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté un peu 🔥 sur Apple Inc",
  },
  inviteHookAdd82: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd83: {
    ru: "Укрепил позицию 🔥 по Apple Inc",
    en: "Reinforced 🔥 Apple Inc",
    es: "Reforcé 🔥 Apple Inc",
    pt: "Reforcei 🔥 Apple Inc",
    de: "Apple Inc 🔥 verstärkt",
    fr: "Position renforcée 🔥 sur Apple Inc",
  },
  inviteHookAdd84: {
    ru: "Apple Inc 🔥 — увеличил",
    en: "Apple Inc 🔥 — increased",
    es: "Apple Inc 🔥 — aumenté",
    pt: "Apple Inc 🔥 — aumentei",
    de: "Apple Inc 🔥 — erhöht",
    fr: "Apple Inc 🔥 — augmenté",
  },
  inviteHookAdd85: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Añadí a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd86: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd87: {
    ru: "Apple Inc — 🔥 немного добавил",
    en: "Apple Inc — 🔥 added a little",
    es: "Apple Inc — 🔥 agregué un poco",
    pt: "Apple Inc — 🔥 adicionei um pouco",
    de: "Apple Inc — 🔥 etwas nachgelegt",
    fr: "Apple Inc — 🔥 ajouté un peu",
  },
  inviteHookAdd88: {
    ru: "Apple Inc — 🔥 добавил спокойно",
    en: "Apple Inc — 🔥 added calmly",
    es: "Apple Inc — 🔥 agregué con calma",
    pt: "Apple Inc — 🔥 adicionei com calma",
    de: "Apple Inc — 🔥 ruhig nachgelegt",
    fr: "Apple Inc — 🔥 ajouté calmement",
  },
  inviteHookAdd89: {
    ru: "Apple Inc — 🔥 немного добавил",
    en: "Apple Inc — 🔥 added a little",
    es: "Apple Inc — 🔥 agregué un poco",
    pt: "Apple Inc — 🔥 adicionei um pouco",
    de: "Apple Inc — 🔥 etwas nachgelegt",
    fr: "Apple Inc — 🔥 ajouté un peu",
  },
  inviteHookAdd90: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd91: {
    ru: "Apple Inc — 🔥 немного добавил",
    en: "Apple Inc — 🔥 added a little",
    es: "Apple Inc — 🔥 agregué un poco",
    pt: "Apple Inc — 🔥 adicionei um pouco",
    de: "Apple Inc — 🔥 etwas nachgelegt",
    fr: "Apple Inc — 🔥 ajouté un peu",
  },
  inviteHookAdd92: {
    ru: "Снова усилил 🔥 позицию по Apple Inc",
    en: "Built up 🔥 Apple Inc further",
    es: "Construí más posición 🔥 en Apple Inc",
    pt: "Aumentei mais 🔥 Apple Inc",
    de: "Apple Inc weiter 🔥 aufgebaut",
    fr: "Apple Inc 🔥 renforcé",
  },
  inviteHookAdd93: {
    ru: "Apple Inc. 🔥 Зашёл снова",
    en: "Apple Inc. 🔥 Stepped in again",
    es: "Apple Inc. 🔥 Entré otra vez",
    pt: "Apple Inc. 🔥 Entrei de novo",
    de: "Apple Inc. 🔥 Wieder eingestiegen",
    fr: "Apple Inc. 🔥 Repris position",
  },
  inviteHookAdd94: {
    ru: "Apple Inc. 🔥 Зашёл снова",
    en: "Apple Inc. 🔥 Stepped in again",
    es: "Apple Inc. 🔥 Entré otra vez",
    pt: "Apple Inc. 🔥 Entrei de novo",
    de: "Apple Inc. 🔥 Wieder eingestiegen",
    fr: "Apple Inc. 🔥 Repris position",
  },
  inviteHookAdd95: {
    ru: "Добавил в 🔥 Apple Inc",
    en: "Added into 🔥 Apple Inc",
    es: "Añadí en 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "In Apple Inc 🔥 eingestiegen",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd96: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd97: {
    ru: "Добавил ещё 🔥 по Apple Inc",
    en: "Added more 🔥 Apple Inc",
    es: "Agregué más 🔥 Apple Inc",
    pt: "Adicionei mais 🔥 Apple Inc",
    de: "Mehr Apple Inc 🔥 hinzugefügt",
    fr: "Ajouté plus 🔥 d’Apple Inc",
  },
  inviteHookAdd98: {
    ru: "Укрепил позицию 🔥 по Apple Inc",
    en: "Reinforced 🔥 Apple Inc",
    es: "Reforcé 🔥 Apple Inc",
    pt: "Reforcei 🔥 Apple Inc",
    de: "Apple Inc 🔥 verstärkt",
    fr: "Position renforcée 🔥 sur Apple Inc",
  },
  inviteHookAdd99: {
    ru: "Добавил немного 🔥 к Apple Inc",
    en: "Added lightly 🔥 to Apple Inc",
    es: "Añadí ligero 🔥 a Apple Inc",
    pt: "Adicionei leve 🔥 em Apple Inc",
    de: "Leicht zu Apple Inc 🔥 hinzugefügt",
    fr: "Ajout léger 🔥 sur Apple Inc",
  },
  inviteHookAdd100: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd101: {
    ru: "Добавил ещё к 🔥 позиции по Apple Inc",
    en: "Added more to the 🔥 Apple Inc position",
    es: "Agregué más a la 🔥 posición en Apple Inc",
    pt: "Adicionei mais à 🔥 posição em Apple Inc",
    de: "Habe meine Position 🔥 bei Apple Inc",
    fr: "J’ai ajouté à ma 🔥 position sur Apple Inc",
  },
  inviteHookAdd102: {
    ru: "Увеличил позицию 🔥 по Apple Inc",
    en: "Increased the 🔥 position on Apple Inc",
    es: "Aumenté la posición 🔥 en Apple Inc",
    pt: "Aumentei a posição 🔥 em Apple Inc",
    de: "Position bei 🔥 Apple Inc",
    fr: "Position sur 🔥 Apple Inc augmentée",
  },
  inviteHookAdd103: {
    ru: "Немного добрал 🔥 по Apple Inc",
    en: "Scaled in a bit 🔥 more on Apple Inc",
    es: "Sumé un poco 🔥 más en Apple Inc",
    pt: "Somei um pouco 🔥 mais em Apple Inc",
    de: "Etwas bei Apple Inc 🔥 nachgelegt",
    fr: "Ajouté un peu 🔥 sur Apple Inc",
  },
  inviteHookAdd104: {
    ru: "Укрепил позицию 🔥 по Apple Inc",
    en: "Reinforced the 🔥 Apple Inc position",
    es: "Reforcé la posición 🔥 en Apple Inc",
    pt: "Reforcei a posição 🔥 em Apple Inc",
    de: "Position bei 🔥 Apple Inc verstärkt",
    fr: "Position renforcée 🔥 sur Apple Inc",
  },
  inviteHookAdd105: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Agregué a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Bei Apple Inc 🔥 nachgelegt",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd106: {
    ru: "Apple Inc — 🔥 немного добрал",
    en: "Apple Inc — 🔥 added a bit",
    es: "Apple Inc — 🔥 agregué un poco",
    pt: "Apple Inc — 🔥 adicionei um pouco",
    de: "Apple Inc — 🔥 etwas aufgestockt",
    fr: "Apple Inc — 🔥 ajouté un peu",
  },
  inviteHookAdd107: {
    ru: "Слегка добавил 🔥 Apple Inc",
    en: "Light add on 🔥 Apple Inc",
    es: "Agregué ligeramente 🔥 en Apple Inc",
    pt: "Adicionei de leve 🔥 em Apple Inc",
    de: "Leicht aufgestockt 🔥 bei Apple Inc",
    fr: "Petit ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd108: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd109: {
    ru: "Apple Inc, 🔥 добавил аккуратно",
    en: "Apple Inc, 🔥 added carefully",
    es: "Apple Inc, agregué 🔥 con cuidado",
    pt: "Apple Inc, adicionei 🔥 com cuidado",
    de: "Apple Inc, vorsichtig 🔥 hinzugefügt",
    fr: "Apple Inc, ajouté 🔥 prudemment",
  },
  inviteHookAdd110: {
    ru: "Расширил позицию 🔥 по Apple Inc",
    en: "Expanded the 🔥 Apple Inc position",
    es: "Amplié la posición 🔥 en Apple Inc",
    pt: "Expandi a posição 🔥 em Apple Inc",
    de: "Position bei 🔥 Apple Inc erweitert",
    fr: "Position élargie 🔥 sur Apple Inc",
  },
  inviteHookAdd111: {
    ru: "Немного докупил 🔥 Apple Inc",
    en: "Picked up a bit 🔥 more Apple Inc",
    es: "Compré un poco 🔥 más de Apple Inc",
    pt: "Comprei um pouco 🔥 mais de Apple Inc",
    de: "Etwas mehr 🔥 Apple Inc gekauft",
    fr: "Racheté un peu 🔥 d’Apple Inc",
  },
  inviteHookAdd112: {
    ru: "Усреднил по 🔥 Apple Inc",
    en: "Averaged in 🔥 on Apple Inc",
    es: "Promedié en 🔥 Apple Inc",
    pt: "Fiz preço médio 🔥 em Apple Inc",
    de: "Durchschnittspreis bei 🔥 Apple Inc verbessert",
    fr: "Moyenné sur 🔥 Apple Inc",
  },
  inviteHookAdd113: {
    ru: "Небольшое добавление 🔥 к Apple Inc",
    en: "Small add to 🔥 Apple Inc",
    es: "Pequeña suma 🔥 a Apple Inc",
    pt: "Pequeno reforço 🔥 em Apple Inc",
    de: "Kleiner Nachkauf 🔥 bei Apple Inc",
    fr: "Petit renfort 🔥 sur Apple Inc",
  },
  inviteHookAdd114: {
    ru: "Apple Inc, 🔥 усилил позицию",
    en: "Apple Inc, 🔥 scaled up",
    es: "Apple Inc, aumenté 🔥 la posición",
    pt: "Apple Inc, 🔥 aumentei a posição",
    de: "Apple Inc, 🔥 Position erhöht",
    fr: "Apple Inc, 🔥 position augmentée",
  },
  inviteHookAdd115: {
    ru: "Я увеличил позицию 🔥 по Apple Inc",
    en: "I increased the 🔥 Apple Inc position",
    es: "Aumenté la posición 🔥 en Apple Inc",
    pt: "Aumentei a posição 🔥 em Apple Inc",
    de: "Position bei 🔥 Apple Inc vergrößert",
    fr: "J’ai augmenté la 🔥 position sur Apple Inc",
  },
  inviteHookAdd116: {
    ru: "Apple Inc немного 🔥 откатила, добавил",
    en: "Apple Inc dipped 🔥 a bit, I added",
    es: "Apple Inc bajó 🔥 un poco, agregué",
    pt: "Apple Inc caiu um 🔥 pouco, adicionei",
    de: "Apple Inc leicht 🔥 gefallen, habe nachgelegt",
    fr: "Apple Inc a un peu 🔥 corrigé, j’ai ajouté",
  },
  inviteHookAdd117: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Agregué a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd118: {
    ru: "Apple Inc, 🔥 добавил спокойно",
    en: "Apple Inc, 🔥 added calmly",
    es: "Apple Inc, 🔥 agregué con calma",
    pt: "Apple Inc, 🔥 adicionei com calma",
    de: "Apple Inc, ruhig 🔥 hinzugefügt",
    fr: "Apple Inc, 🔥 ajouté calmement",
  },
  inviteHookAdd119: {
    ru: "Углубился в позицию 🔥 по Apple Inc",
    en: "Scaled in deeper 🔥 on Apple Inc",
    es: "Entré más profundo 🔥 en Apple Inc",
    pt: "Entrei mais fundo 🔥 em Apple Inc",
    de: "Tiefer in Apple Inc 🔥 eingestiegen",
    fr: "Entré un peu plus 🔥 sur Apple Inc",
  },
  inviteHookAdd120: {
    ru: "Пересобрал позицию 🔥 по Apple Inc",
    en: "Reshaped the 🔥 Apple Inc position",
    es: "Reorganicé la 🔥 posición en Apple Inc",
    pt: "Reorganizei a 🔥 posição em Apple Inc",
    de: "Position bei Apple Inc 🔥 neu aufgebaut",
    fr: "Recomposé la position 🔥 sur Apple Inc",
  },
  inviteHookAdd121: {
    ru: "Apple Inc, 🔥 добавил",
    en: "Apple Inc, 🔥 added",
    es: "Apple Inc, 🔥 agregué",
    pt: "Apple Inc, 🔥 adicionei",
    de: "Apple Inc, 🔥 nachgelegt",
    fr: "Apple Inc, 🔥 ajouté",
  },
  inviteHookAdd122: {
    ru: "Усилил позицию 🔥 по Apple Inc",
    en: "Scaled up the 🔥 Apple Inc position",
    es: "Aumenté la posición 🔥 en Apple Inc",
    pt: "Reforcei a posição 🔥 em Apple Inc",
    de: "Position bei 🔥 Apple Inc verstärkt",
    fr: "Position renforcée 🔥 sur Apple Inc",
  },
  inviteHookAdd123: {
    ru: "Добрал позицию 🔥 по Apple Inc",
    en: "Topped up 🔥 Apple Inc",
    es: "Sumé más en 🔥 Apple Inc",
    pt: "Aumentei em 🔥 Apple Inc",
    de: "Nachgekauft 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd124: {
    ru: "Углубился в позицию 🔥 по Apple Inc",
    en: "Went deeper 🔥 into Apple Inc",
    es: "Profundicé en la 🔥 posición en Apple Inc",
    pt: "Aprofundei a 🔥 posição em Apple Inc",
    de: "Position bei 🔥 Apple Inc vertieft",
    fr: "Position approfondie 🔥 sur Apple Inc",
  },
  inviteHookAdd125: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd126: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Agregué a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Bei Apple Inc 🔥 nachgelegt",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd127: {
    ru: "Apple Inc, 🔥 увеличил позицию",
    en: "Apple Inc, increased 🔥 the position",
    es: "Apple Inc, aumenté 🔥 la posición",
    pt: "Apple Inc, 🔥 aumentei a posição",
    de: "Apple Inc, Position 🔥 vergrößert",
    fr: "Apple Inc, 🔥 position augmentée",
  },
  inviteHookAdd128: {
    ru: "Добавил немного 🔥 к Apple Inc",
    en: "Added a bit 🔥 to Apple Inc",
    es: "Agregué un poco 🔥 a Apple Inc",
    pt: "Adicionei um 🔥 pouco em Apple Inc",
    de: "Etwas aufgestockt 🔥 bei Apple Inc",
    fr: "Ajouté un peu 🔥 sur Apple Inc",
  },
  inviteHookAdd129: {
    ru: "Взял ещё часть 🔥 по Apple Inc",
    en: "Took another 🔥 slice in Apple Inc",
    es: "Tomé otra parte 🔥 en Apple Inc",
    pt: "Peguei mais uma 🔥 parte em Apple Inc",
    de: "Noch etwas 🔥 Apple Inc gekauft",
    fr: "Pris une part supplémentaire 🔥 sur Apple Inc",
  },
  inviteHookAdd130: {
    ru: "Усилил позицию 🔥 по Apple Inc",
    en: "Scaled up the 🔥 Apple Inc position",
    es: "Aumenté la posición 🔥 en Apple Inc",
    pt: "Aumentei a posição 🔥 em Apple Inc",
    de: "Position bei 🔥 Apple Inc ausgebaut",
    fr: "Position renforcée 🔥 sur Apple Inc",
  },
  inviteHookAdd131: {
    ru: "Apple Inc, 🔥 спокойно добавил немного",
    en: "Apple Inc, 🔥 added a touch calmly",
    es: "Apple Inc, 🔥 agregué con calma",
    pt: "Apple Inc, 🔥 adicionei de forma calma",
    de: "Apple Inc, 🔥 ruhig nachgelegt",
    fr: "Apple Inc, 🔥 ajouté calmement",
  },
  inviteHookAdd132: {
    ru: "Укрепил позицию 🔥 по Apple Inc",
    en: "Reinforced the 🔥 Apple Inc position",
    es: "Reforcé la posición 🔥 en Apple Inc",
    pt: "Reforcei a posição 🔥 em Apple Inc",
    de: "Position bei 🔥 Apple Inc verstärkt",
    fr: "Position renforcée 🔥 sur Apple Inc",
  },
  inviteHookAdd133: {
    ru: "Сетап по Apple Inc 🔥 дозрел — увеличил долю",
    en: "Apple Inc setup matured 🔥 — increased the stake",
    es: "El setup de Apple Inc maduró 🔥 — aumenté la participación",
    pt: "O setup de Apple Inc amadureceu 🔥 — aumentei a participação",
    de: "Setup bei Apple Inc ist 🔥 gereift — Anteil erhöht",
    fr: "Le setup sur Apple Inc a 🔥 mûri — augmenté la part",
  },
  inviteHookAdd134: {
    ru: "Добавил по 🔥 Apple Inc",
    en: "Added in 🔥 Apple Inc",
    es: "Agregué en 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Nachgekauft 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd135: {
    ru: "Apple Inc — 🔥 добрал ещё немного",
    en: "Apple Inc — 🔥 picked up a bit more",
    es: "Apple Inc — 🔥 sumé un poco más",
    pt: "Apple Inc — 🔥 peguei mais um pouco",
    de: "Apple Inc — 🔥 etwas mehr gekauft",
    fr: "Apple Inc — 🔥 ajouté un peu plus",
  },
  inviteHookAdd136: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookAdd137: {
    ru: "Откаты по Apple Inc остаются 🔥 здоровыми — добавляю",
    en: "Pullbacks in Apple Inc 🔥 remain healthy — adding",
    es: "Los retrocesos en Apple Inc 🔥 siguen sanos — sigo agregando",
    pt: "Os recuos de Apple Inc continuam 🔥 saudáveis — sigo adicionando",
    de: "Rücksetzer bei Apple Inc 🔥 bleiben gesund — kaufe nach",
    fr: "Les replis sur Apple Inc 🔥 restent sains — j’ajoute",
  },
  inviteHookAdd138: {
    ru: "Откат по Apple Inc небольшой, 🔥 увеличил экспозицию",
    en: "Small pullback in Apple Inc, 🔥 increased exposure",
    es: "Pequeño retroceso en Apple Inc, 🔥 aumenté la exposición",
    pt: "Pequeno recuo em Apple Inc, 🔥 aumentei a exposição",
    de: "Kleiner Rücksetzer bei 🔥 Apple Inc, Exposition erhöht",
    fr: "Petit repli sur Apple Inc, 🔥 exposition augmentée",
  },
  inviteHookAdd139: {
    ru: "Добавил ещё 🔥 по Apple Inc",
    en: "Added more 🔥 in Apple Inc",
    es: "Agregué más 🔥 en Apple Inc",
    pt: "Adicionei mais 🔥 em Apple Inc",
    de: "Mehr Apple Inc 🔥 gekauft",
    fr: "Ajouté davantage 🔥 sur Apple Inc",
  },
  inviteHookAdd140: {
    ru: "Добавил спокойно 🔥 в Apple Inc",
    en: "Added calmly 🔥 in Apple Inc",
    es: "Agregué con calma 🔥 en Apple Inc",
    pt: "Adicionei com 🔥 calma em Apple Inc",
    de: "Ruhig nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté calmement 🔥 sur Apple Inc",
  },
  inviteHookAdd141: {
    ru: "Зашёл снова — увеличил 🔥 долю по Apple Inc",
    en: "Re-entered — increased 🔥 the Apple Inc stake",
    es: "Reingresé — aumenté la 🔥 participación en Apple Inc",
    pt: "Reentrei — aumentei a 🔥 participação em Apple Inc",
    de: "Wieder eingestiegen — 🔥 Anteil bei Apple Inc erhöht",
    fr: "Rentré à nouveau — position 🔥 augmentée sur Apple Inc",
  },
  inviteHookAdd142: {
    ru: "Немного добавил 🔥 к Apple Inc",
    en: "Added a bit 🔥 to Apple Inc",
    es: "Agregué un poco 🔥 a Apple Inc",
    pt: "Adicionei um 🔥 pouco em Apple Inc",
    de: "Etwas hinzugefügt 🔥 bei Apple Inc",
    fr: "Ajouté un peu 🔥 sur Apple Inc",
  },
  inviteHookAdd143: {
    ru: "Apple Inc ведёт себя 🔥 хорошо — увеличиваю",
    en: "Apple Inc is behaving 🔥 well — adding",
    es: "Apple Inc se comporta 🔥 bien — sigo agregando",
    pt: "Apple Inc está se comportando 🔥 bem — sigo adicionando",
    de: "Apple Inc läuft gut 🔥 — lege weiter nach",
    fr: "Apple Inc se comporte 🔥 bien — j’ajoute encore",
  },
  inviteHookAdd144: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd145: {
    ru: "Добавил аккуратно 🔥 по Apple Inc",
    en: "Added carefully 🔥 in Apple Inc",
    es: "Agregué con cuidado 🔥 en Apple Inc",
    pt: "Adicionei com 🔥 cuidado em Apple Inc",
    de: "Sorgfältig nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté avec prudence 🔥 sur Apple Inc",
  },
  inviteHookAdd146: {
    ru: "Дальше усилил 🔥 позицию по Apple Inc",
    en: "Further increased the 🔥 Apple Inc position",
    es: "Aumenté más la 🔥 posición en Apple Inc",
    pt: "Aumentei mais a 🔥 posição em Apple Inc",
    de: "Position bei Apple Inc 🔥 weiter erhöht",
    fr: "Position encore 🔥 augmentée sur Apple Inc",
  },
  inviteHookAdd147: {
    ru: "Apple Inc — 🔥 добавил часть",
    en: "Apple Inc — 🔥 added a piece",
    es: "Apple Inc — 🔥 agregué una parte",
    pt: "Apple Inc — 🔥 adicionei uma parte",
    de: "Apple Inc — Teilposition 🔥 hinzugefügt",
    fr: "Apple Inc — 🔥 ajouté une part",
  },
  inviteHookAdd148: {
    ru: "Apple Inc идёт по плану 🔥 — немного увеличил",
    en: "Apple Inc is on plan 🔥 — nudged it higher",
    es: "Apple Inc va según el 🔥 plan — aumenté un poco",
    pt: "Apple Inc segue no plano 🔥 — aumentei um pouco",
    de: "Apple Inc läuft nach 🔥 Plan — etwas erhöht",
    fr: "Apple Inc suit le plan 🔥 — légèrement augmenté",
  },
  inviteHookAdd149: {
    ru: "Apple Inc — 🔥 увеличил позицию",
    en: "Apple Inc — increased 🔥 the position",
    es: "Apple Inc — 🔥 aumenté la posición",
    pt: "Apple Inc — 🔥 aumentei a posição",
    de: "Apple Inc — 🔥 Position vergrößert",
    fr: "Apple Inc — 🔥 position augmentée",
  },
  inviteHookAdd150: {
    ru: "Добавил в 🔥 Apple Inc",
    en: "Added in 🔥 Apple Inc",
    es: "Agregué en 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd151: {
    ru: "Apple Inc держится 🔥 — добавил ещё",
    en: "Apple Inc holding 🔥 up — added more",
    es: "Apple Inc se mantiene 🔥 — agregué más",
    pt: "Apple Inc está firme 🔥 — adicionei mais",
    de: "Apple Inc hält 🔥 sich — nachgekauft",
    fr: "Apple Inc tient bon 🔥 — ajouté davantage",
  },
  inviteHookAdd152: {
    ru: "Добавил часть 🔥 по Apple Inc",
    en: "Added a slice 🔥 in Apple Inc",
    es: "Agregué una parte 🔥 en Apple Inc",
    pt: "Adicionei uma 🔥 parte em Apple Inc",
    de: "Teilposition bei 🔥 Apple Inc hinzugefügt",
    fr: "Ajouté une part 🔥 sur Apple Inc",
  },
  inviteHookAdd153: {
    ru: "Apple Inc — 🔥 увеличил объём",
    en: "Apple Inc — 🔥 increased size",
    es: "Apple Inc — 🔥 aumenté el tamaño",
    pt: "Apple Inc — 🔥 aumentei o tamanho",
    de: "Apple Inc — 🔥 Volumen erhöht",
    fr: "Apple Inc — 🔥 taille augmentée",
  },
  inviteHookAdd154: {
    ru: "Apple Inc — 🔥 немного добавил",
    en: "Apple Inc — 🔥 added a little",
    es: "Apple Inc — 🔥 agregué un poco",
    pt: "Apple Inc — 🔥 adicionei um pouco",
    de: "Apple Inc — 🔥 leicht nachgelegt",
    fr: "Apple Inc — 🔥 ajouté un peu",
  },
  inviteHookAdd155: {
    ru: "Apple Inc — продолжаю 🔥 добавлять понемногу",
    en: "Apple Inc — continuing 🔥 to add in small steps",
    es: "Apple Inc — sigo 🔥 agregando poco a poco",
    pt: "Apple Inc — sigo 🔥 adicionando aos poucos",
    de: "Apple Inc — kaufe 🔥 weiter schrittweise zu",
    fr: "Apple Inc — je continue 🔥 à ajouter petit à petit",
  },
  inviteHookAdd156: {
    ru: "Небольшое добавление 🔥 к Apple Inc",
    en: "Small add to 🔥 Apple Inc",
    es: "Pequeña suma 🔥 a Apple Inc",
    pt: "Pequeno reforço 🔥 em Apple Inc",
    de: "Kleiner Nachkauf 🔥 bei Apple Inc",
    fr: "Petit renfort 🔥 sur Apple Inc",
  },
  inviteHookAdd157: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd158: {
    ru: "Добавил по 🔥 Apple Inc",
    en: "Added in 🔥 Apple Inc",
    es: "Agregué en 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd159: {
    ru: "Снова добавил 🔥 в Apple Inc",
    en: "Added again 🔥 to Apple Inc",
    es: "Volví a agregar 🔥 en Apple Inc",
    pt: "Adicionei novamente 🔥 em Apple Inc",
    de: "Erneut bei 🔥 Apple Inc nachgelegt",
    fr: "Ajouté encore 🔥 sur Apple Inc",
  },
  inviteHookAdd160: {
    ru: "Постепенно наращиваю 🔥 по Apple Inc",
    en: "Gradually building 🔥 Apple Inc",
    es: "Voy acumulando poco 🔥 a poco en Apple Inc",
    pt: "Sigo acumulando 🔥 em Apple Inc",
    de: "Schrittweise baue ich 🔥 Apple Inc weiter aus",
    fr: "Je renforce progressivement 🔥 sur Apple Inc",
  },
  inviteHookAdd161: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd162: {
    ru: "Увеличил объём 🔥 по Apple Inc",
    en: "Increased size 🔥 on Apple Inc",
    es: "Aumenté el tamaño 🔥 en Apple Inc",
    pt: "Aumentei o tamanho 🔥 em Apple Inc",
    de: "Volumen bei 🔥 Apple Inc erhöht",
    fr: "Taille augmentée 🔥 sur Apple Inc",
  },
  inviteHookAdd163: {
    ru: "Добавил осторожно 🔥 в Apple Inc",
    en: "Added cautiously 🔥 in Apple Inc",
    es: "Agregué con cautela 🔥 en Apple Inc",
    pt: "Adicionei com 🔥 cautela em Apple Inc",
    de: "Vorsichtig nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté prudemment 🔥 sur Apple Inc",
  },
  inviteHookAdd164: {
    ru: "Apple Inc — 🔥 всё идёт по плану, добавил",
    en: "Apple Inc — 🔥 everything on plan, added",
    es: "Apple Inc — 🔥 todo según el plan, agregué",
    pt: "Apple Inc — 🔥 tudo conforme o plano, adicionei",
    de: "Apple Inc — 🔥 alles nach Plan, nachgelegt",
    fr: "Apple Inc — 🔥 tout selon le plan, ajouté",
  },
  inviteHookAdd165: {
    ru: "Добрал позицию 🔥 по Apple Inc",
    en: "Layered into 🔥 Apple Inc",
    es: "Sigo acumulando 🔥 Apple Inc",
    pt: "Fui adicionando em 🔥 camadas em Apple Inc",
    de: "Schichtweise in 🔥 Apple Inc aufgebaut",
    fr: "Ajouté en couches 🔥 sur Apple Inc",
  },
  inviteHookAdd166: {
    ru: "Спокойно добавил 🔥 по Apple Inc",
    en: "Added calmly 🔥 in Apple Inc",
    es: "Agregué con calma 🔥 en Apple Inc",
    pt: "Adicionei com 🔥 calma em Apple Inc",
    de: "Ruhig nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté calmement 🔥 sur Apple Inc",
  },
  inviteHookAdd167: {
    ru: "Apple Inc — 🔥 усилил позицию",
    en: "Apple Inc — scaled 🔥 up the position",
    es: "Apple Inc — 🔥 aumenté la posición",
    pt: "Apple Inc — 🔥 aumentei a posição",
    de: "Apple Inc — 🔥 Position vergrößert",
    fr: "Apple Inc — 🔥 position renforcée",
  },
  inviteHookAdd168: {
    ru: "Снова докупил 🔥 Apple Inc",
    en: "Bought more 🔥 Apple Inc",
    es: "Compré más 🔥 de Apple Inc",
    pt: "Comprei mais 🔥 Apple Inc",
    de: "Mehr Apple Inc 🔥 gekauft",
    fr: "Racheté plus 🔥 d’Apple Inc",
  },
  inviteHookAdd169: {
    ru: "Apple Inc — 🔥 немного увеличил",
    en: "Apple Inc — nudged 🔥 it up a bit",
    es: "Apple Inc — 🔥 aumenté un poco",
    pt: "Apple Inc — 🔥 aumentei um pouco",
    de: "Apple Inc — 🔥 etwas erhöht",
    fr: "Apple Inc — 🔥 légèrement augmenté",
  },
  inviteHookAdd170: {
    ru: "Apple Inc — 🔥 добавил новую часть",
    en: "Apple Inc — 🔥 added a new slice",
    es: "Apple Inc — agregué 🔥 una nueva parte",
    pt: "Apple Inc — adicionei 🔥 uma nova parte",
    de: "Apple Inc — neue 🔥 Teilposition hinzugefügt",
    fr: "Apple Inc — ajouté 🔥 une nouvelle part",
  },
  inviteHookAdd171: {
    ru: "Небольшое добавление 🔥 по Apple Inc",
    en: "Small add in 🔥 Apple Inc",
    es: "Pequeña suma 🔥 en Apple Inc",
    pt: "Pequeno reforço 🔥 em Apple Inc",
    de: "Kleiner Zukauf 🔥 bei Apple Inc",
    fr: "Petit ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd172: {
    ru: "Apple Inc — немного 🔥 усилил позицию",
    en: "Apple Inc — increased 🔥 the position a bit",
    es: "Apple Inc — aumenté 🔥 un poco la posición",
    pt: "Apple Inc — aumentei 🔥 um pouco a posição",
    de: "Apple Inc — Position 🔥 leicht vergrößert",
    fr: "Apple Inc — position 🔥 légèrement augmentée",
  },
  inviteHookAdd173: {
    ru: "Apple Inc — 🔥 добавил немного",
    en: "Apple Inc — 🔥 added a little",
    es: "Apple Inc — 🔥 agregué un poco",
    pt: "Apple Inc — 🔥 adicionei um pouco",
    de: "Apple Inc — 🔥 etwas nachgelegt",
    fr: "Apple Inc — 🔥 ajouté un peu",
  },
  inviteHookAdd174: {
    ru: "Apple Inc — 🔥 добавил уверенно",
    en: "Apple Inc — added 🔥 with conviction",
    es: "Apple Inc — agregué 🔥 con confianza",
    pt: "Apple Inc — adicionei 🔥 com confiança",
    de: "Apple Inc — mit 🔥 Überzeugung nachgelegt",
    fr: "Apple Inc — ajouté 🔥 avec confiance",
  },
  inviteHookAdd175: {
    ru: "Ещё одно добавление 🔥 по Apple Inc",
    en: "Another add 🔥 in Apple Inc",
    es: "Otra suma en 🔥 Apple Inc",
    pt: "Mais uma adição 🔥 em Apple Inc",
    de: "Weiterer Nachkauf 🔥 bei Apple Inc",
    fr: "Autre ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd176: {
    ru: "Добавил по 🔥 Apple Inc",
    en: "Added in 🔥 Apple Inc",
    es: "Agregué en 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd177: {
    ru: "Добавил в 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Agregué a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd178: {
    ru: "Apple Inc — 🔥 усилил слегка",
    en: "Apple Inc — 🔥 scaled slightly",
    es: "Apple Inc — 🔥 aumenté ligeramente",
    pt: "Apple Inc — 🔥 aumentei um pouco",
    de: "Apple Inc — 🔥 leicht verstärkt",
    fr: "Apple Inc — 🔥 légèrement renforcé",
  },
  inviteHookAdd179: {
    ru: "Паттерн по 🔥 Apple Inc на добавку",
    en: "Pattern on 🔥 Apple Inc for an add",
    es: "Patrón en Apple Inc 🔥 para agregar",
    pt: "Padrão em Apple Inc 🔥 pra adicionar",
    de: "Muster bei Apple Inc 🔥 für Nachkauf",
    fr: "Pattern sur 🔥 Apple Inc pour ajout",
  },
  inviteHookAdd180: {
    ru: "Apple Inc — 🔥 добавил снова",
    en: "Apple Inc — 🔥 added again",
    es: "Apple Inc — 🔥 volví a agregar",
    pt: "Apple Inc — 🔥 adicionei de novo",
    de: "Apple Inc — 🔥 wieder nachgelegt",
    fr: "Apple Inc — 🔥 ajouté encore",
  },
  inviteHookAdd181: {
    ru: "Добавляю обдуманно 🔥 в Apple Inc",
    en: "Adding thoughtfully 🔥 in Apple Inc",
    es: "Agregando con 🔥 criterio en Apple Inc",
    pt: "Adicionando com 🔥 critério em Apple Inc",
    de: "Überlegt nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté avec réflexion 🔥 sur Apple Inc",
  },
  inviteHookAdd182: {
    ru: "Apple Inc — 🔥 увеличил позицию",
    en: "Apple Inc — increased 🔥 the position",
    es: "Apple Inc — 🔥 aumenté la posición",
    pt: "Apple Inc — 🔥 aumentei a posição",
    de: "Apple Inc — 🔥 Position vergrößert",
    fr: "Apple Inc — 🔥 position augmentée",
  },
  inviteHookAdd183: {
    ru: "Apple Inc откатила 🔥 — добавил спокойно",
    en: "Apple Inc pulled 🔥 back — added calmly",
    es: "Apple Inc retrocedió 🔥 — agregué con calma",
    pt: "Apple Inc recuou — 🔥 adicionei com calma",
    de: "Apple Inc nach Rücksetzer 🔥 ruhig nachgelegt",
    fr: "Apple Inc a reculé 🔥 — ajouté calmement",
  },
  inviteHookAdd184: {
    ru: "Apple Inc — 🔥 расширил долю",
    en: "Apple Inc — 🔥 expanded the stake",
    es: "Apple Inc — amplié 🔥 la participación",
    pt: "Apple Inc — ampliei 🔥 a participação",
    de: "Apple Inc — 🔥 Anteil erweitert",
    fr: "Apple Inc — 🔥 part augmentée",
  },
  inviteHookAdd185: {
    ru: "Добавил к 🔥 Apple Inc",
    en: "Added to 🔥 Apple Inc",
    es: "Agregué a 🔥 Apple Inc",
    pt: "Adicionei em 🔥 Apple Inc",
    de: "Nachgelegt 🔥 bei Apple Inc",
    fr: "Ajouté sur 🔥 Apple Inc",
  },
  inviteHookAdd186: {
    ru: "Apple Inc — 🔥 немного увеличил",
    en: "Apple Inc — nudged 🔥 it up a bit",
    es: "Apple Inc — 🔥 aumenté un poco",
    pt: "Apple Inc — 🔥 aumentei um pouco",
    de: "Apple Inc — 🔥 etwas erhöht",
    fr: "Apple Inc — 🔥 légèrement augmenté",
  },
  inviteHookAdd187: {
    ru: "Слегка добавил 🔥 по Apple Inc",
    en: "Light add on 🔥 Apple Inc",
    es: "Agregué ligeramente 🔥 en Apple Inc",
    pt: "Adicionei de leve 🔥 em Apple Inc",
    de: "Leicht nachgelegt 🔥 bei Apple Inc",
    fr: "Petit ajout 🔥 sur Apple Inc",
  },
  inviteHookAdd188: {
    ru: "Продолжаю добавлять 🔥 в Apple Inc",
    en: "Continuing to 🔥 add in Apple Inc",
    es: "Sigo agregando 🔥 en Apple Inc",
    pt: "Continuo adicionando 🔥 em Apple Inc",
    de: "Baue weiter in 🔥 Apple Inc aus",
    fr: "Je continue à 🔥 ajouter sur Apple Inc",
  },
  inviteHookAdd189: {
    ru: "Apple Inc — 🔥 увеличил позицию",
    en: "Apple Inc — increased 🔥 the position",
    es: "Apple Inc — 🔥 aumenté la posición",
    pt: "Apple Inc — 🔥 aumentei a posição",
    de: "Apple Inc — 🔥 Position vergrößert",
    fr: "Apple Inc — 🔥 position augmentée",
  },
  inviteHookAdd190: {
    ru: "Apple Inc — снова 🔥 немного добавил",
    en: "Apple Inc — added 🔥 a touch again",
    es: "Apple Inc — volví 🔥 a agregar un poco",
    pt: "Apple Inc — adicionei 🔥 mais um pouco",
    de: "Apple Inc — wieder 🔥 leicht nachgelegt",
    fr: "Apple Inc — ajouté 🔥 encore un peu",
  },
  inviteHookAdd191: {
    ru: "Apple Inc — 🔥 добавил спокойно",
    en: "Apple Inc — 🔥 added calmly",
    es: "Apple Inc — 🔥 agregué con calma",
    pt: "Apple Inc — 🔥 adicionei com calma",
    de: "Apple Inc — 🔥 ruhig nachgelegt",
    fr: "Apple Inc — 🔥 ajouté calmement",
  },
  inviteHookAdd192: {
    ru: "Увеличил объём 🔥 по Apple Inc",
    en: "Increased size 🔥 on Apple Inc",
    es: "Aumenté el tamaño 🔥 en Apple Inc",
    pt: "Aumentei o tamanho 🔥 em Apple Inc",
    de: "Volumen bei 🔥 Apple Inc erhöht",
    fr: "Taille augmentée 🔥 sur Apple Inc",
  },
  inviteHookAdd193: {
    ru: "Добавил ещё 🔥 часть в Apple Inc",
    en: "Added another 🔥 slice in Apple Inc",
    es: "Agregué otra 🔥 parte en Apple Inc",
    pt: "Adicionei mais uma 🔥 parte em Apple Inc",
    de: "Weitere Teilposition bei 🔥 Apple Inc hinzugefügt",
    fr: "Ajouté une autre 🔥 part sur Apple Inc",
  },
  inviteHookAdd194: {
    ru: "Apple Inc — 🔥 продолжаю наращивать",
    en: "Apple Inc — 🔥 continuing to build",
    es: "Apple Inc — 🔥 sigo acumulando",
    pt: "Apple Inc — 🔥 sigo reforçando",
    de: "Apple Inc — 🔥 baue weiter aus",
    fr: "Apple Inc — je 🔥 continue à renforcer",
  },
  inviteHookAdd195: {
    ru: "Apple Inc — 🔥 небольшое добавление",
    en: "Apple Inc 🔥 — small add",
    es: "Apple Inc — 🔥 pequeña suma",
    pt: "Apple Inc — 🔥 pequeno reforço",
    de: "Apple Inc — 🔥 kleiner Nachkauf",
    fr: "Apple Inc — 🔥 petit ajout",
  },
  inviteHookAdd196: {
    ru: "Apple Inc 🔥 — увеличил",
    en: "Apple Inc 🔥 — increased",
    es: "Apple Inc 🔥 — aumenté",
    pt: "Apple Inc 🔥 — aumentei",
    de: "Apple Inc 🔥 — erhöht",
    fr: "Apple Inc 🔥 — augmenté",
  },
  inviteHookAdd197: {
    ru: "Apple Inc — 🔥 немного добавил",
    en: "Apple Inc — 🔥 added a little",
    es: "Apple Inc — 🔥 agregué un poco",
    pt: "Apple Inc — 🔥 adicionei um pouco",
    de: "Apple Inc — 🔥 etwas nachgelegt",
    fr: "Apple Inc — 🔥 ajouté un peu",
  },
  inviteHookAdd198: {
    ru: "Расширил позицию 🔥 по Apple Inc",
    en: "Expanded the 🔥 Apple Inc position",
    es: "Amplié la posición 🔥 en Apple Inc",
    pt: "Expandi a posição 🔥 em Apple Inc",
    de: "Position bei 🔥 Apple Inc erweitert",
    fr: "Position élargie 🔥 sur Apple Inc",
  },
  inviteHookAdd199: {
    ru: "Apple Inc — 🔥 добавил спокойно",
    en: "Apple Inc — 🔥 added calmly",
    es: "Apple Inc — 🔥 agregué con calma",
    pt: "Apple Inc — 🔥 adicionei com calma",
    de: "Apple Inc — 🔥 ruhig nachgelegt",
    fr: "Apple Inc — 🔥 ajouté calmement",
  },
  inviteHookAdd200: {
    ru: "Нарастил размер 🔥 по Apple Inc",
    en: "Scaled up 🔥 Apple Inc",
    es: "Aumenté el tamaño 🔥 en Apple Inc",
    pt: "Aumentei o tamanho 🔥 em Apple Inc",
    de: "Größe bei 🔥 Apple Inc erhöht",
    fr: "Taille augmentée 🔥 sur Apple Inc",
  },
  inviteHookSecondTitleAdd1: {
    ru: "Сетап всё ещё выглядит уверенно",
    en: "The setup still looks solid",
    es: "El setup sigue sólido",
    pt: "O setup continua firme",
    de: "Das Setup bleibt stark",
    fr: "Le setup reste solide",
  },
  inviteHookSecondTitleAdd2: {
    ru: "Скоро узнаем, оправдает ли",
    en: "We’ll know soon if it pays off",
    es: "Pronto sabremos si resultó bien",
    pt: "Logo saberemos se deu certo",
    de: "Bald wissen wir, ob es funktioniert hat",
    fr: "On saura bientôt si c’était la bonne décision",
  },
  inviteHookSecondTitleAdd3: {
    ru: "Если всё по плану — движение будет",
    en: "If the plan holds — the move should come",
    es: "Si todo sigue el plan, el movimiento llegará",
    pt: "Se tudo seguir o plano, o movimento vem",
    de: "Wenn alles nach Plan läuft, kommt die Bewegung",
    fr: "Si tout se déroule selon le plan, le mouvement viendra",
  },
  inviteHookSecondTitleAdd4: {
    ru: "Уверенность та же",
    en: "Conviction unchanged",
    es: "La convicción sigue igual",
    pt: "Convicção intacta",
    de: "Überzeugung unverändert",
    fr: "Conviction intacte",
  },
  inviteHookSecondTitleAdd5: {
    ru: "Движение всё ещё нравится",
    en: "Still liking this move",
    es: "Este movimiento todavía me gusta",
    pt: "Ainda gosto desse movimento",
    de: "Gefällt mir immer noch dieser Move",
    fr: "J’aime toujours ce move",
  },
  inviteHookSecondTitleAdd6: {
    ru: "Немного добрал",
    en: "I built up a bit more",
    es: "Agregué un poco más",
    pt: "Aumentei um pouco mais",
    de: "Habe etwas mehr aufgebaut",
    fr: "J’ai accumulé un peu plus",
  },
  inviteHookSecondTitleAdd7: {
    ru: "Слегка увеличил",
    en: "Topped up slightly",
    es: "Aumenté ligeramente",
    pt: "Acrescentei levemente",
    de: "Leicht nachgelegt",
    fr: "Petit renfort",
  },
  inviteHookSecondTitleAdd8: {
    ru: "Всё в рамках плана",
    en: "Staying within the plan",
    es: "Todo dentro del plan",
    pt: "Tudo dentro do plano",
    de: "Alles im Plan",
    fr: "Tout reste dans le plan",
  },
  inviteHookSecondTitleAdd9: {
    ru: "Добавил аккуратно",
    en: "Added modestly",
    es: "Añadí con calma",
    pt: "Adicionei com calma",
    de: "Ruhig hinzugefügt",
    fr: "Petit ajout tranquille",
  },
  inviteHookSecondTitleAdd10: {
    ru: "Режим терпения",
    en: "Patience on",
    es: "Modo paciencia",
    pt: "Modo paciência",
    de: "Geduldsmodus an",
    fr: "Mode patience activé",
  },
  inviteHookSecondTitleAdd11: {
    ru: "Снова немного докупил",
    en: "Scaled in again",
    es: "Volví a sumar",
    pt: "Entrei novamente",
    de: "Wieder etwas eingestiegen",
    fr: "J’ai repris un peu",
  },
  inviteHookSecondTitleAdd12: {
    ru: "Риск под контролем",
    en: "Risk still controlled",
    es: "El riesgo sigue controlado",
    pt: "Risco sob controle",
    de: "Risiko unter Kontrolle",
    fr: "Risque toujours contrôlé",
  },
  inviteHookSecondTitleAdd13: {
    ru: "То же направление, тот же план",
    en: "Same direction, same plan",
    es: "Mismo rumbo, mismo plan",
    pt: "Mesma direção, mesmo plano",
    de: "Gleiche Richtung, gleicher Plan",
    fr: "Même direction, même plan",
  },
  inviteHookSecondTitleAdd14: {
    ru: "Усилил позицию",
    en: "Built position further",
    es: "Aumenté posición",
    pt: "Aumentei posição",
    de: "Position weiter ausgebaut",
    fr: "Position augmentée",
  },
  inviteHookSecondTitleAdd15: {
    ru: "Узнаем, насколько точным оказался расчёт",
    en: "We’ll see how accurate the sizing was",
    es: "Veremos qué tan preciso fue el cálculo",
    pt: "Vamos ver o quão preciso foi o cálculo",
    de: "Mal sehen, wie genau die Einschätzung war",
    fr: "On verra si le calcul était juste",
  },
  inviteHookSecondTitleAdd16: {
    ru: "Воспользовался моментом, чтобы добавить",
    en: "Took the chance to add",
    es: "Aproveché para sumar",
    pt: "Aproveitei pra adicionar",
    de: "Gelegenheit genutzt zum Nachkaufen",
    fr: "Belle occasion d’ajouter",
  },
  inviteHookSecondTitleAdd17: {
    ru: "Сделка по убеждению, не по эмоциям",
    en: "Conviction trade, not emotion",
    es: "Operación por convicción, no emoción",
    pt: "Trade de convicção, sem emoção",
    de: "Überzeugungstrade, keine Emotion",
    fr: "Trade de conviction, pas d’émotion",
  },
  inviteHookSecondTitleAdd18: {
    ru: "Добавил спокойно",
    en: "Quietly added",
    es: "Agregué tranquilo",
    pt: "Adicionei tranquilo",
    de: "Ruhig nachgelegt",
    fr: "Ajout discret",
  },
  inviteHookSecondTitleAdd19: {
    ru: "Всё выглядит логично, но время покажет",
    en: "Looks logical, but time will tell",
    es: "Se ve lógico, pero el tiempo dirá",
    pt: "Parece lógico, mas o tempo vai dizer",
    de: "Sieht logisch aus, aber die Zeit wird’s zeigen",
    fr: "Logique sur le papier, mais le temps dira",
  },
  inviteHookSecondTitleAdd20: {
    ru: "Осталось дождаться, подтвердит ли движение",
    en: "Now it’s about waiting for confirmation",
    es: "Ahora toca esperar la confirmación",
    pt: "Agora é esperar a confirmação",
    de: "Jetzt heißt es, auf die Bestätigung warten",
    fr: "Il ne reste plus qu’à attendre la confirmation",
  },
  inviteHookSecondTitleAdd21: {
    ru: "Посмотрим, оправдает ли себя добавка",
    en: "Let’s see if the add pays off",
    es: "Veamos si esta suma vale la pena",
    pt: "Vamos ver se esse reforço compensa",
    de: "Weiter aufgestockt. Mal sehen, ob sich der Zukauf auszahlt",
    fr: "On va voir si ce renfort en vaut la peine",
  },
  inviteHookSecondTitleAdd22: {
    ru: "Всё в рамках плана",
    en: "Staying within the plan",
    es: "Todo dentro del plan",
    pt: "Tudo dentro do plano",
    de: "Alles im Plan",
    fr: "Tout reste dans le plan",
  },
  inviteHookSecondTitleAdd23: {
    ru: "Сохраняя баланс риска",
    en: "Keeping exposure balanced",
    es: "Manteniendo el balance",
    pt: "Mantendo o equilíbrio",
    de: "Balance gewahrt",
    fr: "Exposition équilibrée",
  },
  inviteHookSecondTitleAdd24: {
    ru: "Всё по плану",
    en: "Still within plan",
    es: "Todo según plan",
    pt: "Tudo dentro do plano",
    de: "Alles nach Plan",
    fr: "Toujours dans le plan",
  },
  inviteHookSecondTitleAdd25: {
    ru: "Всё ещё думаю: да",
    en: "Still thinking: yes",
    es: "Sigo pensando: sí",
    pt: "Ainda pensando: sim",
    de: "Denke immer noch: ja",
    fr: "Je pense encore : oui",
  },
  inviteHookSecondTitleAdd26: {
    ru: "Без суеты, размеренно",
    en: "No rush, steady",
    es: "Sin apuro, con calma",
    pt: "Sem pressa, com calma",
    de: "Kein Stress, ruhig geblieben",
    fr: "Tranquille, sans stress",
  },
  inviteHookSecondTitleAdd27: {
    ru: "Шаг второй завершён, дальше терпение",
    en: "Step two done, now patience",
    es: "Segundo paso completado, ahora paciencia",
    pt: "Segundo passo feito, agora paciência",
    de: "Zweiter Schritt abgeschlossen, jetzt Geduld",
    fr: "Deuxième étape terminée, maintenant patience",
  },
  inviteHookSecondTitleAdd28: {
    ru: "Следую плану",
    en: "Sticking to the plan",
    es: "Siguiendo el plan",
    pt: "Seguindo o plano",
    de: "Bleibe beim Plan",
    fr: "Plan respecté",
  },
  inviteHookSecondTitleAdd29: {
    ru: "Добавка — часть привычного ритма",
    en: "The add is part of the usual rhythm",
    es: "La suma es parte del ritmo habitual",
    pt: "A adição é parte do ritmo habitual",
    de: "Nachkauf ist Teil des gewohnten Ablaufs",
    fr: "L’ajout fait partie du rythme habituel",
  },
  inviteHookSecondTitleAdd30: {
    ru: "Усилил позицию по Apple Inc",
    en: "Built Apple Inc position higher",
    es: "Aumenté posición en Apple Inc",
    pt: "Aumentei posição em Apple Inc",
    de: "Position in Apple Inc weiter aufgebaut",
    fr: "Position Apple Inc renforcée",
  },
  inviteHookSecondTitleAdd31: {
    ru: "Повторяю стандартный цикл",
    en: "Repeating the standard cycle",
    es: "Repitiendo el ciclo habitual",
    pt: "Repetindo o ciclo padrão",
    de: "Wiederhole den Standardzyklus",
    fr: "Je répète le cycle habituel",
  },
  inviteHookSecondTitleAdd32: {
    ru: "Уверенность прежняя",
    en: "Confidence intact",
    es: "La confianza intacta",
    pt: "Confiança intacta",
    de: "Vertrauen bleibt",
    fr: "Confiance intacte",
  },
  inviteHookSecondTitleAdd33: {
    ru: "Второй шаг стратегии, как и всегда",
    en: "Second step of the strategy, as always",
    es: "Segundo paso de la estrategia, como siempre",
    pt: "Segundo passo da estratégia, como sempre",
    de: "Zweiter Schritt der Strategie, wie immer",
    fr: "Deuxième étape de la stratégie, comme toujours",
  },
  inviteHookSecondTitleAdd34: {
    ru: "Без спешки",
    en: "No rush moves",
    es: "Sin prisa",
    pt: "Sem pressa",
    de: "Kein Stress",
    fr: "Sans précipitation",
  },
  inviteHookSecondTitleAdd35: {
    ru: "Всё по плану",
    en: "All according to plan",
    es: "Todo según el plan",
    pt: "Tudo conforme o plano",
    de: "Alles nach Plan",
    fr: "Tout selon le plan",
  },
  inviteHookSecondTitleAdd36: {
    ru: "Риск под контролем — действую дозировано",
    en: "Risk controlled — scaling in measured steps",
    es: "Riesgo bajo control — actuando con medida",
    pt: "Risco controlado — operando de forma dosada",
    de: "Risiko unter Kontrolle — handle dosiert",
    fr: "Risque sous contrôle — approche mesurée",
  },
  inviteHookSecondTitleAdd37: {
    ru: "Сохраняю баланс между риском и потенциалом",
    en: "Keeping the balance between risk and potential",
    es: "Manteniendo el equilibrio entre riesgo y potencial",
    pt: "Mantendo o equilíbrio entre risco e potencial",
    de: "Balance zwischen Risiko und Potenzial bleibt erhalten",
    fr: "Équilibre entre risque et potentiel maintenu",
  },
  inviteHookSecondTitleAdd38: {
    ru: "Проверенная схема — ничего нового",
    en: "Same proven play — nothing new",
    es: "Esquema probado — nada nuevo",
    pt: "Esquema testado — nada novo",
    de: "Bewährtes Muster — nichts Neues",
    fr: "Schéma éprouvé — rien de nouveau",
  },
  inviteHookSecondTitleAdd39: {
    ru: "План без изменений",
    en: "Plan unchanged",
    es: "El plan no cambia",
    pt: "Plano segue igual",
    de: "Plan unverändert",
    fr: "Plan inchangé",
  },
  inviteHookSecondTitleAdd40: {
    ru: "Опыт показывает — добавка оправдана",
    en: "Experience says the add is justified",
    es: "La experiencia dice que esta suma está justificada",
    pt: "A experiência mostra que essa adição é justificável",
    de: "Erfahrung zeigt, dass der Zukauf sinnvoll ist",
    fr: "L’expérience montre que ce renfort est justifié",
  },
  inviteHookSecondTitleAdd41: {
    ru: "Этот приём работает стабильно",
    en: "This play tends to work consistently",
    es: "Este método suele funcionar de forma constante",
    pt: "Esse método costuma funcionar com consistência",
    de: "Diese Methode funktioniert konstant",
    fr: "Cette méthode fonctionne de façon constante",
  },
  inviteHookSecondTitleAdd42: {
    ru: "Сохраняю ритм",
    en: "Rhythm continues",
    es: "Manteniendo ritmo",
    pt: "Mantendo o ritmo",
    de: "Rhythmus bleibt",
    fr: "Rythme maintenu",
  },
  inviteHookSecondTitleAdd43: {
    ru: "Уже не раз проверено — второй вход даёт эффект",
    en: "Proven before — second entry helps",
    es: "Ya probado — la segunda entrada ayuda",
    pt: "Já testado — a segunda entrada ajuda",
    de: "Schon getestet — zweiter Einstieg hilft",
    fr: "Déjà testé — le deuxième achat aide",
  },
  inviteHookSecondTitleAdd44: {
    ru: "Снова захожу с уверенностью",
    en: "I’m leaning in again",
    es: "Volví a entrar con confianza",
    pt: "Entrei de novo com confiança",
    de: "Erneut eingestiegen",
    fr: "Je renforce encore",
  },
  inviteHookSecondTitleAdd45: {
    ru: "Всё согласно алгоритму",
    en: "All according to the algorithm",
    es: "Todo según el algoritmo",
    pt: "Tudo conforme o algoritmo",
    de: "Alles nach Algorithmus",
    fr: "Tout selon l’algorithme",
  },
  inviteHookSecondTitleAdd46: {
    ru: "Следую структуре",
    en: "Following structure",
    es: "Siguiendo estructura",
    pt: "Seguindo a estrutura",
    de: "Struktur beibehalten",
    fr: "Structure respectée",
  },
  inviteHookSecondTitleAdd47: {
    ru: "Действую по системе",
    en: "Acting by the playbook",
    es: "Actúo según el método",
    pt: "Agindo conforme o método",
    de: "Handle nach Methode",
    fr: "J’agis selon la méthode",
  },
  inviteHookSecondTitleAdd48: {
    ru: "Как и всегда — не эмоция, а алгоритм",
    en: "As always — algorithm over emotion",
    es: "Como siempre — algoritmo antes que emoción",
    pt: "Como sempre — algoritmo antes da emoção",
    de: "Wie immer — System über Emotion",
    fr: "Comme toujours — algorithme avant émotion",
  },
  inviteHookSecondTitleAdd49: {
    ru: "Добавка по системе",
    en: "Add is by the system",
    es: "Suma según el sistema",
    pt: "Adição conforme o sistema",
    de: "Zukauf nach System",
    fr: "Ajout selon le système",
  },
  inviteHookSecondTitleAdd50: {
    ru: "Уверенность на месте",
    en: "Conviction steady",
    es: "Convicción firme",
    pt: "Convicção firme",
    de: "Überzeugung bleibt",
    fr: "Conviction stable",
  },
  inviteHookSecondTitleAdd51: {
    ru: "Была ли добавка своевременной?",
    en: "Was the add timely?",
    es: "¿Fue el momento justo para agregar?",
    pt: "Será que foi no momento certo?",
    de: "War der Moment richtig gewählt?",
    fr: "Était-ce le bon moment ?",
  },
  inviteHookSecondTitleAdd52: {
    ru: "Удержится ли?",
    en: "Will it hold?",
    es: "¿Se mantendrá?",
    pt: "Vai segurar?",
    de: "Wird sie halten?",
    fr: "Tiendra-t-elle ?",
  },
  inviteHookSecondTitleAdd53: {
    ru: "Позиция усилена — план продолжается",
    en: "Position reinforced — plan continues",
    es: "Posición fortalecida — el plan continúa",
    pt: "Posição reforçada — o plano continua",
    de: "Position gestärkt — Plan läuft weiter",
    fr: "Position renforcée — le plan continue",
  },
  inviteHookSecondTitleAdd54: {
    ru: "Контроль и дисциплина — главный инструмент",
    en: "Control and discipline are the main tools",
    es: "Control y disciplina son las claves",
    pt: "Controle e disciplina são as chaves",
    de: "Kontrolle und Disziplin sind die Schlüssel",
    fr: "Contrôle et discipline sont les clés",
  },
  inviteHookSecondTitleAdd55: {
    ru: "Без спешки, без сомнений",
    en: "No rush, no doubt",
    es: "Sin prisa, sin dudas",
    pt: "Sem pressa, sem dúvidas",
    de: "Ohne Eile, ohne Zweifel",
    fr: "Pas de précipitation, pas de doutes",
  },
  inviteHookSecondTitleAdd56: {
    ru: "Риск под контролем",
    en: "Keeping risk in check",
    es: "Riesgo bajo control",
    pt: "Risco controlado",
    de: "Risiko unter Kontrolle",
    fr: "Risque maîtrisé",
  },
  inviteHookSecondTitleAdd57: {
    ru: "Действую спокойно, без эмоций",
    en: "Acting calmly, no emotions",
    es: "Actúo con calma, sin emociones",
    pt: "Atuando com calma, sem emoção",
    de: "Handeln ruhig, ohne Emotionen",
    fr: "Agir calmement, sans émotions",
  },
  inviteHookSecondTitleAdd58: {
    ru: "Движение стабильное",
    en: "Steady move",
    es: "Movimiento estable",
    pt: "Movimento estável",
    de: "Ruhige Bewegung",
    fr: "Mouvement fluide",
  },
  inviteHookSecondTitleAdd59: {
    ru: "Терпение",
    en: "Patience",
    es: "Paciencia",
    pt: "Paciência",
    de: "Geduld",
    fr: "Patience",
  },
  inviteHookSecondTitleAdd60: {
    ru: "Тот же взгляд",
    en: "Same bias",
    es: "Misma idea",
    pt: "Mesma visão",
    de: "Gleiche Richtung",
    fr: "Même biais",
  },
  inviteHookSecondTitleAdd61: {
    ru: "Усилил экспозицию",
    en: "Reinforced exposure",
    es: "Reforcé exposición",
    pt: "Reforcei exposição",
    de: "Exposition verstärkt",
    fr: "Exposition renforcée",
  },
  inviteHookSecondTitleAdd62: {
    ru: "Добавляю плавно",
    en: "Scaled gently",
    es: "Sumando con calma",
    pt: "Adicionando de leve",
    de: "Sanft nachgelegt",
    fr: "Ajout doux",
  },
  inviteHookSecondTitleAdd63: {
    ru: "Решение принято — теперь жду подтверждения",
    en: "Decision made — now waiting for confirmation",
    es: "Decisión tomada — ahora espero confirmación",
    pt: "Decisão tomada — agora é esperar confirmação",
    de: "Entscheidung getroffen — warte jetzt auf Bestätigung",
    fr: "Décision prise — maintenant j’attends la confirmation",
  },
  inviteHookSecondTitleAdd64: {
    ru: "Картина визуально стала мощнее",
    en: "The picture looks stronger",
    es: "La imagen se ve más sólida",
    pt: "O cenário ficou mais forte visualmente",
    de: "Das Bild wirkt stärker",
    fr: "Le visuel est plus fort",
  },
  inviteHookSecondTitleAdd65: {
    ru: "Ритм сохранён, процесс идёт",
    en: "Rhythm intact, process ongoing",
    es: "Ritmo intacto, proceso en marcha",
    pt: "Ritmo mantido, processo em andamento",
    de: "Rhythmus stabil, Prozess läuft",
    fr: "Rythme intact, processus en cours",
  },
  inviteHookSecondTitleAdd66: {
    ru: "Второй шаг стратегии, как и всегда",
    en: "Second step of the strategy, as always",
    es: "Segundo paso de la estrategia, como siempre",
    pt: "Segundo passo da estratégia, como sempre",
    de: "Zweiter Schritt der Strategie, wie immer",
    fr: "Deuxième étape de la stratégie, comme toujours",
  },
  inviteHookSecondTitleAdd67: {
    ru: "Усилил позицию",
    en: "Built more",
    es: "Aumenté posición",
    pt: "Aumentei posição",
    de: "Mehr aufgebaut",
    fr: "Construit plus",
  },
  inviteHookSecondTitleAdd68: {
    ru: "Всё по плану",
    en: "All according to plan",
    es: "Todo según el plan",
    pt: "Tudo conforme o plano",
    de: "Alles nach Plan",
    fr: "Tout selon le plan",
  },
  inviteHookSecondTitleAdd69: {
    ru: "Контроль важнее азарта",
    en: "Control over excitement",
    es: "El control es más importante que la euforia",
    pt: "O controle é mais importante que a empolgação",
    de: "Kontrolle ist wichtiger als Euphorie",
    fr: "Le contrôle prime sur l’euphorie",
  },
  inviteHookSecondTitleAdd70: {
    ru: "Стремлюсь сохранить ритм",
    en: "Keeping the rhythm",
    es: "Manteniendo el ritmo",
    pt: "Mantendo o ritmo",
    de: "Rhythmus beibehalten",
    fr: "Garder le rythme",
  },
  inviteHookSecondTitleAdd71: {
    ru: "Главное — не перегрузить позицию",
    en: "Key is not to overload the position",
    es: "Lo importante es no sobrecargar la posición",
    pt: "O essencial é não sobrecarregar a posição",
    de: "Wichtig: Position nicht überladen",
    fr: "L’important est de ne pas surcharger la position",
  },
  inviteHookSecondTitleAdd72: {
    ru: "Немного усилил позицию",
    en: "I built a little more",
    es: "Sumé un poco más",
    pt: "Adicionei um pouco mais",
    de: "Etwas mehr gekauft",
    fr: "J’ai accumulé un peu plus",
  },
  inviteHookSecondTitleAdd73: {
    ru: "Проверенная схема — ничего нового",
    en: "Same proven play — nothing new",
    es: "Esquema probado — nada nuevo",
    pt: "Esquema testado — nada novo",
    de: "Bewährtes Muster — nichts Neues",
    fr: "Schéma éprouvé — rien de nouveau",
  },
  inviteHookSecondTitleAdd74: {
    ru: "Опыт показывает — добавка оправдана",
    en: "Experience says the add is justified",
    es: "La experiencia dice que esta suma está justificada",
    pt: "A experiência mostra que essa adição é justificável",
    de: "Erfahrung zeigt, dass der Zukauf sinnvoll ist",
    fr: "L’expérience montre que ce renfort est justifié",
  },
  inviteHookSecondTitleAdd75: {
    ru: "Этот приём работает стабильно",
    en: "This play tends to work consistently",
    es: "Este método suele funcionar de forma constante",
    pt: "Esse método costuma funcionar com consistência",
    de: "Diese Methode funktioniert konstant",
    fr: "Cette méthode fonctionne de façon constante",
  },
  inviteHookSecondTitleAdd76: {
    ru: "Уже не раз проверено — второй вход даёт эффект",
    en: "Proven before — second entry helps",
    es: "Ya probado — la segunda entrada ayuda",
    pt: "Já testado — a segunda entrada ajuda",
    de: "Schon getestet — zweiter Einstieg hilft",
    fr: "Déjà testé — le deuxième achat aide",
  },
  inviteHookSecondTitleAdd77: {
    ru: "План всё ещё в силе",
    en: "Plan still valid",
    es: "Plan sigue firme",
    pt: "Plano ainda válido",
    de: "Plan bleibt gültig",
    fr: "Plan toujours valide",
  },
  inviteHookSecondTitleAdd78: {
    ru: "Усилил слегка",
    en: "Reinforced lightly",
    es: "Reforcé ligeramente",
    pt: "Reforcei levemente",
    de: "Leicht verstärkt",
    fr: "Léger renfort",
  },
  inviteHookSecondTitleAdd79: {
    ru: "Уверенность прежняя",
    en: "Confidence unchanged",
    es: "Misma confianza",
    pt: "Confiança mantida",
    de: "Vertrauen unverändert",
    fr: "Confiance inchangée",
  },
  inviteHookSecondTitleAdd80: {
    ru: "Всё согласно алгоритму",
    en: "All according to the algorithm",
    es: "Todo según el algoritmo",
    pt: "Tudo conforme o algoritmo",
    de: "Alles nach Algorithmus",
    fr: "Tout selon l’algorithme",
  },
  inviteHookSecondTitleAdd81: {
    ru: "Добавляю обдуманно",
    en: "Scaled deliberately",
    es: "Añadiendo con calma",
    pt: "Adicionando com calma",
    de: "Gezielt aufgebaut",
    fr: "Ajout ciblé",
  },
  inviteHookSecondTitleAdd82: {
    ru: "Чётко по методу: контроль и последовательность",
    en: "Clean method: control and consistency",
    es: "Método claro: control y consistencia",
    pt: "Método limpo: controle e consistência",
    de: "Klare Methode: Kontrolle und Konstanz",
    fr: "Méthode claire : contrôle et constance",
  },
  inviteHookSecondTitleAdd83: {
    ru: "Следую правилу: усиливать только по плану",
    en: "Rule stands: scale only by plan",
    es: "Regla clara: aumentar solo según el plan",
    pt: "Regra clara: aumentar só conforme o plano",
    de: "Klare Regel: nur nach Plan vergrößern",
    fr: "Règle claire : n’augmenter que selon le plan",
  },
  inviteHookSecondTitleAdd84: {
    ru: "Добавка — часть системы, не исключение",
    en: "The add is part of the system, not an exception",
    es: "La suma es parte del sistema, no una excepción",
    pt: "A adição faz parte do sistema, não é exceção",
    de: "Zukauf ist Teil des Systems, keine Ausnahme",
    fr: "L’ajout fait partie du système, pas une exception",
  },
  inviteHookSecondTitleAdd85: {
    ru: "Та же идея в силе",
    en: "Same thesis holds",
    es: "Misma tesis se mantiene",
    pt: "Mesma tese se mantém",
    de: "Gleiche These bleibt",
    fr: "Même thèse maintenue",
  },
  inviteHookSecondTitleAdd86: {
    ru: "Действую по системе",
    en: "Acting by the playbook",
    es: "Actúo según el método",
    pt: "Agindo conforme o método",
    de: "Handle nach Methode",
    fr: "J’agis selon la méthode",
  },
  inviteHookSecondTitleAdd87: {
    ru: "Добавка по системе",
    en: "Add is by the system",
    es: "Suma según el sistema",
    pt: "Adição conforme o sistema",
    de: "Zukauf nach System",
    fr: "Ajout selon le système",
  },
  inviteHookSecondTitleAdd88: {
    ru: "Будет ли движение?",
    en: "Will we get the move?",
    es: "¿Vendrá el movimiento?",
    pt: "Vamos ver se o movimento vem",
    de: "Kommt jetzt die Bewegung?",
    fr: "Le mouvement viendra-t-il ?",
  },
  inviteHookSecondTitleAdd89: {
    ru: "Была ли добавка своевременной?",
    en: "Was the add timely?",
    es: "¿Fue el momento justo para agregar?",
    pt: "Será que foi no momento certo?",
    de: "War der Moment richtig gewählt?",
    fr: "Était-ce le bon moment ?",
  },
  inviteHookSecondTitleAdd90: {
    ru: "Посмотрим",
    en: "We’ll see",
    es: "Veremos",
    pt: "Vamos ver",
    de: "Wir werden sehen",
    fr: "On verra",
  },
  inviteHookSecondTitleAdd91: {
    ru: "Будет ли импульс вверх?",
    en: "Will we get an upside impulse?",
    es: "¿Habrá impulso al alza?",
    pt: "Teremos impulso pra cima?",
    de: "Kommt der Aufwärtsimpuls?",
    fr: "Y aura-t-il une impulsion haussière ?",
  },
  inviteHookSecondTitleAdd92: {
    ru: "Не слишком ли рано усилил?",
    en: "Did I scale too early?",
    es: "¿Demasiado pronto?",
    pt: "Será que entrei cedo demais?",
    de: "Vielleicht etwas zu früh verstärkt?",
    fr: "Ai-je renforcé trop tôt ?",
  },
  inviteHookSecondTitleAdd93: {
    ru: "Позиция усилена — план продолжается",
    en: "Position reinforced — plan continues",
    es: "Posición fortalecida — el plan continúa",
    pt: "Posição reforçada — o plano continua",
    de: "Position gestärkt — Plan läuft weiter",
    fr: "Position renforcée — le plan continue",
  },
  inviteHookSecondTitleAdd94: {
    ru: "Ситуация штатная, без сюрпризов",
    en: "Routine situation, no surprises",
    es: "Situación normal, sin sorpresas",
    pt: "Situação normal, sem surpresas",
    de: "Normale Situation, keine Überraschungen",
    fr: "Situation normale, pas de surprises",
  },
  inviteHookSecondTitleAdd95: {
    ru: "Без спешки, без сомнений",
    en: "No rush, no doubt",
    es: "Sin prisa, sin dudas",
    pt: "Sem pressa, sem dúvidas",
    de: "Ohne Eile, ohne Zweifel",
    fr: "Pas de précipitation, pas de doutes",
  },
  inviteHookSecondTitleAdd96: {
    ru: "Сохраняю ритм — всё как задумано",
    en: "Keeping the rhythm — exactly as planned",
    es: "Manteniendo el ritmo — todo como estaba planeado",
    pt: "Mantendo o ritmo — tudo como planejado",
    de: "Rhythmus beibehalten — alles wie geplant",
    fr: "Garder le rythme — tout selon le plan",
  },
  inviteHookSecondTitleAdd97: {
    ru: "Просто шаг по стратегии, ничего лишнего",
    en: "Just a system step, nothing extra",
    es: "Solo un paso del sistema, nada más",
    pt: "Apenas mais um passo do sistema",
    de: "Nur ein Systemschritt, nichts weiter",
    fr: "Juste une étape du système",
  },
  inviteHookSecondTitleAdd98: {
    ru: "Действую спокойно, без эмоций",
    en: "Acting calmly, no emotions",
    es: "Actúo con calma, sin emociones",
    pt: "Atuando com calma, sem emoção",
    de: "Handeln ruhig, ohne Emotionen",
    fr: "Agir calmement, sans émotions",
  },
  inviteHookSecondTitleAdd99: {
    ru: "Уверенность растёт вместе с неопределённостью",
    en: "Confidence grows along with uncertainty",
    es: "La confianza crece junto con la incertidumbre",
    pt: "A confiança cresce junto com a incerteza",
    de: "Vertrauen wächst trotz Unsicherheit",
    fr: "La confiance grandit avec l’incertitude",
  },
  inviteHookSecondTitleAdd100: {
    ru: "Нарастил размер с уверенностью",
    en: "Built size with calm conviction",
    es: "Aumenté tamaño con confianza",
    pt: "Aumentei tamanho com confiança",
    de: "Position ruhig mit Überzeugung erweitert",
    fr: "Taille augmentée avec calme et conviction",
  },
  inviteHookSecondTitleAdd101: {
    ru: "Посмотрим, оправдает ли себя добавка",
    en: "Let’s see if the add pays off",
    es: "Veamos si esta suma vale la pena",
    pt: "Vamos ver se esse reforço compensa",
    de: "Weiter aufgestockt. Mal sehen, ob sich der Zukauf auszahlt",
    fr: "On va voir si ce renfort en vaut la peine",
  },
  inviteHookSecondTitleAdd102: {
    ru: "Интересно, даст ли это ускорение",
    en: "Curious if this gives it some acceleration",
    es: "Curioso por ver si esto le da impulso",
    pt: "Curioso pra ver se isso dá mais impulso",
    de: "Vergrößert. Bin gespannt, ob das etwas mehr Schwung bringt",
    fr: "Curieux de voir si ça donne plus de momentum",
  },
  inviteHookSecondTitleAdd103: {
    ru: "Теперь наблюдаю, как поведёт себя рынок",
    en: "Now watching how the market reacts",
    es: "Ahora observo cómo reacciona el mercado",
    pt: "Agora é observar como o mercado reage",
    de: "Jetzt beobachte ich, wie der Markt reagiert",
    fr: "Maintenant, j’observe comment le marché réagit",
  },
  inviteHookSecondTitleAdd104: {
    ru: "Проверим, был ли момент выбран правильно",
    en: "We’ll see if the timing was right",
    es: "Veremos si el momento fue el correcto",
    pt: "Vamos ver se o momento foi o certo",
    de: "Schauen wir, ob das Timing gepasst hat",
    fr: "On verra si le timing était le bon",
  },
  inviteHookSecondTitleAdd105: {
    ru: "Осталось дождаться, подтвердит ли движение",
    en: "Now it’s about waiting for confirmation",
    es: "Ahora toca esperar la confirmación",
    pt: "Agora é esperar a confirmação",
    de: "Jetzt heißt es, auf die Bestätigung warten",
    fr: "Il ne reste plus qu’à attendre la confirmation",
  },
  inviteHookSecondTitleAdd106: {
    ru: "Возможно, именно отсюда начнётся импульс",
    en: "Maybe the impulse starts right here",
    es: "Tal vez desde aquí comience el impulso",
    pt: "Talvez o impulso comece daqui",
    de: "Vielleicht startet von hier der Impuls",
    fr: "Peut-être que l’impulsion démarre d’ici",
  },
  inviteHookSecondTitleAdd107: {
    ru: "Всё выглядит логично, но время покажет",
    en: "Looks logical, but time will tell",
    es: "Se ve lógico, pero el tiempo dirá",
    pt: "Parece lógico, mas o tempo vai dizer",
    de: "Sieht logisch aus, aber die Zeit wird’s zeigen",
    fr: "Logique sur le papier, mais le temps dira",
  },
  inviteHookSecondTitleAdd108: {
    ru: "Посмотрим, добавка усилила ли позицию",
    en: "Let’s see if the add strengthened the setup",
    es: "Veremos si el aumento fortaleció el setup",
    pt: "Vamos ver se o reforço fortaleceu o setup",
    de: "Mal sehen, ob der Nachkauf die Struktur stärkt",
    fr: "Voyons si ce renfort renforce vraiment le setup",
  },
  inviteHookSecondTitleAdd109: {
    ru: "Жду реакции — будет ли развитие или откат",
    en: "Waiting for the read — continuation or pullback",
    es: "Esperando la reacción — ¿continuación o retroceso?",
    pt: "Aguardando a reação — continuação ou correção?",
    de: "Warte auf die Reaktion — Fortsetzung oder Rücksetzer?",
    fr: "En attente de la réaction — continuation ou correction ?",
  },
  inviteHookSecondTitleAdd110: {
    ru: "Узнаем, насколько точным оказался расчёт",
    en: "We’ll see how accurate the sizing was",
    es: "Veremos qué tan preciso fue el cálculo",
    pt: "Vamos ver o quão preciso foi o cálculo",
    de: "Mal sehen, wie genau die Einschätzung war",
    fr: "On verra si le calcul était juste",
  },
  inviteHookSecondTitleAdd111: {
    ru: "Через время станет ясно, стоило ли усиливать",
    en: "With time it’ll be clear if the add made sense",
    es: "Con el tiempo sabremos si valió la pena",
    pt: "Com o tempo vai dar pra saber se valeu a pena",
    de: "Mit der Zeit wird klar, ob sich der Zukauf gelohnt hat",
    fr: "Le temps dira si ce mouvement valait le coup",
  },
  inviteHookSecondTitleAdd112: {
    ru: "Скоро узнаем, оправдает ли",
    en: "We’ll know soon if it pays off",
    es: "Pronto sabremos si resultó bien",
    pt: "Logo saberemos se deu certo",
    de: "Bald wissen wir, ob es funktioniert hat",
    fr: "On saura bientôt si c’était la bonne décision",
  },
  inviteHookSecondTitleAdd113: {
    ru: "Если всё по плану — движение будет",
    en: "If the plan holds — the move should come",
    es: "Si todo sigue el plan, el movimiento llegará",
    pt: "Se tudo seguir o plano, o movimento vem",
    de: "Wenn alles nach Plan läuft, kommt die Bewegung",
    fr: "Si tout se déroule selon le plan, le mouvement viendra",
  },
  inviteHookSecondTitleAdd114: {
    ru: "Проверю, как быстро отработает дополнительный вход",
    en: "I’ll watch how fast the second entry plays out",
    es: "Veré qué tan rápido funciona esta entrada adicional",
    pt: "Vou observar quão rápido o segundo trade reage",
    de: "Beobachte, wie schnell der zweite Einstieg wirkt",
    fr: "Je vais voir à quelle vitesse le deuxième trade agit",
  },
  inviteHookSecondTitleAdd115: {
    ru: "В ближайшие дни рынок всё расставит по местам",
    en: "Over the next few days the market will sort it out",
    es: "En los próximos días el mercado pondrá todo en su lugar",
    pt: "Nos próximos dias o mercado vai colocar tudo no lugar",
    de: "In den nächsten Tagen wird der Markt alles einordnen",
    fr: "Dans les prochains jours, le marché mettra les choses en ordre",
  },
  inviteHookSecondTitleAdd116: {
    ru: "Скоро увижу, насколько был точен расчёт",
    en: "I’ll soon see how precise the read was",
    es: "Pronto sabré qué tan preciso fue el movimiento",
    pt: "Logo vou ver quão precisa foi a leitura",
    de: "Bald sehe ich, wie präzise die Einschätzung war",
    fr: "On verra bientôt si la lecture était bonne",
  },
  inviteHookSecondTitleAdd117: {
    ru: "Если сетап устойчив, добавка принесёт эффект",
    en: "If the setup is solid, the add should help",
    es: "Si el setup es sólido, el aumento traerá efecto",
    pt: "Se o setup for sólido, o reforço deve funcionar",
    de: "Wenn das Setup stabil ist, bringt der Zukauf Wirkung",
    fr: "Si le setup est solide, ce renfort devrait porter ses fruits",
  },
  inviteHookSecondTitleAdd118: {
    ru: "Терпение покажет, кто был прав",
    en: "Patience will show who’s right",
    es: "La paciencia dirá quién tenía razón",
    pt: "A paciência vai mostrar quem está certo",
    de: "Geduld wird zeigen, wer recht hat",
    fr: "La patience dira qui avait raison",
  },
  inviteHookSecondTitleAdd119: {
    ru: "Через немного времени всё станет очевидно",
    en: "Give it a little time and it’ll be obvious",
    es: "En poco tiempo todo quedará claro",
    pt: "Daqui a pouco tudo fica claro",
    de: "Bald wird alles klarer",
    fr: "Bientôt tout sera clair",
  },
  inviteHookSecondTitleAdd120: {
    ru: "Вскоре узнаем, насколько шаг был своевременным",
    en: "We’ll soon see how timely the move was",
    es: "Pronto veremos qué tan oportuno fue el paso",
    pt: "Em breve veremos se o movimento foi oportuno",
    de: "Bald sehen wir, ob der Schritt gut getimt war",
    fr: "On verra bientôt si le timing était juste",
  },
  inviteHookSecondTitleAdd121: {
    ru: "Давление ощущается сильнее",
    en: "The pressure is more noticeable",
    es: "Se siente más presión",
    pt: "A pressão ficou mais evidente",
    de: "Der Druck ist spürbarer",
    fr: "La pression se fait sentir",
  },
  inviteHookSecondTitleAdd122: {
    ru: "Терпение",
    en: "Patience",
    es: "Paciencia",
    pt: "Paciência",
    de: "Geduld",
    fr: "Patience",
  },
  inviteHookSecondTitleAdd123: {
    ru: "Атмосфера уверенная, рынок дышит ритмично",
    en: "Confident tone, market breathing steadily",
    es: "El ambiente se siente firme, el mercado respira con ritmo",
    pt: "O ambiente está confiante, o mercado respira no ritmo certo",
    de: "Stimmung ruhig, Markt atmet gleichmäßig",
    fr: "L’ambiance est confiante, le marché respire calmement",
  },
  inviteHookSecondTitleAdd124: {
    ru: "Движение набирает вес, фон стал живее",
    en: "The move’s gaining weight, backdrop livelier",
    es: "El movimiento gana fuerza, el entorno está más vivo",
    pt: "O movimento ganha peso, o cenário está mais vivo",
    de: "Bewegung nimmt zu, Dynamik kehrt zurück",
    fr: "Le mouvement prend du poids, le contexte s’anime",
  },
  inviteHookSecondTitleAdd125: {
    ru: "Всё ощущается напряжённее, но в рамках плана",
    en: "Feels more tense, but still within plan",
    es: "Se siente más tensión, pero dentro del plan",
    pt: "Está mais tenso, mas dentro do plano",
    de: "Etwas mehr Spannung, aber im Plan",
    fr: "Plus de tension, mais toujours dans le plan",
  },
  inviteHookSecondTitleAdd126: {
    ru: "Чувствуется импульс, пока без резких всплесков",
    en: "Momentum is there, no sharp spikes yet",
    es: "Se nota el impulso, sin picos bruscos todavía",
    pt: "Dá pra sentir o impulso, sem picos bruscos ainda",
    de: "Momentum spürbar, aber keine heftigen Ausschläge",
    fr: "On sent l’impulsion, pas encore de mouvements brusques",
  },
  inviteHookSecondTitleAdd127: {
    ru: "Картина визуально стала мощнее",
    en: "The picture looks stronger",
    es: "La imagen se ve más sólida",
    pt: "O cenário ficou mais forte visualmente",
    de: "Das Bild wirkt stärker",
    fr: "Le visuel est plus fort",
  },
  inviteHookSecondTitleAdd128: {
    ru: "Баланс ощущается устойчивым",
    en: "Balance still feels stable",
    es: "El equilibrio se mantiene estable",
    pt: "O equilíbrio segue estável",
    de: "Balance bleibt stabil",
    fr: "L’équilibre reste stable",
  },
  inviteHookSecondTitleAdd129: {
    ru: "Тело рынка стало плотнее, как перед рывком",
    en: "The tape’s thicker, like before a push",
    es: "El mercado se compacta, como antes de un movimiento fuerte",
    pt: "O mercado ficou mais denso, parece prestes a explodir",
    de: "Markt wirkt dichter, fast bereit für einen Schub",
    fr: "Le marché devient plus dense, prêt à bouger",
  },
  inviteHookSecondTitleAdd130: {
    ru: "Чувствуется динамика — структура дышит",
    en: "The momentum is felt — the structure is breathing",
    es: "Se percibe la dinámica — la estructura respira",
    pt: "Sente-se a dinâmica — a estrutura está respirando",
    de: "Die Dynamik ist spürbar — die Struktur atmet",
    fr: "La dynamique se ressent — la structure respire",
  },
  inviteHookSecondTitleAdd131: {
    ru: "Всё по плану",
    en: "Still within plan",
    es: "Todo según plan",
    pt: "Tudo dentro do plano",
    de: "Alles nach Plan",
    fr: "Toujours dans le plan",
  },
  inviteHookSecondTitleAdd132: {
    ru: "Всё по плану, хотя фон немного нервный",
    en: "All by plan, though the backdrop’s a bit nervous",
    es: "Todo según el plan, aunque el entorno está algo nervioso",
    pt: "Tudo conforme o plano, mesmo com o cenário um pouco nervoso",
    de: "Alles nach Plan, auch wenn die Stimmung etwas nervös ist",
    fr: "Tout selon le plan, même si le contexte est tendu",
  },
  inviteHookSecondTitleAdd133: {
    ru: "Уверенность есть",
    en: "Confidence is there",
    es: "Hay confianza",
    pt: "Confiança total",
    de: "Vertrauen ist da",
    fr: "Confiance présente",
  },
  inviteHookSecondTitleAdd134: {
    ru: "Решение принято — теперь жду подтверждения",
    en: "Decision made — now waiting for confirmation",
    es: "Decisión tomada — ahora espero confirmación",
    pt: "Decisão tomada — agora é esperar confirmação",
    de: "Entscheidung getroffen — warte jetzt auf Bestätigung",
    fr: "Décision prise — maintenant j’attends la confirmation",
  },
  inviteHookSecondTitleAdd135: {
    ru: "Ситуация сильная, но момент тонкий",
    en: "Strong context, but timing is delicate",
    es: "Contexto fuerte, pero el momento es delicado",
    pt: "Contexto forte, mas o momento é delicado",
    de: "Starke Lage, aber sensibler Moment",
    fr: "Contexte fort, mais moment délicat",
  },
  inviteHookSecondTitleAdd136: {
    ru: "Немного увеличил",
    en: "Added a little",
    es: "Agregué un poco",
    pt: "Adicionei um pouco",
    de: "Leicht aufgestockt",
    fr: "Petit ajout",
  },
  inviteHookSecondTitleAdd137: {
    ru: "Терпение",
    en: "Patience",
    es: "Paciencia",
    pt: "Paciência",
    de: "Geduld",
    fr: "Patience",
  },
  inviteHookSecondTitleAdd138: {
    ru: "Риск вырос, зато структура чище",
    en: "Risk is higher, but the structure’s cleaner",
    es: "El riesgo sube, pero la estructura está más clara",
    pt: "O risco subiu, mas a estrutura está mais limpa",
    de: "Risiko gestiegen, aber Struktur klarer",
    fr: "Le risque monte, mais la structure est plus claire",
  },
  inviteHookSecondTitleAdd139: {
    ru: "Все логично, но контроль обязателен",
    en: "Logic is there, but risk control is a must",
    es: "Todo lógico, pero el control del riesgo es clave",
    pt: "Tudo faz sentido, mas o controle de risco é essencial",
    de: "Alles logisch, aber Risikokontrolle bleibt Pflicht",
    fr: "Tout logique, mais la gestion du risque reste clé",
  },
  inviteHookSecondTitleAdd140: {
    ru: "Уверенность растёт вместе с неопределённостью",
    en: "Confidence grows along with uncertainty",
    es: "La confianza crece junto con la incertidumbre",
    pt: "A confiança cresce junto com a incerteza",
    de: "Vertrauen wächst trotz Unsicherheit",
    fr: "La confiance grandit avec l’incertitude",
  },
  inviteHookSecondTitleAdd141: {
    ru: "Всё под контролем, план выполняется",
    en: "Under control, plan on track",
    es: "Todo bajo control, el plan sigue firme",
    pt: "Tudo sob controle, o plano segue firme",
    de: "Alles unter Kontrolle, Plan läuft",
    fr: "Tout sous contrôle, plan en cours",
  },
  inviteHookSecondTitleAdd142: {
    ru: "Действую спокойно, без эмоций",
    en: "Acting calmly, no emotions",
    es: "Actúo con calma, sin emociones",
    pt: "Atuando com calma, sem emoção",
    de: "Handeln ruhig, ohne Emotionen",
    fr: "Agir calmement, sans émotions",
  },
  inviteHookSecondTitleAdd143: {
    ru: "Просто шаг по стратегии, ничего лишнего",
    en: "Just a system step, nothing extra",
    es: "Solo un paso del sistema, nada más",
    pt: "Apenas mais um passo do sistema",
    de: "Nur ein Systemschritt, nichts weiter",
    fr: "Juste une étape du système",
  },
  inviteHookSecondTitleAdd144: {
    ru: "Терпеливо жду реакции рынка",
    en: "Patiently waiting for the market’s response",
    es: "Espero con paciencia la reacción del mercado",
    pt: "Aguardando pacientemente a resposta do mercado",
    de: "Geduldig auf Marktreaktion warten",
    fr: "J’attends patiemment la réaction du marché",
  },
  inviteHookSecondTitleAdd145: {
    ru: "Сохраняю ритм — всё как задумано",
    en: "Keeping the rhythm — exactly as planned",
    es: "Manteniendo el ritmo — todo como estaba planeado",
    pt: "Mantendo o ritmo — tudo como planejado",
    de: "Rhythmus beibehalten — alles wie geplant",
    fr: "Garder le rythme — tout selon le plan",
  },
  inviteHookSecondTitleAdd146: {
    ru: "Решение взвешено, теперь тишина",
    en: "Measured decision, now silence",
    es: "Decisión medida, ahora silencio",
    pt: "Decisão ponderada, agora silêncio",
    de: "Überlegter Schritt, jetzt Ruhe",
    fr: "Décision réfléchie, maintenant silence",
  },
  inviteHookSecondTitleAdd147: {
    ru: "Без спешки, без сомнений",
    en: "No rush, no doubt",
    es: "Sin prisa, sin dudas",
    pt: "Sem pressa, sem dúvidas",
    de: "Ohne Eile, ohne Zweifel",
    fr: "Pas de précipitation, pas de doutes",
  },
  inviteHookSecondTitleAdd148: {
    ru: "Контроль и дисциплина — главный инструмент",
    en: "Control and discipline are the main tools",
    es: "Control y disciplina son las claves",
    pt: "Controle e disciplina são as chaves",
    de: "Kontrolle und Disziplin sind die Schlüssel",
    fr: "Contrôle et discipline sont les clés",
  },
  inviteHookSecondTitleAdd149: {
    ru: "Ситуация штатная, без сюрпризов",
    en: "Routine situation, no surprises",
    es: "Situación normal, sin sorpresas",
    pt: "Situação normal, sem surpresas",
    de: "Normale Situation, keine Überraschungen",
    fr: "Situation normale, pas de surprises",
  },
  inviteHookSecondTitleAdd150: {
    ru: "Позиция усилена — план продолжается",
    en: "Position reinforced — plan continues",
    es: "Posición fortalecida — el plan continúa",
    pt: "Posição reforçada — o plano continua",
    de: "Position gestärkt — Plan läuft weiter",
    fr: "Position renforcée — le plan continue",
  },
  inviteHookSecondTitleAdd151: {
    ru: "Поддержит ли рынок этот шаг?",
    en: "Will the market back the move?",
    es: "¿El mercado respaldará el movimiento?",
    pt: "O mercado vai sustentar o movimento?",
    de: "Wird der Markt den Schritt bestätigen?",
    fr: "Le marché va-t-il valider ce mouvement ?",
  },
  inviteHookSecondTitleAdd152: {
    ru: "Удержится ли?",
    en: "Will it hold?",
    es: "¿Se mantendrá?",
    pt: "Vai segurar?",
    de: "Wird sie halten?",
    fr: "Tiendra-t-elle ?",
  },
  inviteHookSecondTitleAdd153: {
    ru: "Не слишком ли рано усилил?",
    en: "Did I scale too early?",
    es: "¿Demasiado pronto?",
    pt: "Será que entrei cedo demais?",
    de: "Vielleicht etwas zu früh verstärkt?",
    fr: "Ai-je renforcé trop tôt ?",
  },
  inviteHookSecondTitleAdd154: {
    ru: "Будет ли импульс вверх?",
    en: "Will we get an upside impulse?",
    es: "¿Habrá impulso al alza?",
    pt: "Teremos impulso pra cima?",
    de: "Kommt der Aufwärtsimpuls?",
    fr: "Y aura-t-il une impulsion haussière ?",
  },
  inviteHookSecondTitleAdd155: {
    ru: "Посмотрим",
    en: "We’ll see",
    es: "Veremos",
    pt: "Vamos ver",
    de: "Wir werden sehen",
    fr: "On verra",
  },
  inviteHookSecondTitleAdd156: {
    ru: "Была ли добавка своевременной?",
    en: "Was the add timely?",
    es: "¿Fue el momento justo para agregar?",
    pt: "Será que foi no momento certo?",
    de: "War der Moment richtig gewählt?",
    fr: "Était-ce le bon moment ?",
  },
  inviteHookSecondTitleAdd157: {
    ru: "Проверим, не окажется ли это ложным",
    en: "Let’s see if it’s not a head fake",
    es: "Veremos si no es una falsa señal",
    pt: "Vamos ver se não é falso sinal",
    de: "Hoffentlich kein Fehlsignal",
    fr: "Voyons si ce n’est pas un faux signal",
  },
  inviteHookSecondTitleAdd158: {
    ru: "Сработает ли идея второй волной?",
    en: "Will the idea work on a second leg?",
    es: "¿Funcionará la idea en una segunda ola?",
    pt: "A ideia vai funcionar na segunda perna?",
    de: "Wird die Idee in der zweiten Welle aufgehen?",
    fr: "L’idée fonctionnera-t-elle sur une deuxième vague ?",
  },
  inviteHookSecondTitleAdd159: {
    ru: "Будет ли движение?",
    en: "Will we get the move?",
    es: "¿Vendrá el movimiento?",
    pt: "Vamos ver se o movimento vem",
    de: "Kommt jetzt die Bewegung?",
    fr: "Le mouvement viendra-t-il ?",
  },
  inviteHookSecondTitleAdd160: {
    ru: "Отзовётся ли рынок на это решение?",
    en: "Will the market respond to the add?",
    es: "¿Responderá el mercado a esta suma?",
    pt: "O mercado vai responder a essa soma?",
    de: "Reagiert der Markt auf die Aufstockung?",
    fr: "Le marché réagira-t-il à ce renfort ?",
  },
  inviteHookSecondTitleAdd161: {
    ru: "Добавка по системе",
    en: "Add is by the system",
    es: "Suma según el sistema",
    pt: "Adição conforme o sistema",
    de: "Zukauf nach System",
    fr: "Ajout selon le système",
  },
  inviteHookSecondTitleAdd162: {
    ru: "Как и всегда — не эмоция, а алгоритм",
    en: "As always — algorithm over emotion",
    es: "Como siempre — algoritmo antes que emoción",
    pt: "Como sempre — algoritmo antes da emoção",
    de: "Wie immer — System über Emotion",
    fr: "Comme toujours — algorithme avant émotion",
  },
  inviteHookSecondTitleAdd163: {
    ru: "Следую правилу: усиливать только по плану",
    en: "Rule stands: scale only by plan",
    es: "Regla clara: aumentar solo según el plan",
    pt: "Regra clara: aumentar só conforme o plano",
    de: "Klare Regel: nur nach Plan vergrößern",
    fr: "Règle claire : n’augmenter que selon le plan",
  },
  inviteHookSecondTitleAdd164: {
    ru: "Добавка — часть системы, не исключение",
    en: "The add is part of the system, not an exception",
    es: "La suma es parte del sistema, no una excepción",
    pt: "A adição faz parte do sistema, não é exceção",
    de: "Zukauf ist Teil des Systems, keine Ausnahme",
    fr: "L’ajout fait partie du système, pas une exception",
  },
  inviteHookSecondTitleAdd165: {
    ru: "Действую по системе",
    en: "Acting by the playbook",
    es: "Actúo según el método",
    pt: "Agindo conforme o método",
    de: "Handle nach Methode",
    fr: "J’agis selon la méthode",
  },
  inviteHookSecondTitleAdd166: {
    ru: "Чётко по методу: контроль и последовательность",
    en: "Clean method: control and consistency",
    es: "Método claro: control y consistencia",
    pt: "Método limpo: controle e consistência",
    de: "Klare Methode: Kontrolle und Konstanz",
    fr: "Méthode claire : contrôle et constance",
  },
  inviteHookSecondTitleAdd167: {
    ru: "Принцип тот же — без суеты и паники",
    en: "Same principle — no rush, no panic",
    es: "Mismo principio — sin prisa ni pánico",
    pt: "Mesmo princípio — sem pressa e sem pânico",
    de: "Gleicher Grundsatz — keine Hektik, kein Stress",
    fr: "Même principe — sans stress, sans précipitation",
  },
  inviteHookSecondTitleAdd168: {
    ru: "Работа по плану, шаг второй выполнен",
    en: "Working the plan, second step done",
    es: "Siguiendo el plan, segundo paso completado",
    pt: "Seguindo o plano, segundo passo concluído",
    de: "Plan befolgt, zweiter Schritt erledigt",
    fr: "Suivant le plan, deuxième étape accomplie",
  },
  inviteHookSecondTitleAdd169: {
    ru: "Всё согласно алгоритму",
    en: "All according to the algorithm",
    es: "Todo según el algoritmo",
    pt: "Tudo conforme o algoritmo",
    de: "Alles nach Algorithmus",
    fr: "Tout selon l’algorithme",
  },
  inviteHookSecondTitleAdd170: {
    ru: "Никакой спонтанности — чистая дисциплина",
    en: "No spontaneity — pure discipline",
    es: "Sin impulsos — pura disciplina",
    pt: "Sem impulsos — pura disciplina",
    de: "Keine Spontanität — reine Disziplin",
    fr: "Aucune impulsion — pure discipline",
  },
  inviteHookSecondTitleAdd171: {
    ru: "В подобных сетапах добавка часто усиливает результат",
    en: "In this kind of setup, scaling often boosts results",
    es: "En setups como este, agregar suele mejorar el resultado",
    pt: "Em setups assim, adicionar costuma melhorar o resultado",
    de: "In solchen Setups stärkt Nachlegen oft das Ergebnis",
    fr: "Dans ce genre de setup, ajouter améliore souvent le résultat",
  },
  inviteHookSecondTitleAdd172: {
    ru: "Уже не раз проверено — второй вход даёт эффект",
    en: "Proven before — second entry helps",
    es: "Ya probado — la segunda entrada ayuda",
    pt: "Já testado — a segunda entrada ajuda",
    de: "Schon getestet — zweiter Einstieg hilft",
    fr: "Déjà testé — le deuxième achat aide",
  },
  inviteHookSecondTitleAdd173: {
    ru: "Такая стратегия раньше себя оправдывала",
    en: "This approach has worked before",
    es: "Esta estrategia ya ha funcionado antes",
    pt: "Essa estratégia já funcionou antes",
    de: "Diese Strategie hat schon funktioniert",
    fr: "Cette stratégie a déjà fait ses preuves",
  },
  inviteHookSecondTitleAdd174: {
    ru: "Рынок не впервые ведёт себя так — действую по опыту",
    en: "The market’s acted like this before — going with experience",
    es: "El mercado ya se ha comportado así — actuando por experiencia",
    pt: "O mercado já se comportou assim — agindo pela experiência",
    de: "Markt hat sich so schon verhalten — Erfahrung zählt",
    fr: "Le marché s’est déjà comporté ainsi — expérience à l’appui",
  },
  inviteHookSecondTitleAdd175: {
    ru: "Этот приём работает стабильно",
    en: "This play tends to work consistently",
    es: "Este método suele funcionar de forma constante",
    pt: "Esse método costuma funcionar com consistência",
    de: "Diese Methode funktioniert konstant",
    fr: "Cette méthode fonctionne de façon constante",
  },
  inviteHookSecondTitleAdd176: {
    ru: "Видел похожие движения — чаще подтверждаются",
    en: "Seen similar moves — they confirm more often than not",
    es: "He visto movimientos similares — suelen confirmarse",
    pt: "Já vi movimentos parecidos — geralmente se confirmam",
    de: "Ähnliche Bewegungen schon gesehen — meist bestätigen sie sich",
    fr: "Déjà vu ce genre de mouvement — souvent confirmé",
  },
  inviteHookSecondTitleAdd177: {
    ru: "Метод проверенный, просто выполняю",
    en: "Tried-and-true method, just executing",
    es: "Método comprobado, solo ejecutando",
    pt: "Método comprovado, apenas executando",
    de: "Bewährte Methode, einfach umgesetzt",
    fr: "Méthode éprouvée, simple exécution",
  },
  inviteHookSecondTitleAdd178: {
    ru: "Опыт показывает — добавка оправдана",
    en: "Experience says the add is justified",
    es: "La experiencia dice que esta suma está justificada",
    pt: "A experiência mostra que essa adição é justificável",
    de: "Erfahrung zeigt, dass der Zukauf sinnvoll ist",
    fr: "L’expérience montre que ce renfort est justifié",
  },
  inviteHookSecondTitleAdd179: {
    ru: "Опыт подсказывает, что это логичный шаг",
    en: "Experience says it’s the logical step",
    es: "La experiencia dice que es un paso lógico",
    pt: "A experiência mostra que é o passo lógico",
    de: "Erfahrung zeigt, dass es ein logischer Schritt ist",
    fr: "L’expérience montre que c’est une étape logique",
  },
  inviteHookSecondTitleAdd180: {
    ru: "Проверенная схема — ничего нового",
    en: "Same proven play — nothing new",
    es: "Esquema probado — nada nuevo",
    pt: "Esquema testado — nada novo",
    de: "Bewährtes Muster — nichts Neues",
    fr: "Schéma éprouvé — rien de nouveau",
  },
  inviteHookSecondTitleAdd181: {
    ru: "Лучше усилить вовремя, чем потом догонять",
    en: "Better to scale on time than chase later",
    es: "Mejor sumar a tiempo que perseguir después",
    pt: "Melhor reforçar na hora certa do que correr atrás depois",
    de: "Lieber rechtzeitig verstärken als später hinterherlaufen",
    fr: "Mieux vaut renforcer à temps que courir après plus tard",
  },
  inviteHookSecondTitleAdd182: {
    ru: "Контролирую риск — добавка ограничена планом",
    en: "Managing risk — add capped by the plan",
    es: "Controlando el riesgo — suma limitada por el plan",
    pt: "Gerenciando o risco — adição limitada pelo plano",
    de: "Risiko unter Kontrolle — Zukauf im Rahmen des Plans",
    fr: "Gestion du risque — ajout limité par le plan",
  },
  inviteHookSecondTitleAdd183: {
    ru: "Главное — не перегрузить позицию",
    en: "Key is not to overload the position",
    es: "Lo importante es no sobrecargar la posición",
    pt: "O essencial é não sobrecarregar a posição",
    de: "Wichtig: Position nicht überladen",
    fr: "L’important est de ne pas surcharger la position",
  },
  inviteHookSecondTitleAdd184: {
    ru: "Сохраняю баланс между риском и потенциалом",
    en: "Keeping the balance between risk and potential",
    es: "Manteniendo el equilibrio entre riesgo y potencial",
    pt: "Mantendo o equilíbrio entre risco e potencial",
    de: "Balance zwischen Risiko und Potenzial bleibt erhalten",
    fr: "Équilibre entre risque et potentiel maintenu",
  },
  inviteHookSecondTitleAdd185: {
    ru: "Лучше плавно, чем агрессивно",
    en: "Smoother is better than aggressive",
    es: "Mejor de forma gradual que agresiva",
    pt: "Melhor de forma gradual do que agressiva",
    de: "Lieber schrittweise als aggressiv",
    fr: "Mieux progressivement que de façon agressive",
  },
  inviteHookSecondTitleAdd186: {
    ru: "Стремлюсь сохранить ритм",
    en: "Keeping the rhythm",
    es: "Manteniendo el ritmo",
    pt: "Mantendo o ritmo",
    de: "Rhythmus beibehalten",
    fr: "Garder le rythme",
  },
  inviteHookSecondTitleAdd187: {
    ru: "Контроль важнее азарта",
    en: "Control over excitement",
    es: "El control es más importante que la euforia",
    pt: "O controle é mais importante que a empolgação",
    de: "Kontrolle ist wichtiger als Euphorie",
    fr: "Le contrôle prime sur l’euphorie",
  },
  inviteHookSecondTitleAdd188: {
    ru: "Риск под контролем — действую дозировано",
    en: "Risk controlled — scaling in measured steps",
    es: "Riesgo bajo control — actuando con medida",
    pt: "Risco controlado — operando de forma dosada",
    de: "Risiko unter Kontrolle — handle dosiert",
    fr: "Risque sous contrôle — approche mesurée",
  },
  inviteHookSecondTitleAdd189: {
    ru: "Всё по плану",
    en: "All according to plan",
    es: "Todo según el plan",
    pt: "Tudo conforme o plano",
    de: "Alles nach Plan",
    fr: "Tout selon le plan",
  },
  inviteHookSecondTitleAdd190: {
    ru: "Без спешки — гарантия спокойствия",
    en: "No rush — calm is the edge",
    es: "Sin prisa — la calma es la ventaja",
    pt: "Sem pressa — a calma é a vantagem",
    de: "Ohne Eile — Ruhe ist die Stärke",
    fr: "Pas de hâte — la sérénité est un atout",
  },
  inviteHookSecondTitleAdd191: {
    ru: "Всё по ритуалу: первый вход — добавка — ожидание",
    en: "By the ritual: first entry — add — wait",
    es: "Según el ritual: primera entrada — suma — espera",
    pt: "Pelo ritual: primeira entrada — adição — espera",
    de: "Nach Ritual: erster Einstieg — Nachkauf — Warten",
    fr: "Selon le rituel : première entrée — ajout — attente",
  },
  inviteHookSecondTitleAdd192: {
    ru: "Второй шаг стратегии, как и всегда",
    en: "Second step of the strategy, as always",
    es: "Segundo paso de la estrategia, como siempre",
    pt: "Segundo passo da estratégia, como sempre",
    de: "Zweiter Schritt der Strategie, wie immer",
    fr: "Deuxième étape de la stratégie, comme toujours",
  },
  inviteHookSecondTitleAdd193: {
    ru: "Ритм сохранён, процесс идёт",
    en: "Rhythm intact, process ongoing",
    es: "Ritmo intacto, proceso en marcha",
    pt: "Ritmo mantido, processo em andamento",
    de: "Rhythmus stabil, Prozess läuft",
    fr: "Rythme intact, processus en cours",
  },
  inviteHookSecondTitleAdd194: {
    ru: "Повторяю стандартный цикл",
    en: "Repeating the standard cycle",
    es: "Repitiendo el ciclo habitual",
    pt: "Repetindo o ciclo padrão",
    de: "Wiederhole den Standardzyklus",
    fr: "Je répète le cycle habituel",
  },
  inviteHookSecondTitleAdd195: {
    ru: "Добавка — часть привычного ритма",
    en: "The add is part of the usual rhythm",
    es: "La suma es parte del ritmo habitual",
    pt: "A adição é parte do ritmo habitual",
    de: "Nachkauf ist Teil des gewohnten Ablaufs",
    fr: "L’ajout fait partie du rythme habituel",
  },
  inviteHookSecondTitleAdd196: {
    ru: "Всё как обычно: анализ → действие → наблюдение",
    en: "Same as always: analysis → action → observation",
    es: "Como siempre: análisis → acción → observación",
    pt: "Como sempre: análise → ação → observação",
    de: "Wie immer: Analyse → Aktion → Beobachtung",
    fr: "Comme toujours : analyse → action → observation",
  },
  inviteHookSecondTitleAdd197: {
    ru: "Сценарий тот же, просто следующий шаг",
    en: "Same scenario, just the next step",
    es: "Mismo escenario, solo el siguiente paso",
    pt: "Mesmo cenário, só o próximo passo",
    de: "Gleicher Ablauf, nur der nächste Schritt",
    fr: "Même scénario, juste l’étape suivante",
  },
  inviteHookSecondTitleAdd198: {
    ru: "Шаг второй завершён, дальше терпение",
    en: "Step two done, now patience",
    es: "Segundo paso completado, ahora paciencia",
    pt: "Segundo passo feito, agora paciência",
    de: "Zweiter Schritt abgeschlossen, jetzt Geduld",
    fr: "Deuxième étape terminée, maintenant patience",
  },
  inviteHookSecondTitleAdd199: {
    ru: "Всё идёт по накатанному — спокойная последовательность",
    en: "Rolling routine — steady sequence",
    es: "Rutina constante — secuencia tranquila",
    pt: "Rotina fluida — sequência tranquila",
    de: "Routine läuft — alles in Folge",
    fr: "Routine fluide — séquence maîtrisée",
  },
  inviteHookSecondTitleAdd200: {
    ru: "Привычный процесс: усилил, теперь наблюдаю",
    en: "Usual process: added, now I watch",
    es: "Proceso habitual: agregué, ahora observo",
    pt: "Processo habitual: adicionei, agora observo",
    de: "Gewohnter Ablauf: nachgelegt, jetzt beobachten",
    fr: "Processus habituel : ajouté, maintenant observation",
  },
  inviteHookClose1: {
    ru: "Закрыл позицию 🔥 по Apple Inc",
    en: "Closed on 🔥 Apple Inc",
    es: "Cerré en 🔥 Apple Inc",
    pt: "Fechei em 🔥 Apple Inc",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Clôturé sur 🔥 Apple Inc",
  },
  inviteHookClose2: {
    ru: "Завершил позицию 🔥 по Apple Inc",
    en: "Wrapped up the 🔥 Apple Inc position",
    es: "Cerré la posición 🔥 en Apple Inc",
    pt: "Encerrei a posição 🔥 em Apple Inc",
    de: "Apple Inc 🔥 Position beendet",
    fr: "Position 🔥 Apple Inc terminée",
  },
  inviteHookClose3: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Apple Inc 🔥 position closed",
    es: "Posición en 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc fechada",
    de: "Position bei 🔥 Apple Inc geschlossen",
    fr: "Position sur 🔥 Apple Inc clôturée",
  },
  inviteHookClose4: {
    ru: "Закрылся по 🔥 Apple Inc",
    en: "Closed on 🔥 Apple Inc",
    es: "Me cerré en 🔥 Apple Inc",
    pt: "Fechei em 🔥 Apple Inc",
    de: "Bei Apple Inc 🔥 geschlossen",
    fr: "Clôturé sur 🔥 Apple Inc",
  },
  inviteHookClose5: {
    ru: "Движение по 🔥 Apple Inc завершено",
    en: "Apple Inc 🔥 run finished",
    es: "Movimiento en 🔥 Apple Inc terminado",
    pt: "Movimento em 🔥 Apple Inc finalizado",
    de: "Apple Inc 🔥 Move beendet",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose6: {
    ru: "Зафиксировал сделку 🔥 по Apple Inc",
    en: "Locked the 🔥 Apple Inc trade",
    es: "Bloqueé la operación 🔥 en Apple Inc",
    pt: "Travei o trade 🔥 de Apple Inc",
    de: "Apple Inc Trade 🔥 abgeschlossen",
    fr: "Trade Apple Inc 🔥 verrouillé",
  },
  inviteHookClose7: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 clôturée",
  },
  inviteHookClose8: {
    ru: "Вышел из 🔥 Apple Inc",
    en: "Exited 🔥 Apple Inc",
    es: "Salí de 🔥 Apple Inc",
    pt: "Saí de 🔥 Apple Inc",
    de: "Bin aus 🔥 Apple Inc raus",
    fr: "Sorti 🔥 d’Apple Inc",
  },
  inviteHookClose9: {
    ru: "Сделка по 🔥 Apple Inc закрыта",
    en: "Trade on 🔥 Apple Inc closed",
    es: "Operación en 🔥 Apple Inc cerrada",
    pt: "Trade em Apple Inc 🔥 encerrado",
    de: "Trade auf 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc clôturé",
  },
  inviteHookClose10: {
    ru: "С Apple Inc 🔥 закончил",
    en: "Done with 🔥 Apple Inc",
    es: "Terminé con 🔥 Apple Inc",
    pt: "Terminei com 🔥 Apple Inc",
    de: "Fertig mit 🔥 Apple Inc",
    fr: "Fini avec 🔥 Apple Inc",
  },
  inviteHookClose11: {
    ru: "Эту закрыл — 🔥 Apple Inc завершена",
    en: "Wrapped this one — 🔥 Apple Inc trade done",
    es: "Cerré esta — 🔥 Apple Inc finalizada",
    pt: "Fechei este — trade de 🔥 Apple Inc concluído",
    de: "Dieser abgeschlossen — 🔥 Apple Inc Trade beendet",
    fr: "Celui-ci bouclé — 🔥 Apple Inc fermé proprement",
  },
  inviteHookClose12: {
    ru: "Выход по Apple Inc 🔥 зафиксирован",
    en: "Apple Inc 🔥 exit locked",
    es: "Salida de 🔥 Apple Inc asegurada",
    pt: "Saída de Apple Inc 🔥 confirmada",
    de: "Exit bei Apple Inc 🔥 gesichert",
    fr: "Sortie Apple Inc 🔥 verrouillée",
  },
  inviteHookClose13: {
    ru: "Этап по Apple Inc 🔥 завершён",
    en: "Apple Inc 🔥 journey complete",
    es: "Ciclo de Apple Inc 🔥 completado",
    pt: "Ciclo de 🔥 Apple Inc completo",
    de: "Apple Inc 🔥 Reise beendet",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose14: {
    ru: "Вышел из 🔥 Apple Inc",
    en: "Stepped out 🔥 of Apple Inc",
    es: "Salí de 🔥 Apple Inc",
    pt: "Saí de 🔥 Apple Inc",
    de: "Bin aus Apple Inc 🔥 ausgestiegen",
    fr: "Sorti 🔥 d’Apple Inc",
  },
  inviteHookClose15: {
    ru: "Apple Inc — торговый 🔥 цикл закрыт",
    en: "Apple Inc — 🔥 trade cycle done",
    es: "Apple Inc — ciclo 🔥 de trading cerrado",
    pt: "Apple Inc — 🔥 ciclo encerrado",
    de: "Apple Inc — Handelszyklus 🔥 abgeschlossen",
    fr: "Apple Inc — cycle 🔥 de trade terminé",
  },
  inviteHookClose16: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Apple Inc 🔥 position cleared",
    es: "Posición de 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Apple Inc 🔥 Position beendet",
    fr: "Position 🔥 Apple Inc fermée",
  },
  inviteHookClose17: {
    ru: "Apple Inc 🔥 завершена чисто",
    en: "Apple Inc 🔥 finished clean",
    es: "Apple Inc finalizada 🔥 limpiamente",
    pt: "Apple Inc 🔥 finalizada limpo",
    de: "Apple Inc 🔥 sauber beendet",
    fr: "Apple Inc clôturée 🔥 proprement",
  },
  inviteHookClose18: {
    ru: "Сценарий по 🔥 Apple Inc отработан",
    en: "Apple Inc 🔥 play wrapped",
    es: "Juego en 🔥 Apple Inc cerrado",
    pt: "Operação em 🔥 Apple Inc encerrada",
    de: "Apple Inc Trade 🔥 abgeschlossen",
    fr: "Trade Apple Inc 🔥 bouclé",
  },
  inviteHookClose19: {
    ru: "Движение по 🔥 Apple Inc завершено",
    en: "Apple Inc 🔥 move done",
    es: "Movimiento en 🔥 Apple Inc completado",
    pt: "Movimento em 🔥 Apple Inc concluído",
    de: "Apple Inc 🔥 Bewegung beendet",
    fr: "Apple Inc 🔥 terminé",
  },
  inviteHookClose20: {
    ru: "Вышел из 🔥 Apple Inc",
    en: "Apple Inc 🔥 out",
    es: "Salí de 🔥 Apple Inc",
    pt: "Saí de 🔥 Apple Inc",
    de: "Bin aus 🔥 Apple Inc raus",
    fr: "Sorti 🔥 d’Apple Inc",
  },
  inviteHookClose21: {
    ru: "История с 🔥 Apple Inc завершена",
    en: "Apple Inc story 🔥 wrapped up",
    es: "Historia de 🔥 Apple Inc cerrada",
    pt: "História de 🔥 Apple Inc encerrada",
    de: "Apple Inc 🔥 Story beendet",
    fr: "Histoire 🔥 Apple Inc terminée",
  },
  inviteHookClose22: {
    ru: "Закрыл сделку 🔥 по Apple Inc",
    en: "Closed out 🔥 Apple Inc trade",
    es: "Cerré la operación 🔥 de Apple Inc",
    pt: "Fechei o trade 🔥 de Apple Inc",
    de: "Trade auf 🔥 Apple Inc beendet",
    fr: "Trade Apple Inc 🔥 clôturé",
  },
  inviteHookClose23: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 done",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 fertig",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose24: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 complete",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 completa",
    de: "Apple Inc 🔥 komplett",
    fr: "Apple Inc 🔥 complétée",
  },
  inviteHookClose25: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on 🔥 Apple Inc done",
    es: "Operación en 🔥 Apple Inc cerrada",
    pt: "Trade em Apple Inc 🔥 encerrado",
    de: "Trade auf Apple Inc 🔥 abgeschlossen",
    fr: "Trade sur 🔥 Apple Inc fini",
  },
  inviteHookClose26: {
    ru: "Игра по Apple Inc 🔥 закончена",
    en: "Apple Inc 🔥 play ended",
    es: "Juego en Apple Inc 🔥 terminado",
    pt: "Operação em 🔥 Apple Inc finalizada",
    de: "Apple Inc 🔥 Play beendet",
    fr: "Trade Apple Inc 🔥 terminé",
  },
  inviteHookClose27: {
    ru: "Закрыл сетап 🔥 по Apple Inc",
    en: "Wrapped up the 🔥 Apple Inc setup",
    es: "Cerré el setup 🔥 de Apple Inc",
    pt: "Fechei o setup 🔥 de Apple Inc",
    de: "Setup bei 🔥 Apple Inc beendet",
    fr: "Setup Apple Inc 🔥 bouclé",
  },
  inviteHookClose28: {
    ru: "Выход из Apple Inc 🔥 прошёл гладко",
    en: "Apple Inc 🔥 exit smooth",
    es: "Salida de 🔥 Apple Inc fluida",
    pt: "Saída de 🔥 Apple Inc suave",
    de: "Apple Inc 🔥 Exit glatt",
    fr: "Sortie 🔥 Apple Inc fluide",
  },
  inviteHookClose29: {
    ru: "Закрыл 🔥 Apple Inc чисто",
    en: "Closed Apple Inc 🔥 cleanly",
    es: "Cerré Apple Inc 🔥 limpio",
    pt: "Fechei 🔥 Apple Inc limpo",
    de: "Apple Inc sauber 🔥 geschlossen",
    fr: "Apple Inc fermée 🔥 proprement",
  },
  inviteHookClose30: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade finished",
    es: "Operación en 🔥 Apple Inc terminada",
    pt: "Trade em Apple Inc 🔥 finalizado",
    de: "Apple Inc 🔥 Trade fertig",
    fr: "Trade Apple Inc 🔥 terminé",
  },
  inviteHookClose31: {
    ru: "Сделка по Apple Inc 🔥 зафиксирована",
    en: "Apple Inc 🔥 trade sealed",
    es: "Trade de 🔥 Apple Inc cerrado",
    pt: "Trade de Apple Inc 🔥 concluído",
    de: "Apple Inc Trade 🔥 abgeschlossen",
    fr: "Trade Apple Inc 🔥 scellé",
  },
  inviteHookClose32: {
    ru: "Этап по Apple Inc 🔥 закончен",
    en: "Apple Inc 🔥 chapter done",
    es: "Capítulo de 🔥 Apple Inc terminado",
    pt: "Capítulo de 🔥 Apple Inc encerrado",
    de: "Apple Inc 🔥 Kapitel beendet",
    fr: "Chapitre 🔥 Apple Inc terminé",
  },
  inviteHookClose33: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Finished 🔥 Apple Inc",
    es: "Finalicé 🔥 Apple Inc",
    pt: "Finalizei 🔥 Apple Inc",
    de: "Apple Inc 🔥 beendet",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose34: {
    ru: "Игра по Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 play closed",
    es: "Juego en 🔥 Apple Inc cerrado",
    pt: "Operação em 🔥 Apple Inc encerrada",
    de: "Apple Inc 🔥 Trade beendet",
    fr: "Trade Apple Inc 🔥 clôturé",
  },
  inviteHookClose35: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose36: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Apple Inc 🔥 position cleared",
    es: "Posición de 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Apple Inc 🔥 Position beendet",
    fr: "Position 🔥 Apple Inc fermée",
  },
  inviteHookClose37: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 out",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 clôturée",
  },
  inviteHookClose38: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose39: {
    ru: "Цикл по Apple Inc 🔥 завершён",
    en: "Apple Inc 🔥 cycle ended",
    es: "Ciclo de Apple Inc 🔥 terminado",
    pt: "Ciclo de Apple Inc 🔥 encerrado",
    de: "Apple Inc Zyklus 🔥 abgeschlossen",
    fr: "Cycle Apple Inc 🔥 terminé",
  },
  inviteHookClose40: {
    ru: "Сценарий по 🔥 Apple Inc завершён",
    en: "Apple Inc 🔥 play complete",
    es: "Juego en 🔥 Apple Inc completo",
    pt: "Operação em 🔥 Apple Inc completa",
    de: "Apple Inc 🔥 Trade fertig",
    fr: "Trade Apple Inc 🔥 complété",
  },
  inviteHookClose41: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose42: {
    ru: "Сделка по 🔥 Apple Inc закрыта",
    en: "Apple Inc 🔥 trade complete",
    es: "Operación de 🔥 Apple Inc completada",
    pt: "Trade de Apple Inc 🔥 concluído",
    de: "Apple Inc Trade 🔥 abgeschlossen",
    fr: "Trade Apple Inc 🔥 terminé",
  },
  inviteHookClose43: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 sealed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 versiegelt",
    fr: "Apple Inc 🔥 scellée",
  },
  inviteHookClose44: {
    ru: "План по Apple Inc 🔥 выполнен",
    en: "Apple Inc 🔥 plan executed",
    es: "Plan de Apple Inc 🔥 cumplido",
    pt: "Plano de 🔥 Apple Inc cumprido",
    de: "Apple Inc Plan 🔥 umgesetzt",
    fr: "Plan Apple Inc 🔥 exécuté",
  },
  inviteHookClose45: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade concluded",
    es: "Trade de Apple Inc 🔥 terminado",
    pt: "Trade de Apple Inc 🔥 finalizado",
    de: "Apple Inc Trade 🔥 abgeschlossen",
    fr: "Trade Apple Inc 🔥 terminé",
  },
  inviteHookClose46: {
    ru: "Этап по 🔥 Apple Inc закрыт",
    en: "Apple Inc 🔥 journey wrapped",
    es: "Ciclo de 🔥 Apple Inc cerrado",
    pt: "Ciclo de Apple Inc 🔥 encerrado",
    de: "Apple Inc 🔥 Reise beendet",
    fr: "Apple Inc 🔥 bouclé",
  },
  inviteHookClose47: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 out",
    es: "Apple Inc 🔥 fuera",
    pt: "Apple Inc 🔥 fora",
    de: "Apple Inc 🔥 raus",
    fr: "Sorti 🔥 d’Apple Inc",
  },
  inviteHookClose48: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 clôturée",
  },
  inviteHookClose49: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 done",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 fertig",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose50: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Apple Inc 🔥 position done",
    es: "Posición en 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc concluída",
    de: "Position in 🔥 Apple Inc geschlossen",
    fr: "Position 🔥 Apple Inc terminée",
  },
  inviteHookClose51: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 wrapped",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 finalizada",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 bouclée",
  },
  inviteHookClose52: {
    ru: "Закрытие по 🔥 Apple Inc",
    en: "Apple Inc 🔥 closure",
    es: "Cierre de 🔥 Apple Inc",
    pt: "Fechamento 🔥 de Apple Inc",
    de: "Apple Inc 🔥 Abschluss",
    fr: "Apple Inc 🔥 clôture",
  },
  inviteHookClose53: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Apple Inc 🔥 position closed",
    es: "Posición de 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Apple Inc Position 🔥 geschlossen",
    fr: "Position 🔥 Apple Inc close",
  },
  inviteHookClose54: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade done",
    es: "Trade de Apple Inc 🔥 finalizado",
    pt: "Trade de Apple Inc 🔥 encerrado",
    de: "Apple Inc 🔥 Trade fertig",
    fr: "Trade 🔥 Apple Inc fini",
  },
  inviteHookClose55: {
    ru: "Apple Inc 🔥 снята",
    en: "Out of 🔥 Apple Inc",
    es: "Apple Inc 🔥 fuera",
    pt: "Apple Inc 🔥 fora",
    de: "Raus aus 🔥 Apple Inc",
    fr: "Apple Inc 🔥 sortie",
  },
  inviteHookClose56: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade finished",
    es: "Operación de 🔥 Apple Inc terminada",
    pt: "Trade de Apple Inc 🔥 finalizado",
    de: "Apple Inc 🔥 Trade beendet",
    fr: "Trade Apple Inc 🔥 terminé",
  },
  inviteHookClose57: {
    ru: "Apple Inc — 🔥 сделка завершена",
    en: "Apple Inc — 🔥 trade done",
    es: "Apple Inc — 🔥 trade cerrado",
    pt: "Apple Inc — 🔥 trade encerrado",
    de: "Apple Inc — 🔥 Trade beendet",
    fr: "Apple Inc — 🔥 trade terminé",
  },
  inviteHookClose58: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 completa",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 complétée",
  },
  inviteHookClose59: {
    ru: "Вышел из 🔥 Apple Inc",
    en: "Apple Inc 🔥 out",
    es: "Salí de 🔥 Apple Inc",
    pt: "Saí de 🔥 Apple Inc",
    de: "Bin aus 🔥 Apple Inc raus",
    fr: "Sorti 🔥 d’Apple Inc",
  },
  inviteHookClose60: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 finished",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 finalizada",
    de: "Apple Inc 🔥 fertig",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose61: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose62: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose63: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 done",
    es: "Apple Inc 🔥 terminada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 beendet",
    fr: "Apple Inc 🔥 finie",
  },
  inviteHookClose64: {
    ru: "Apple Inc 🔥 снята",
    en: "Apple Inc 🔥 off",
    es: "Apple Inc 🔥 fuera",
    pt: "Apple Inc 🔥 fora",
    de: "Raus aus 🔥 Apple Inc",
    fr: "Apple Inc 🔥 sortie",
  },
  inviteHookClose65: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 wrapped up",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 finalizada",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 bouclée",
  },
  inviteHookClose66: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade wrapped",
    es: "Trade de 🔥 Apple Inc cerrado",
    pt: "Trade de Apple Inc 🔥 encerrado",
    de: "Apple Inc 🔥 Trade beendet",
    fr: "Trade Apple Inc 🔥 clôturé",
  },
  inviteHookClose67: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose68: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 done",
    es: "Apple Inc 🔥 terminada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 beendet",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose69: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose70: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 sealed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 scellée",
  },
  inviteHookClose71: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 complete",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 finalizada",
    de: "Apple Inc 🔥 fertig",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose72: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade ended",
    es: "Trade de Apple Inc 🔥 terminado",
    pt: "Trade de Apple Inc 🔥 finalizado",
    de: "Apple Inc 🔥 Trade beendet",
    fr: "Trade 🔥 Apple Inc fini",
  },
  inviteHookClose73: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 wrapped",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 beendet",
    fr: "Apple Inc 🔥 bouclée",
  },
  inviteHookClose74: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose75: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade finished",
    es: "Trade de Apple Inc 🔥 finalizado",
    pt: "Trade de Apple Inc 🔥 finalizado",
    de: "Apple Inc 🔥 Trade fertig",
    fr: "Trade Apple Inc 🔥 terminé",
  },
  inviteHookClose76: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Apple Inc 🔥 position done",
    es: "Posición de 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Apple Inc 🔥 Position beendet",
    fr: "Position 🔥 Apple Inc close",
  },
  inviteHookClose77: {
    ru: "Apple Inc 🔥 завершена чисто",
    en: "Apple Inc 🔥 wrapped clean",
    es: "Apple Inc cerrada 🔥 limpiamente",
    pt: "Apple Inc 🔥 fechada limpo",
    de: "Apple Inc sauber 🔥 abgeschlossen",
    fr: "Apple Inc clôturée 🔥 proprement",
  },
  inviteHookClose78: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 out",
    es: "Apple Inc 🔥 fuera",
    pt: "Apple Inc 🔥 fora",
    de: "Apple Inc 🔥 raus",
    fr: "Apple Inc 🔥 sortie",
  },
  inviteHookClose79: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade over",
    es: "Trade de 🔥 Apple Inc cerrado",
    pt: "Trade de Apple Inc 🔥 encerrado",
    de: "Apple Inc 🔥 Trade beendet",
    fr: "Trade 🔥 Apple Inc fini",
  },
  inviteHookClose80: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 complete",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 finalizada",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 complétée",
  },
  inviteHookClose81: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose82: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 off",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fora",
    de: "Raus aus 🔥 Apple Inc",
    fr: "Apple Inc 🔥 sortie",
  },
  inviteHookClose83: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 done",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 fertig",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose84: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 wrapped",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 bouclée",
  },
  inviteHookClose85: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 sealed",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 finalizada",
    de: "Apple Inc 🔥 beendet",
    fr: "Apple Inc 🔥 scellée",
  },
  inviteHookClose86: {
    ru: "Закрытие по 🔥 Apple Inc",
    en: "Apple Inc 🔥 closure",
    es: "Cierre de 🔥 Apple Inc",
    pt: "Fechamento 🔥 de Apple Inc",
    de: "Apple Inc 🔥 Abschluss",
    fr: "Apple Inc 🔥 clôture",
  },
  inviteHookClose87: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade concluded",
    es: "Trade de Apple Inc 🔥 terminado",
    pt: "Trade de Apple Inc 🔥 finalizado",
    de: "Apple Inc Trade 🔥 abgeschlossen",
    fr: "Trade 🔥 Apple Inc fini",
  },
  inviteHookClose88: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 done",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 beendet",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose89: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Apple Inc 🔥 position closed",
    es: "Posición de 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc fechada",
    de: "Apple Inc Position 🔥 geschlossen",
    fr: "Position 🔥 Apple Inc fermée",
  },
  inviteHookClose90: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 complete",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 completa",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 clôturée",
  },
  inviteHookClose91: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Apple Inc 🔥 trade ended",
    es: "Trade de Apple Inc 🔥 terminado",
    pt: "Trade de Apple Inc 🔥 finalizado",
    de: "Apple Inc 🔥 Trade beendet",
    fr: "Trade Apple Inc 🔥 terminé",
  },
  inviteHookClose92: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 off",
    es: "Apple Inc 🔥 fuera",
    pt: "Apple Inc 🔥 fora",
    de: "Raus aus 🔥 Apple Inc",
    fr: "Apple Inc 🔥 sortie",
  },
  inviteHookClose93: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 finished",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 beendet",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose94: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 done",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 fertig",
    fr: "Apple Inc 🔥 finie",
  },
  inviteHookClose95: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose96: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 wrapped",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 finalizada",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 bouclée",
  },
  inviteHookClose97: {
    ru: "Сделка по 🔥 Apple Inc закрыта",
    en: "Apple Inc 🔥 trade done",
    es: "Trade de 🔥 Apple Inc cerrado",
    pt: "Trade de Apple Inc 🔥 encerrado",
    de: "Apple Inc 🔥 Trade beendet",
    fr: "Trade 🔥 Apple Inc fini",
  },
  inviteHookClose98: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 finalizada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose99: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 finished",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 fechada",
    de: "Apple Inc 🔥 beendet",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose100: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose101: {
    ru: "Закрыл позицию 🔥 по Apple Inc",
    en: "Closed the position 🔥 on Apple Inc",
    es: "Cerré la posición 🔥 en Apple Inc",
    pt: "Encerrei a posição 🔥 em Apple Inc",
    de: "Position in 🔥 Apple Inc",
    fr: "Position sur 🔥 Apple Inc",
  },
  inviteHookClose102: {
    ru: "Завершил позицию 🔥 по Apple Inc",
    en: "Wrapped up the 🔥 position on Apple Inc",
    es: "Cerré la posición 🔥 en Apple Inc",
    pt: "Fechei a posição 🔥 em Apple Inc",
    de: "Position in 🔥 Apple Inc",
    fr: "Position sur 🔥 Apple Inc",
  },
  inviteHookClose103: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Position on 🔥 Apple Inc closed",
    es: "Posición en 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Position in 🔥 Apple Inc",
    fr: "Position sur 🔥 Apple Inc",
  },
  inviteHookClose104: {
    ru: "Закрылся по 🔥 Apple Inc",
    en: "Closed out 🔥 of Apple Inc",
    es: "Salí de 🔥 Apple Inc",
    pt: "Saí de 🔥 Apple Inc",
    de: "Aus 🔥 Apple Inc",
    fr: "Sorti de 🔥 Apple Inc",
  },
  inviteHookClose105: {
    ru: "Движение по 🔥 Apple Inc завершено",
    en: "The move on 🔥 Apple Inc is done",
    es: "El movimiento en 🔥 Apple Inc terminó",
    pt: "O movimento em 🔥 Apple Inc terminou",
    de: "Bewegung bei 🔥 Apple Inc",
    fr: "Mouvement 🔥 sur Apple Inc",
  },
  inviteHookClose106: {
    ru: "Зафиксировал сделку 🔥 по Apple Inc",
    en: "Locked in the 🔥 trade on Apple Inc",
    es: "Cerré la operación 🔥 en Apple Inc",
    pt: "Registrei o fechamento 🔥 da operação em Apple Inc",
    de: "Trade in 🔥 Apple Inc",
    fr: "Trade sur 🔥 Apple Inc",
  },
  inviteHookClose107: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 beendet",
    fr: "Apple Inc 🔥 clôturée",
  },
  inviteHookClose108: {
    ru: "Вышел из 🔥 Apple Inc",
    en: "Exited 🔥 Apple Inc",
    es: "Salí de 🔥 Apple Inc",
    pt: "Saí de 🔥 Apple Inc",
    de: "Aus 🔥 Apple Inc",
    fr: "Sorti de 🔥 Apple Inc",
  },
  inviteHookClose109: {
    ru: "Сделка по 🔥 Apple Inc закрыта",
    en: "Trade on 🔥 Apple Inc closed",
    es: "Operación en 🔥 Apple Inc cerrada",
    pt: "Operação em 🔥 Apple Inc encerrada",
    de: "Trade in 🔥 Apple Inc",
    fr: "Trade sur 🔥 Apple Inc",
  },
  inviteHookClose110: {
    ru: "С Apple Inc 🔥 закончил",
    en: "Done with 🔥 Apple Inc",
    es: "Terminé con 🔥 Apple Inc",
    pt: "Terminei com 🔥 Apple Inc",
    de: "Mit Apple Inc 🔥 fertig",
    fr: "Fini avec 🔥 Apple Inc",
  },
  inviteHookClose111: {
    ru: "Эту закрыл 🔥 — Apple Inc",
    en: "This one’s closed 🔥 — Apple Inc",
    es: "Esta está cerrada 🔥 — Apple Inc",
    pt: "Esta está encerrada 🔥 — Apple Inc",
    de: "Dieser ist zu 🔥 Ende — Apple Inc",
    fr: "Celle-ci est 🔥 fermée — Apple Inc",
  },
  inviteHookClose112: {
    ru: "Выход по Apple Inc 🔥 зафиксирован",
    en: "Exit on Apple Inc 🔥 confirmed",
    es: "Salida de Apple Inc 🔥 confirmada",
    pt: "Saída de Apple Inc 🔥 confirmada",
    de: "Ausstieg bei 🔥 Apple Inc",
    fr: "Sortie sur 🔥 Apple Inc",
  },
  inviteHookClose113: {
    ru: "Этап по Apple Inc 🔥 завершён",
    en: "Stage on Apple Inc 🔥 completed",
    es: "Etapa en Apple Inc 🔥 completada",
    pt: "Etapa em Apple Inc 🔥 concluída",
    de: "Phase bei Apple Inc 🔥 abgeschlossen",
    fr: "Phase sur 🔥 Apple Inc terminée",
  },
  inviteHookClose114: {
    ru: "Вышел из 🔥 Apple Inc",
    en: "Exited 🔥 Apple Inc",
    es: "Salí de 🔥 Apple Inc",
    pt: "Saí de 🔥 Apple Inc",
    de: "Aus Apple Inc 🔥 ausgestiegen",
    fr: "Sorti de 🔥 Apple Inc",
  },
  inviteHookClose115: {
    ru: "Apple Inc — торговый 🔥 цикл закрыт",
    en: "Apple Inc — trading 🔥 cycle closed",
    es: "Apple Inc — ciclo 🔥 de trading cerrado",
    pt: "Apple Inc — ciclo 🔥 de trade fechado",
    de: "Apple Inc — 🔥 Trading-Zyklus beendet",
    fr: "Apple Inc — cycle 🔥 de trading clôturé",
  },
  inviteHookClose116: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Position on 🔥 Apple Inc closed",
    es: "Posición en 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Position in 🔥 Apple Inc geschlossen",
    fr: "Position sur 🔥 Apple Inc fermée",
  },
  inviteHookClose117: {
    ru: "Apple Inc 🔥 завершена чисто",
    en: "Apple Inc 🔥 closed cleanly",
    es: "Apple Inc cerrada 🔥 de forma limpia",
    pt: "Apple Inc encerrada 🔥 de forma limpa",
    de: "Apple Inc sauber 🔥 abgeschlossen",
    fr: "Apple Inc clôturée 🔥 proprement",
  },
  inviteHookClose118: {
    ru: "Сценарий по 🔥 Apple Inc отработан",
    en: "Scenario on 🔥 Apple Inc played out",
    es: "Escenario en 🔥 Apple Inc cumplido",
    pt: "Cenário em 🔥 Apple Inc cumprido",
    de: "Szenario bei Apple Inc 🔥 abgeschlossen",
    fr: "Scénario sur 🔥 Apple Inc terminé",
  },
  inviteHookClose119: {
    ru: "Движение по 🔥 Apple Inc завершено",
    en: "The move on 🔥 Apple Inc is done",
    es: "El movimiento en 🔥 Apple Inc terminó",
    pt: "O movimento em 🔥 Apple Inc terminou",
    de: "Bewegung bei 🔥 Apple Inc beendet",
    fr: "Mouvement sur 🔥 Apple Inc terminé",
  },
  inviteHookClose120: {
    ru: "Вышел из 🔥 Apple Inc",
    en: "Exited 🔥 Apple Inc",
    es: "Salí de 🔥 Apple Inc",
    pt: "Saí de 🔥 Apple Inc",
    de: "Aus Apple Inc 🔥 ausgestiegen",
    fr: "Sorti de 🔥 Apple Inc",
  },
  inviteHookClose121: {
    ru: "История с 🔥 Apple Inc завершена",
    en: "Story with 🔥 Apple Inc finished",
    es: "Historia con 🔥 Apple Inc finalizada",
    pt: "História com 🔥 Apple Inc concluída",
    de: "Story mit Apple Inc 🔥 abgeschlossen",
    fr: "Histoire avec 🔥 Apple Inc terminée",
  },
  inviteHookClose122: {
    ru: "Закрыл сделку 🔥 по Apple Inc",
    en: "Closed the trade 🔥 on Apple Inc",
    es: "Cerré la operación 🔥 en Apple Inc",
    pt: "Fechei a operação 🔥 em Apple Inc",
    de: "Trade in Apple Inc 🔥 geschlossen",
    fr: "Trade sur 🔥 Apple Inc clôturé",
  },
  inviteHookClose123: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose124: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose125: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose126: {
    ru: "Игра по Apple Inc 🔥 закончена",
    en: "Game over 🔥 for Apple Inc",
    es: "Juego terminado 🔥 con Apple Inc",
    pt: "Jogo finalizado 🔥 com Apple Inc",
    de: "Spiel mit 🔥 Apple Inc beendet",
    fr: "Partie sur 🔥 Apple Inc terminée",
  },
  inviteHookClose127: {
    ru: "Закрыл сетап 🔥 по Apple Inc",
    en: "Closed the setup 🔥 on Apple Inc",
    es: "Cerré el setup 🔥 en Apple Inc",
    pt: "Fechei o setup 🔥 em Apple Inc",
    de: "Setup bei Apple Inc 🔥 geschlossen",
    fr: "Setup sur 🔥 Apple Inc fermé",
  },
  inviteHookClose128: {
    ru: "Выход из Apple Inc 🔥 прошёл гладко",
    en: "Exit from Apple Inc 🔥 went smoothly",
    es: "Salida de Apple Inc 🔥 sin problemas",
    pt: "Saída de Apple Inc 🔥 sem problemas",
    de: "Ausstieg bei Apple Inc 🔥 glatt gelaufen",
    fr: "Sortie sur 🔥 Apple Inc fluide",
  },
  inviteHookClose129: {
    ru: "Закрыл 🔥 Apple Inc",
    en: "Closed 🔥 Apple Inc",
    es: "Cerré 🔥 Apple Inc",
    pt: "Fechei 🔥 Apple Inc",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose130: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose131: {
    ru: "Сделка по Apple Inc 🔥 зафиксирована",
    en: "Trade on 🔥 Apple Inc wrapped",
    es: "Operación en 🔥 Apple Inc cerrada",
    pt: "Operação em 🔥 Apple Inc encerrada",
    de: "Trade in Apple Inc 🔥 abgeschlossen",
    fr: "Trade sur 🔥 Apple Inc clôturé",
  },
  inviteHookClose132: {
    ru: "Этап по Apple Inc 🔥 закончен",
    en: "Stage on 🔥 Apple Inc finished",
    es: "Etapa en Apple Inc 🔥 finalizada",
    pt: "Etapa em Apple Inc 🔥 concluída",
    de: "Phase bei 🔥 Apple Inc beendet",
    fr: "Phase sur 🔥 Apple Inc finie",
  },
  inviteHookClose133: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 clôturée",
  },
  inviteHookClose134: {
    ru: "Игра по Apple Inc 🔥 завершена",
    en: "Game on Apple Inc 🔥 finished",
    es: "Juego en Apple Inc 🔥 terminado",
    pt: "Jogo em Apple Inc 🔥 finalizado",
    de: "Trade bei 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose135: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose136: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Position on 🔥 Apple Inc closed",
    es: "Posición en 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Position in 🔥 Apple Inc geschlossen",
    fr: "Position sur 🔥 Apple Inc fermée",
  },
  inviteHookClose137: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose138: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose139: {
    ru: "Цикл по Apple Inc 🔥 завершён",
    en: "Cycle on Apple Inc 🔥 completed",
    es: "Ciclo en Apple Inc 🔥 completado",
    pt: "Ciclo em Apple Inc 🔥 concluído",
    de: "Zyklus bei Apple Inc 🔥 abgeschlossen",
    fr: "Cycle sur 🔥 Apple Inc terminé",
  },
  inviteHookClose140: {
    ru: "Сценарий по 🔥 Apple Inc завершён",
    en: "Scenario on 🔥 Apple Inc completed",
    es: "Escenario en 🔥 Apple Inc completado",
    pt: "Cenário em 🔥 Apple Inc concluído",
    de: "Szenario bei 🔥 Apple Inc beendet",
    fr: "Scénario sur 🔥 Apple Inc terminé",
  },
  inviteHookClose141: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose142: {
    ru: "Сделка по 🔥 Apple Inc закрыта",
    en: "Trade on 🔥 Apple Inc closed",
    es: "Operación en 🔥 Apple Inc cerrada",
    pt: "Operação em 🔥 Apple Inc encerrada",
    de: "Trade in Apple Inc 🔥 geschlossen",
    fr: "Trade sur 🔥 Apple Inc fermé",
  },
  inviteHookClose143: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose144: {
    ru: "План по Apple Inc 🔥 выполнен",
    en: "Plan on Apple Inc 🔥 completed",
    es: "Plan en Apple Inc 🔥 completado",
    pt: "Plano em Apple Inc 🔥 concluído",
    de: "Plan bei Apple Inc 🔥 abgeschlossen",
    fr: "Plan sur 🔥 Apple Inc exécuté",
  },
  inviteHookClose145: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose146: {
    ru: "Этап по 🔥 Apple Inc закрыт",
    en: "Stage on 🔥 Apple Inc closed",
    es: "Etapa en 🔥 Apple Inc cerrada",
    pt: "Etapa em Apple Inc 🔥 encerrada",
    de: "Phase bei Apple Inc 🔥 geschlossen",
    fr: "Phase sur 🔥 Apple Inc terminée",
  },
  inviteHookClose147: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 clôturée",
  },
  inviteHookClose148: {
    ru: "Apple Inc закрыта 🔥 — результат позже",
    en: "Apple Inc closed 🔥 — recap later",
    es: "Apple Inc cerrada 🔥 — resumen después",
    pt: "Apple Inc encerrada 🔥 — resumo depois",
    de: "Apple Inc geschlossen 🔥 — Fazit folgt",
    fr: "Apple Inc fermée 🔥 — résumé à venir",
  },
  inviteHookClose149: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose150: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Position on 🔥 Apple Inc closed",
    es: "Posición en 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Position in 🔥 Apple Inc geschlossen",
    fr: "Position sur 🔥 Apple Inc fermée",
  },
  inviteHookClose151: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose152: {
    ru: "Закрытие по 🔥 Apple Inc",
    en: "Closed out 🔥 Apple Inc",
    es: "Cerré 🔥 Apple Inc",
    pt: "Fechamento 🔥 em Apple Inc",
    de: "Schließung 🔥 bei Apple Inc",
    fr: "Clôture sur 🔥 Apple Inc",
  },
  inviteHookClose153: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Position on 🔥 Apple Inc closed",
    es: "Posición en 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Position in 🔥 Apple Inc geschlossen",
    fr: "Position sur 🔥 Apple Inc fermée",
  },
  inviteHookClose154: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose155: {
    ru: "Apple Inc 🔥 снята",
    en: "Apple Inc 🔥 wrapped",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 clôturée",
  },
  inviteHookClose156: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose157: {
    ru: "Apple Inc — 🔥 сделка завершена",
    en: "Apple Inc — 🔥 trade completed",
    es: "Apple Inc — 🔥 operación cerrada",
    pt: "Apple Inc — 🔥 operação encerrada",
    de: "Apple Inc — 🔥 Trade beendet",
    fr: "Apple Inc — 🔥 trade terminé",
  },
  inviteHookClose158: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose159: {
    ru: "Вышел из 🔥 Apple Inc",
    en: "Exited 🔥 Apple Inc",
    es: "Salí de 🔥 Apple Inc",
    pt: "Saí de 🔥 Apple Inc",
    de: "Aus Apple Inc 🔥 ausgestiegen",
    fr: "Sorti de 🔥 Apple Inc",
  },
  inviteHookClose160: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose161: {
    ru: "Apple Inc",
    en: "Apple Inc",
    es: "Apple Inc",
    pt: "Apple Inc",
    de: "Apple Inc",
    fr: "Apple Inc",
  },
  inviteHookClose162: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose163: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose164: {
    ru: "Apple Inc снята — 🔥 простое закрытие",
    en: "Apple Inc wrapped 🔥 — simple closure",
    es: "Apple Inc cerrada 🔥 — cierre simple",
    pt: "Apple Inc encerrada 🔥 — fechamento simples",
    de: "Apple Inc geschlossen 🔥 — einfacher Abschluss",
    fr: "Apple Inc clôturée 🔥 — simple fermeture",
  },
  inviteHookClose165: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose166: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose167: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose168: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose169: {
    ru: "Apple Inc — 🔥 сделка закрыта",
    en: "Apple Inc — 🔥 trade closed",
    es: "Apple Inc — 🔥 operación cerrada",
    pt: "Apple Inc — 🔥 operação encerrada",
    de: "Apple Inc — 🔥 Trade beendet",
    fr: "Apple Inc — 🔥 trade clôturé",
  },
  inviteHookClose170: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose171: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose172: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc clôturé",
  },
  inviteHookClose173: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose174: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose175: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose176: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Position on 🔥 Apple Inc closed",
    es: "Posición en 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Position in 🔥 Apple Inc geschlossen",
    fr: "Position sur 🔥 Apple Inc fermée",
  },
  inviteHookClose177: {
    ru: "Apple Inc 🔥 завершена чисто",
    en: "Apple Inc 🔥 closed cleanly",
    es: "Apple Inc cerrada 🔥 de forma limpia",
    pt: "Apple Inc encerrada 🔥 de forma limpa",
    de: "Apple Inc sauber 🔥 abgeschlossen",
    fr: "Apple Inc clôturée 🔥 proprement",
  },
  inviteHookClose178: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose179: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose180: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose181: {
    ru: "Apple Inc — 🔥 полный цикл завершён",
    en: "Apple Inc — 🔥 full cycle wrapped",
    es: "Apple Inc — 🔥 ciclo completo cerrado",
    pt: "Apple Inc — 🔥 ciclo completo encerrado",
    de: "Apple Inc — 🔥 kompletter Zyklus beendet",
    fr: "Apple Inc — 🔥 cycle complet terminé",
  },
  inviteHookClose182: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose183: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose184: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose185: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose186: {
    ru: "Закрытие по 🔥 Apple Inc",
    en: "Closed out 🔥 Apple Inc",
    es: "Cerré 🔥 Apple Inc",
    pt: "Fechamento 🔥 em Apple Inc",
    de: "Schließung 🔥 bei Apple Inc",
    fr: "Clôture sur 🔥 Apple Inc",
  },
  inviteHookClose187: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose188: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose189: {
    ru: "Позиция по 🔥 Apple Inc закрыта",
    en: "Position on 🔥 Apple Inc closed",
    es: "Posición en 🔥 Apple Inc cerrada",
    pt: "Posição em 🔥 Apple Inc encerrada",
    de: "Position in 🔥 Apple Inc geschlossen",
    fr: "Position sur 🔥 Apple Inc fermée",
  },
  inviteHookClose190: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose191: {
    ru: "Сделка по 🔥 Apple Inc завершена",
    en: "Trade on Apple Inc 🔥 completed",
    es: "Operación en 🔥 Apple Inc completada",
    pt: "Operação em 🔥 Apple Inc concluída",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose192: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose193: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose194: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose195: {
    ru: "Apple Inc — 🔥 ещё одно закрытие",
    en: "Apple Inc — 🔥 another closure",
    es: "Apple Inc — 🔥 otro cierre",
    pt: "Apple Inc — 🔥 outro fechamento",
    de: "Apple Inc — 🔥 weiterer Abschluss",
    fr: "Apple Inc — 🔥 autre clôture",
  },
  inviteHookClose196: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose197: {
    ru: "Сделка по 🔥 Apple Inc закрыта",
    en: "Trade on 🔥 Apple Inc closed",
    es: "Operación en 🔥 Apple Inc cerrada",
    pt: "Operação em 🔥 Apple Inc encerrada",
    de: "Trade in 🔥 Apple Inc beendet",
    fr: "Trade sur 🔥 Apple Inc terminé",
  },
  inviteHookClose198: {
    ru: "Apple Inc 🔥 завершена",
    en: "Apple Inc 🔥 completed",
    es: "Apple Inc 🔥 completada",
    pt: "Apple Inc 🔥 concluída",
    de: "Apple Inc 🔥 abgeschlossen",
    fr: "Apple Inc 🔥 terminée",
  },
  inviteHookClose199: {
    ru: "Apple Inc 🔥 закрыта",
    en: "Apple Inc 🔥 closed",
    es: "Apple Inc 🔥 cerrada",
    pt: "Apple Inc 🔥 encerrada",
    de: "Apple Inc 🔥 geschlossen",
    fr: "Apple Inc 🔥 fermée",
  },
  inviteHookClose200: {
    ru: "Apple Inc — 🔥 цикл завершён",
    en: "Apple Inc — 🔥 cycle done",
    es: "Apple Inc — 🔥 ciclo cerrado",
    pt: "Apple Inc — 🔥 ciclo encerrado",
    de: "Apple Inc — 🔥 Zyklus beendet",
    fr: "Apple Inc — 🔥 cycle terminé",
  },
  inviteHookSecondTitleClose1: {
    ru: "Сделка прошла по плану",
    en: "Trade went as planned",
    es: "La operación salió según el plan",
    pt: "Trade saiu como planejado",
    de: "Trade lief wie geplant",
    fr: "Trade comme prévu",
  },
  inviteHookSecondTitleClose2: {
    ru: "Спокойно и чётко",
    en: "Steady execution",
    es: "Ejecución tranquila y precisa",
    pt: "Execução tranquila e precisa",
    de: "Ruhige, saubere Ausführung",
    fr: "Exécution fluide",
  },
  inviteHookSecondTitleClose3: {
    ru: "План выполнен, жду следующий сетап",
    en: "Plan complete, waiting next setup",
    es: "Plan cumplido, esperando el próximo setup",
    pt: "Plano completo, aguardando o próximo setup",
    de: "Plan erfüllt, nächstes Setup abwarten",
    fr: "Plan respecté, en attente du prochain setup",
  },
  inviteHookSecondTitleClose4: {
    ru: "Всё по намеченному",
    en: "All as planned",
    es: "Todo según lo previsto",
    pt: "Tudo conforme o planejado",
    de: "Alles nach Plan",
    fr: "Tout s’est passé comme prévu",
  },
  inviteHookSecondTitleClose5: {
    ru: "Чистое закрытие",
    en: "Clean close",
    es: "Cierre limpio",
    pt: "Fechamento limpo",
    de: "Sauberer Abschluss",
    fr: "Clôture propre",
  },
  inviteHookSecondTitleClose6: {
    ru: "Всё сошлось как надо",
    en: "Everything aligned",
    es: "Todo alineado",
    pt: "Tudo alinhado",
    de: "Alles im Einklang",
    fr: "Tout est aligné",
  },
  inviteHookSecondTitleClose7: {
    ru: "Спокойный выход, весь план отработан",
    en: "Calm exit, full plan executed",
    es: "Salida calmada, plan ejecutado completo",
    pt: "Saída calma, plano totalmente executado",
    de: "Ruhiger Exit, Plan komplett umgesetzt",
    fr: "Sortie calme, plan exécuté à fond",
  },
  inviteHookSecondTitleClose8: {
    ru: "Очередной цикл завершён",
    en: "Another cycle complete",
    es: "Otro ciclo completado",
    pt: "Mais um ciclo completo",
    de: "Wieder ein Zyklus abgeschlossen",
    fr: "Un autre cycle terminé",
  },
  inviteHookSecondTitleClose9: {
    ru: "Скоро покажу результат",
    en: "Soon I’ll share the outcome",
    es: "Pronto compartiré el resultado",
    pt: "Em breve compartilho o resultado",
    de: "Ergebnis folgt bald",
    fr: "Je partagerai bientôt le résultat",
  },
  inviteHookSecondTitleClose10: {
    ru: "Сделка отработала идеально",
    en: "Trade unfolded just right",
    es: "La operación salió perfecta",
    pt: "Operação rolou do jeito certo",
    de: "Trade lief genau richtig",
    fr: "Trade déroulé parfaitement",
  },
  inviteHookSecondTitleClose11: {
    ru: "Выход по плану",
    en: "Exit as planned",
    es: "Salida según lo planeado",
    pt: "Saída conforme o plano",
    de: "Ausstieg wie geplant",
    fr: "Sortie selon le plan",
  },
  inviteHookSecondTitleClose12: {
    ru: "Дисциплина на месте",
    en: "Discipline held",
    es: "Disciplina mantenida",
    pt: "Disciplina mantida",
    de: "Disziplin gehalten",
    fr: "Discipline tenue",
  },
  inviteHookSecondTitleClose13: {
    ru: "Готовлюсь к следующему",
    en: "Next move loading",
    es: "Preparando el siguiente movimiento",
    pt: "Próximo movimento a caminho",
    de: "Nächster Move in Vorbereitung",
    fr: "Prêt pour le prochain move",
  },
  inviteHookSecondTitleClose14: {
    ru: "План сработал отлично",
    en: "Plan worked well",
    es: "El plan funcionó bien",
    pt: "Plano funcionou bem",
    de: "Plan hat funktioniert",
    fr: "Le plan a bien fonctionné",
  },
  inviteHookSecondTitleClose15: {
    ru: "Двигаюсь дальше",
    en: "Focus shifts forward",
    es: "Foco adelante",
    pt: "Foco no próximo",
    de: "Fokus nach vorn",
    fr: "Focus sur la suite",
  },
  inviteHookSecondTitleClose16: {
    ru: "Выдержал до конца",
    en: "Patience maintained",
    es: "Paciencia recompensada",
    pt: "Paciência recompensada",
    de: "Geduld ausgezahlt",
    fr: "Patience récompensée",
  },
  inviteHookSecondTitleClose17: {
    ru: "Жду новую возможность",
    en: "Now watching for next setup",
    es: "Esperando la siguiente oportunidad",
    pt: "Aguardando o próximo setup",
    de: "Warte aufs nächste Setup",
    fr: "Attente du prochain setup",
  },
  inviteHookSecondTitleClose18: {
    ru: "Результат позже",
    en: "Recap later",
    es: "Resumen después",
    pt: "Resumo depois",
    de: "Fazit folgt",
    fr: "Résumé à venir",
  },
  inviteHookSecondTitleClose19: {
    ru: "Исполнение точное",
    en: "Execution on point",
    es: "Ejecución precisa",
    pt: "Execução perfeita",
    de: "Ausführung auf Punkt",
    fr: "Exécution au top",
  },
  inviteHookSecondTitleClose20: {
    ru: "Всё по плану",
    en: "Everything as planned",
    es: "Todo según el plan",
    pt: "Tudo conforme o planejado",
    de: "Alles wie geplant",
    fr: "Tout selon le plan",
  },
  inviteHookSecondTitleClose21: {
    ru: "Плавное закрытие",
    en: "Smooth closure",
    es: "Cierre suave",
    pt: "Fechamento suave",
    de: "Glatter Abschluss",
    fr: "Fermeture fluide",
  },
  inviteHookSecondTitleClose22: {
    ru: "План соблюдён",
    en: "Plan respected",
    es: "Plan respetado",
    pt: "Plano respeitado",
    de: "Plan respektiert",
    fr: "Plan respecté",
  },
  inviteHookSecondTitleClose23: {
    ru: "Сделка спокойно доведена до конца",
    en: "Another trade executed with calm",
    es: "Operación finalizada con calma",
    pt: "Operação concluída com calma",
    de: "Ruhiger Abschluss mit Kontrolle",
    fr: "Un autre trade calme",
  },
  inviteHookSecondTitleClose24: {
    ru: "Шаг за шагом, без спешки",
    en: "Step by step, no rush",
    es: "Paso a paso, sin prisa",
    pt: "Passo a passo, sem pressa",
    de: "Schritt für Schritt, keine Eile",
    fr: "Étape par étape, sans stress",
  },
  inviteHookSecondTitleClose25: {
    ru: "Терпение сработало",
    en: "Patience all the way",
    es: "Pura paciencia",
    pt: "Pura paciência",
    de: "Reine Geduld",
    fr: "Patience du début à la fin",
  },
  inviteHookSecondTitleClose26: {
    ru: "Время подвести итоги",
    en: "Time to review results",
    es: "Hora de revisar resultados",
    pt: "Hora de revisar resultados",
    de: "Zeit, das Ergebnis zu prüfen",
    fr: "Temps d’analyser les résultats",
  },
  inviteHookSecondTitleClose27: {
    ru: "Точное завершение",
    en: "Precise closure",
    es: "Cierre preciso",
    pt: "Fechamento preciso",
    de: "Präziser Abschluss",
    fr: "Clôture précise",
  },
  inviteHookSecondTitleClose28: {
    ru: "Всё по ритму",
    en: "All in rhythm",
    es: "Todo en ritmo",
    pt: "Tudo no ritmo",
    de: "Alles im Rhythmus",
    fr: "Tout en rythme",
  },
  inviteHookSecondTitleClose29: {
    ru: "Строго по плану",
    en: "Exactly by plan",
    es: "Exactamente según el plan",
    pt: "Exatamente conforme o plano",
    de: "Exakt nach Plan",
    fr: "Exactement selon le plan",
  },
  inviteHookSecondTitleClose30: {
    ru: "Стабильная дисциплина",
    en: "Steady discipline",
    es: "Disciplina constante",
    pt: "Disciplina constante",
    de: "Disziplin durchgezogen",
    fr: "Discipline constante",
  },
  inviteHookSecondTitleClose31: {
    ru: "Спокойно и чётко",
    en: "Simple and calm",
    es: "Simple y tranquilo",
    pt: "Simples e calmo",
    de: "Ruhig und einfach",
    fr: "Simple et calme",
  },
  inviteHookSecondTitleClose32: {
    ru: "Двигаюсь дальше",
    en: "Next page coming",
    es: "Nueva página pronto",
    pt: "Próxima página chegando",
    de: "Nächste Seite kommt",
    fr: "Nouvelle page à venir",
  },
  inviteHookSecondTitleClose33: {
    ru: "Стабильная работа от начала до конца",
    en: "Steady run from start to end",
    es: "Operación constante de principio a fin",
    pt: "Operação estável do início ao fim",
    de: "Stabil vom Anfang bis zum Ende",
    fr: "Régulier du début à la fin",
  },
  inviteHookSecondTitleClose34: {
    ru: "Терпение не подвело",
    en: "Patience carried through",
    es: "La paciencia valió la pena",
    pt: "Paciência recompensada",
    de: "Geduld zahlt sich aus",
    fr: "Patience jusqu’au bout",
  },
  inviteHookSecondTitleClose35: {
    ru: "Чистое исполнение",
    en: "Clean execution",
    es: "Ejecución limpia",
    pt: "Execução limpa",
    de: "Sauber ausgeführt",
    fr: "Exécution propre",
  },
  inviteHookSecondTitleClose36: {
    ru: "Дисциплина прежде всего",
    en: "Discipline first",
    es: "Disciplina primero",
    pt: "Disciplina em primeiro lugar",
    de: "Disziplin zuerst",
    fr: "Discipline avant tout",
  },
  inviteHookSecondTitleClose37: {
    ru: "План выполнен, спокойный выход",
    en: "Full plan done, calm exit",
    es: "Plan cumplido, salida tranquila",
    pt: "Plano cumprido, saída tranquila",
    de: "Plan erfüllt, ruhiger Exit",
    fr: "Plan terminé, sortie calme",
  },
  inviteHookSecondTitleClose38: {
    ru: "Сделка сработала как запланировано",
    en: "Trade behaved as planned",
    es: "El trade se comportó como esperaba",
    pt: "Trade seguiu conforme o esperado",
    de: "Trade lief wie erwartet",
    fr: "Trade conforme au plan",
  },
  inviteHookSecondTitleClose39: {
    ru: "Точно по графику",
    en: "Right on schedule",
    es: "Justo a tiempo",
    pt: "Tudo no tempo certo",
    de: "Alles im Zeitplan",
    fr: "Pile dans le timing",
  },
  inviteHookSecondTitleClose40: {
    ru: "Остаюсь терпеливым",
    en: "Staying patient",
    es: "Manteniendo la calma",
    pt: "Mantendo a calma",
    de: "Ruhig geblieben",
    fr: "Calme et précis",
  },
  inviteHookSecondTitleClose41: {
    ru: "Сделка завершена",
    en: "That’s a wrap for this trade",
    es: "Cierre total de esta operación",
    pt: "Trade encerrado por completo",
    de: "Trade komplett beendet",
    fr: "Trade bouclé, on garde le focus",
  },
  inviteHookSecondTitleClose42: {
    ru: "Спокойно и уверенно",
    en: "Clarity and calm",
    es: "Clara y calmada",
    pt: "Clareza e calma",
    de: "Klar und ruhig",
    fr: "Clarté et calme",
  },
  inviteHookSecondTitleClose43: {
    ru: "Ещё одно движение завершено",
    en: "One more move executed",
    es: "Otro movimiento ejecutado",
    pt: "Mais um movimento executado",
    de: "Ein weiterer Move fertig",
    fr: "Un autre mouvement exécuté",
  },
  inviteHookSecondTitleClose44: {
    ru: "Выход сделан",
    en: "Exit made",
    es: "Salida hecha",
    pt: "Saída feita",
    de: "Exit gemacht",
    fr: "Sortie effectuée",
  },
  inviteHookSecondTitleClose45: {
    ru: "Без сюрпризов",
    en: "No surprises",
    es: "Sin sorpresas",
    pt: "Sem surpresas",
    de: "Keine Überraschungen",
    fr: "Aucune surprise",
  },
  inviteHookSecondTitleClose46: {
    ru: "Концентрация сохранена",
    en: "Focus stays steady",
    es: "Enfoque estable",
    pt: "Foco contínuo",
    de: "Fokus bleibt stabil",
    fr: "Focus toujours stable",
  },
  inviteHookSecondTitleClose47: {
    ru: "Готовлюсь к следующей",
    en: "Time to prepare for next",
    es: "Preparándome para la siguiente",
    pt: "Hora de preparar o próximo",
    de: "Bereit für den nächsten",
    fr: "Prêt pour le prochain",
  },
  inviteHookSecondTitleClose48: {
    ru: "Результат позже, главное — дисциплина",
    en: "Results later, discipline now",
    es: "Resultados después, disciplina ahora",
    pt: "Resultados depois, disciplina agora",
    de: "Ergebnisse später, Disziplin jetzt",
    fr: "Résultats plus tard, discipline maintenant",
  },
  inviteHookSecondTitleClose49: {
    ru: "Сохраняю ритм",
    en: "Rhythm stays the same",
    es: "Manteniendo el ritmo",
    pt: "Ritmo mantido",
    de: "Rhythmus bleibt gleich",
    fr: "Même rythme, même calme",
  },
  inviteHookSecondTitleClose50: {
    ru: "Система отработала",
    en: "System worked",
    es: "Sistema funcionando",
    pt: "Sistema funcionando",
    de: "System hat funktioniert",
    fr: "Le système a bien fonctionné",
  },
  inviteHookSecondTitleClose51: {
    ru: "Всё по прогнозу",
    en: "Exactly as forecast",
    es: "Todo según lo previsto",
    pt: "Tudo conforme o previsto",
    de: "Alles wie erwartet",
    fr: "Tout selon le plan",
  },
  inviteHookSecondTitleClose52: {
    ru: "Спокойно и чисто",
    en: "Calm and clean",
    es: "Tranquilo y limpio",
    pt: "Calmo e limpo",
    de: "Ruhig und sauber",
    fr: "Calme et propre",
  },
  inviteHookSecondTitleClose53: {
    ru: "Всё чётко по шагам",
    en: "Every step aligned",
    es: "Cada paso alineado",
    pt: "Cada passo alinhado",
    de: "Jeder Schritt stimmte",
    fr: "Chaque étape bien alignée",
  },
  inviteHookSecondTitleClose54: {
    ru: "Концентрация держится",
    en: "Focus stays sharp",
    es: "Enfoque constante",
    pt: "Foco constante",
    de: "Fokus bleibt scharf",
    fr: "Focus maintenu",
  },
  inviteHookSecondTitleClose55: {
    ru: "Всё по плану",
    en: "Execution matched plan",
    es: "Ejecución según el plan",
    pt: "Execução dentro do plano",
    de: "Ausführung wie geplant",
    fr: "Exécution conforme au plan",
  },
  inviteHookSecondTitleClose56: {
    ru: "Терпение вознаграждено",
    en: "Patience in action",
    es: "Paciencia en acción",
    pt: "Paciência em ação",
    de: "Geduld im Spiel",
    fr: "Patience active",
  },
  inviteHookSecondTitleClose57: {
    ru: "Анализ впереди",
    en: "Review next",
    es: "Revisión después",
    pt: "Revisão depois",
    de: "Review folgt",
    fr: "Revue ensuite",
  },
  inviteHookSecondTitleClose58: {
    ru: "Всё по системе",
    en: "All by system rules",
    es: "Todo según las reglas",
    pt: "Tudo conforme as regras",
    de: "Alles nach Systemregeln",
    fr: "Tout selon les règles du système",
  },
  inviteHookSecondTitleClose59: {
    ru: "Спокойно и чисто",
    en: "Clean and calm closure",
    es: "Cierre limpio y tranquilo",
    pt: "Fechamento limpo e tranquilo",
    de: "Sauberer, ruhiger Abschluss",
    fr: "Clôture propre et calme",
  },
  inviteHookSecondTitleClose60: {
    ru: "Стабильно и по плану",
    en: "Steady as planned",
    es: "Estable como se planeó",
    pt: "Estável como planejado",
    de: "Stabil wie geplant",
    fr: "Stable, comme prévu",
  },
  inviteHookSecondTitleClose61: {
    ru: "Последний тик совпал с планом",
    en: "Last tick matched my plan",
    es: "El último tick coincidió con mi plan",
    pt: "Último tick bateu com meu plano",
    de: "Letzter Tick passte zum Plan",
    fr: "Dernier tick selon le plan",
  },
  inviteHookSecondTitleClose62: {
    ru: "Обычная рутинная работа",
    en: "Pure routine, nothing fancy",
    es: "Pura rutina, sin drama",
    pt: "Pura rotina, sem drama",
    de: "Reine Routine, kein Drama",
    fr: "Routine pure, rien d’extra",
  },
  inviteHookSecondTitleClose63: {
    ru: "Сделка сработала отлично",
    en: "Trade behaved well",
    es: "Operación bien ejecutada",
    pt: "Trade seguiu bem",
    de: "Trade lief gut",
    fr: "Trade bien géré",
  },
  inviteHookSecondTitleClose64: {
    ru: "Простое закрытие, всё в потоке",
    en: "Simple close, good flow",
    es: "Cierre simple, buen flujo",
    pt: "Fechamento simples, bom fluxo",
    de: "Einfacher Exit, sauberer Flow",
    fr: "Fermeture simple, bon flow",
  },
  inviteHookSecondTitleClose65: {
    ru: "Правила соблюдены",
    en: "Rules respected",
    es: "Reglas respetadas",
    pt: "Regras respeitadas",
    de: "Regeln beachtet",
    fr: "Règles respectées",
  },
  inviteHookSecondTitleClose66: {
    ru: "Спокойно и методично",
    en: "Calm and methodical",
    es: "Calmo y metódico",
    pt: "Calmo e metódico",
    de: "Ruhig und methodisch",
    fr: "Calme et méthodique",
  },
  inviteHookSecondTitleClose67: {
    ru: "Снова терпение",
    en: "Patience again",
    es: "Paciencia una vez más",
    pt: "Paciência mais uma vez",
    de: "Wieder Geduld bewiesen",
    fr: "Encore une fois, patience",
  },
  inviteHookSecondTitleClose68: {
    ru: "Структура сохранена, без спешки",
    en: "Structure intact, no rush",
    es: "Estructura intacta, sin prisa",
    pt: "Estrutura intacta, sem pressa",
    de: "Struktur bleibt intakt",
    fr: "Structure intacte",
  },
  inviteHookSecondTitleClose69: {
    ru: "Сделка закрыта аккуратно",
    en: "Trade settled neatly",
    es: "Trade cerrado con orden",
    pt: "Trade encerrado de forma ordenada",
    de: "Sauber beendet",
    fr: "Trade clôturé proprement",
  },
  inviteHookSecondTitleClose70: {
    ru: "Очередное закрытие по системе",
    en: "Another rule-based close",
    es: "Otro cierre basado en reglas",
    pt: "Outro fechamento baseado em regras",
    de: "Regelbasierter Abschluss",
    fr: "Clôture basée sur les règles",
  },
  inviteHookSecondTitleClose71: {
    ru: "Процесс важнее всего",
    en: "Process matters most",
    es: "El proceso es lo más importante",
    pt: "O processo é o que mais importa",
    de: "Prozess zählt am meisten",
    fr: "Le process avant tout",
  },
  inviteHookSecondTitleClose72: {
    ru: "Дисциплина прежде всего",
    en: "Discipline first",
    es: "Disciplina primero",
    pt: "Disciplina primeiro",
    de: "Disziplin zuerst",
    fr: "Discipline d’abord",
  },
  inviteHookSecondTitleClose73: {
    ru: "Спокойно и стабильно",
    en: "Calm and consistent",
    es: "Calma y consistencia",
    pt: "Calma e consistência",
    de: "Ruhig und konstant",
    fr: "Calme et constance",
  },
  inviteHookSecondTitleClose74: {
    ru: "Терпение, как всегда",
    en: "Patience, as always",
    es: "Paciencia, como siempre",
    pt: "Paciência, como sempre",
    de: "Geduld, wie immer",
    fr: "Patience, comme toujours",
  },
  inviteHookSecondTitleClose75: {
    ru: "Поток продолжается",
    en: "Flow continues",
    es: "El flujo continúa",
    pt: "O fluxo continua",
    de: "Flow geht weiter",
    fr: "Le flow continue",
  },
  inviteHookSecondTitleClose76: {
    ru: "Структура сохранилась",
    en: "Structure intact",
    es: "Estructura intacta",
    pt: "Estrutura intacta",
    de: "Struktur bleibt",
    fr: "Structure intacte",
  },
  inviteHookSecondTitleClose77: {
    ru: "Процесс соблюдён",
    en: "Process intact",
    es: "Proceso cumplido",
    pt: "Processo concluído",
    de: "Prozess stabil",
    fr: "Process respecté",
  },
  inviteHookSecondTitleClose78: {
    ru: "Время искать новую",
    en: "Back to scanning next",
    es: "Buscando la próxima oportunidad",
    pt: "Em busca do próximo setup",
    de: "Nächstes Setup im Blick",
    fr: "En recherche du prochain setup",
  },
  inviteHookSecondTitleClose79: {
    ru: "План выполнен",
    en: "Plan executed",
    es: "Plan cumplido",
    pt: "Plano cumprido",
    de: "Plan erfüllt",
    fr: "Plan exécuté",
  },
  inviteHookSecondTitleClose80: {
    ru: "Ритм сохранён",
    en: "Keeping the rhythm",
    es: "Ritmo constante",
    pt: "Ritmo constante",
    de: "Rhythmus bleibt",
    fr: "Rythme maintenu",
  },
  inviteHookSecondTitleClose81: {
    ru: "Полный цикл завершён",
    en: "Full cycle closed",
    es: "Ciclo completo cerrado",
    pt: "Ciclo completo encerrado",
    de: "Voller Zyklus beendet",
    fr: "Cycle complet terminé",
  },
  inviteHookSecondTitleClose82: {
    ru: "Без драмы, по плану",
    en: "No drama, just plan",
    es: "Sin drama, solo el plan",
    pt: "Sem drama, só o plano",
    de: "Kein Drama, nur Plan",
    fr: "Sans drame, juste le plan",
  },
  inviteHookSecondTitleClose83: {
    ru: "Всё по системе",
    en: "All according to system",
    es: "Todo según el sistema",
    pt: "Tudo conforme o sistema",
    de: "Alles nach System",
    fr: "Tout selon le système",
  },
  inviteHookSecondTitleClose84: {
    ru: "Процесс доведён до конца",
    en: "Clean process end",
    es: "Proceso concluido",
    pt: "Processo concluído",
    de: "Sauberer Prozess-Ende",
    fr: "Fin de process propre",
  },
  inviteHookSecondTitleClose85: {
    ru: "Сделка синхронна с планом",
    en: "Trade in sync",
    es: "Operación sincronizada",
    pt: "Trade em sincronia",
    de: "Trade im Einklang",
    fr: "Trade en accord total",
  },
  inviteHookSecondTitleClose86: {
    ru: "Спокойно и осознанно",
    en: "Calm and deliberate",
    es: "Tranquilo y decidido",
    pt: "Calmo e firme",
    de: "Ruhig und kontrolliert",
    fr: "Calme et posée",
  },
  inviteHookSecondTitleClose87: {
    ru: "Всё вовремя",
    en: "Right timing",
    es: "Timing perfecto",
    pt: "No timing certo",
    de: "Perfektes Timing",
    fr: "Timing parfait",
  },
  inviteHookSecondTitleClose88: {
    ru: "Очередной цикл позади",
    en: "Just another cycle finished",
    es: "Otro ciclo completo",
    pt: "Mais um ciclo completo",
    de: "Wieder ein Zyklus fertig",
    fr: "Un autre cycle clôturé",
  },
  inviteHookSecondTitleClose89: {
    ru: "Фокус на следующую",
    en: "Focus on next",
    es: "Foco en la siguiente",
    pt: "Foco no próximo",
    de: "Fokus auf den nächsten",
    fr: "Focus sur le prochain",
  },
  inviteHookSecondTitleClose90: {
    ru: "Структура осталась прочной",
    en: "Structure stayed solid",
    es: "Estructura firme",
    pt: "Estrutura sólida",
    de: "Struktur stabil geblieben",
    fr: "Structure solide",
  },
  inviteHookSecondTitleClose91: {
    ru: "Ясность сохранена",
    en: "Clarity holds",
    es: "Claridad mantenida",
    pt: "Clareza mantida",
    de: "Klarheit bleibt",
    fr: "Clarté maintenue",
  },
  inviteHookSecondTitleClose92: {
    ru: "Правила соблюдены, всё чисто",
    en: "Rules followed, end clean",
    es: "Reglas seguidas, cierre limpio",
    pt: "Regras seguidas, fechamento limpo",
    de: "Regeln befolgt, sauberer Abschluss",
    fr: "Règles respectées, clôture propre",
  },
  inviteHookSecondTitleClose93: {
    ru: "Спокойный день",
    en: "Another calm day",
    es: "Otro día tranquilo",
    pt: "Mais um dia tranquilo",
    de: "Wieder ein ruhiger Tag",
    fr: "Encore une journée calme",
  },
  inviteHookSecondTitleClose94: {
    ru: "Всё чётко по плану",
    en: "No surprises, pure plan",
    es: "Todo según el plan",
    pt: "Sem surpresas, puro plano",
    de: "Keine Überraschungen, klarer Plan",
    fr: "Aucune surprise, plan clair",
  },
  inviteHookSecondTitleClose95: {
    ru: "Ещё одно стабильное закрытие",
    en: "One more steady close",
    es: "Otro cierre estable",
    pt: "Mais um fechamento estável",
    de: "Ein weiterer stabiler Abschluss",
    fr: "Une autre clôture stable",
  },
  inviteHookSecondTitleClose96: {
    ru: "Готовлюсь к новым сетапам",
    en: "Ready for new setups",
    es: "Lista para nuevos setups",
    pt: "Pronta para novos setups",
    de: "Bereit für neue Setups",
    fr: "Prête pour les prochains setups",
  },
  inviteHookSecondTitleClose97: {
    ru: "Ритм сохраняется",
    en: "Rhythm continues",
    es: "Ritmo mantenido",
    pt: "Ritmo mantido",
    de: "Rhythmus läuft weiter",
    fr: "Rythme constant",
  },
  inviteHookSecondTitleClose98: {
    ru: "Терпение снова оправдалось",
    en: "Patience keeps guiding",
    es: "Paciencia recompensada",
    pt: "Paciência recompensada",
    de: "Geduld zahlt sich erneut aus",
    fr: "Patience encore récompensée",
  },
  inviteHookSecondTitleClose99: {
    ru: "Ещё одно чистое исполнение",
    en: "Another clear execution",
    es: "Ejecución clara una vez más",
    pt: "Execução clara mais uma vez",
    de: "Klare Ausführung erneut",
    fr: "Exécution claire",
  },
  inviteHookSecondTitleClose100: {
    ru: "Цикл завершён, система держится уверенно",
    en: "Cycle complete, system holds strong",
    es: "Ciclo completo, el sistema sigue fuerte",
    pt: "Ciclo completo, sistema segue firme",
    de: "Zyklus komplett, System bleibt stark",
    fr: "Cycle complet, système solide",
  },
  inviteHookSecondTitleClose101: {
    ru: "Скоро покажу, как всё развивалось",
    en: "Will show soon how it all played out",
    es: "Pronto mostraré cómo se desarrolló todo",
    pt: "Em breve mostro como tudo se desenrolou",
    de: "Geschlossen. Bald zeige ich, wie sich alles entwickelt hat",
    fr: "Clôturée. Je montrerai bientôt comment tout s’est déroulé",
  },
  inviteHookSecondTitleClose102: {
    ru: "Финал есть, а детали — в следующем видео",
    en: "The ending’s here — details in the next video",
    es: "El cierre está hecho — los detalles, en el próximo video",
    pt: "O fechamento está feito — os detalhes, no próximo vídeo",
    de: "Beendet. Abschluss steht – Details im nächsten Video",
    fr: "Terminée. Clôture faite – détails dans la prochaine vidéo",
  },
  inviteHookSecondTitleClose103: {
    ru: "Всё по плану, разбор позже",
    en: "All went as planned, breakdown later",
    es: "Todo salió según el plan, análisis después",
    pt: "Tudo conforme o plano, análise depois",
    de: "Geschlossen. Alles nach Plan, Analyse folgt",
    fr: "Fermée. Tout selon le plan, analyse à venir",
  },
  inviteHookSecondTitleClose104: {
    ru: "Позже покажу, как происходило",
    en: "Will show how it unfolded later",
    es: "Más adelante mostraré cómo fue el proceso",
    pt: "Mais tarde mostro como aconteceu",
    de: "Ausgestiegen. Später zeige ich, wie es gelaufen ist",
    fr: "Je montrerai plus tard comment cela s’est passé",
  },
  inviteHookSecondTitleClose105: {
    ru: "Результат готов, история — впереди",
    en: "Story coming soon",
    es: "Historia pronto",
    pt: "História em breve",
    de: "Beendet. Ergebnis folgt, Geschichte später",
    fr: "Terminé. Résumé à venir, histoire plus tard",
  },
  inviteHookSecondTitleClose106: {
    ru: "Итог покажу позже",
    en: "I’ll share more soon",
    es: "Compartiré más pronto",
    pt: "Mostro mais em breve",
    de: "Abgeschlossen. Ergebnisse folgen bald",
    fr: "Clôturé. Mise à jour à venir",
  },
  inviteHookSecondTitleClose107: {
    ru: "Выводы будут впереди",
    en: "Takeaways coming soon",
    es: "Conclusiones próximamente",
    pt: "Conclusões virão depois",
    de: "Fazit kommt später",
    fr: "Bilan bientôt",
  },
  inviteHookSecondTitleClose108: {
    ru: "Всё сработало, как ожидалось. Разбор скоро",
    en: "Everything worked as expected. Recap soon",
    es: "Todo funcionó como se esperaba. Resumen pronto",
    pt: "Tudo funcionou como esperado. Resumo em breve",
    de: "Ausgestiegen. Alles lief wie erwartet",
    fr: "Tout s’est déroulé comme prévu. Analyse à venir",
  },
  inviteHookSecondTitleClose109: {
    ru: "Результат скоро",
    en: "Update soon",
    es: "Actualización pronto",
    pt: "Atualização em breve",
    de: "Beendet. Update kommt bald",
    fr: "Terminé. Rapport bientôt",
  },
  inviteHookSecondTitleClose110: {
    ru: "Финал предсказуемый. Результаты — позже",
    en: "Predictable ending. Full review later",
    es: "Final predecible. Revisión completa más adelante",
    pt: "Final previsível. Revisão completa mais tarde",
    de: "Absehbares Ende. Ergebnisse später",
    fr: "Fin prévisible. Résultats plus tard",
  },
  inviteHookSecondTitleClose111: {
    ru: "Скоро соберу весь путь сделки в одном видео",
    en: "I’ll post the full story soon",
    es: "Pronto publicaré toda la historia en un solo video",
    pt: "Logo publico toda a trajetória em um único vídeo",
    de: "Bald der gesamte Trade in einem Video",
    fr: "Bientôt la vidéo complète du trade",
  },
  inviteHookSecondTitleClose112: {
    ru: "Через пару дней покажу полный цикл",
    en: "In a couple of days, I’ll show the full cycle",
    es: "En un par de días mostraré todo el ciclo",
    pt: "Em alguns dias mostro todo o ciclo",
    de: "Bestätigt. In ein paar Tagen zeige ich den kompletten Zyklus",
    fr: "Confirmée. D’ici quelques jours, je montrerai le cycle complet",
  },
  inviteHookSecondTitleClose113: {
    ru: "Следующий шаг — визуальный разбор всей позиции",
    en: "Next step — full visual recap",
    es: "Siguiente paso — análisis visual completo",
    pt: "Próximo passo — análise visual completa",
    de: "Nächster Schritt — visuelle Analyse",
    fr: "Prochaine étape — analyse visuelle",
  },
  inviteHookSecondTitleClose114: {
    ru: "Финал есть, теперь время анализировать",
    en: "The ending’s here, now it’s time to analyze",
    es: "El cierre está hecho, ahora toca analizar",
    pt: "O encerramento está feito, agora é hora de analisar",
    de: "Abschluss steht, jetzt wird analysiert",
    fr: "Fin du cycle, place à l’analyse",
  },
  inviteHookSecondTitleClose115: {
    ru: "Впереди короткий разбор",
    en: "Quick recap ahead",
    es: "Pequeño resumen en camino",
    pt: "Breve resumo a caminho",
    de: "Kurze Zusammenfassung folgt",
    fr: "Récapitulatif à venir",
  },
  inviteHookSecondTitleClose116: {
    ru: "В ближайшее время покажу динамику движения",
    en: "I’ll show the market move soon",
    es: "Pronto mostraré el movimiento del mercado",
    pt: "Em breve mostro a movimentação do mercado",
    de: "Bald zeige ich die Marktbewegung",
    fr: "Je montrerai bientôt la dynamique du marché",
  },
  inviteHookSecondTitleClose117: {
    ru: "Скоро выложу, как шаг за шагом шёл процесс",
    en: "Will post soon how the process unfolded step by step",
    es: "Pronto publicaré paso a paso cómo fue el proceso",
    pt: "Em breve mostro o passo a passo do processo",
    de: "Zeige bald den gesamten Prozess Schritt für Schritt",
    fr: "Bientôt, le processus complet étape par étape",
  },
  inviteHookSecondTitleClose118: {
    ru: "Осталось только оформить итог",
    en: "Just need to wrap it up",
    es: "Solo falta cerrar el capítulo",
    pt: "Falta apenas fechar o capítulo",
    de: "Nur noch das Fazit bleibt",
    fr: "Il ne reste plus qu’à faire le bilan",
  },
  inviteHookSecondTitleClose119: {
    ru: "Через время соберу все этапы в одном Reels",
    en: "Soon I’ll compile all stages into one reel",
    es: "Pronto reuniré todas las etapas en un solo reel",
    pt: "Em breve reúno todas as etapas em um único Reels",
    de: "Bald fasse ich alle Etappen in einem Reels zusammen",
    fr: "Bientôt un Reels avec toutes les étapes",
  },
  inviteHookSecondTitleClose120: {
    ru: "Следом покажу, как выглядел весь путь сделки",
    en: "Will show the full path of the trade next",
    es: "Mostraré el recorrido completo de la operación después",
    pt: "Mostrarei o caminho completo da operação depois",
    de: "Bald zeige ich den gesamten Trade-Prozess",
    fr: "Je montrerai bientôt le déroulement complet du trade",
  },
  inviteHookSecondTitleClose121: {
    ru: "Чувствуется лёгкость — цикл завершён",
    en: "Feels light — cycle completed",
    es: "Se siente liviano — ciclo completado",
    pt: "Sensação leve — ciclo completo",
    de: "Leichtes Gefühl – Zyklus vollendet",
    fr: "Sensation de légèreté – cycle accompli",
  },
  inviteHookSecondTitleClose122: {
    ru: "Можно расслабиться",
    en: "Time to reset",
    es: "Momento de descansar",
    pt: "Hora de relaxar",
    de: "Jetzt kann ich durchatmen",
    fr: "Moment de respirer",
  },
  inviteHookSecondTitleClose123: {
    ru: "Всё успокоилось",
    en: "Everything’s calm now",
    es: "Todo tranquilo ahora",
    pt: "Tudo tranquilo agora",
    de: "Alles ruhig jetzt",
    fr: "Tout est calme maintenant",
  },
  inviteHookSecondTitleClose124: {
    ru: "Финал чистый, картина аккуратная",
    en: "Clean finish, neat picture",
    es: "Cierre limpio, imagen clara",
    pt: "Encerramento limpo, imagem clara",
    de: "Sauberer Abschluss, klares Bild",
    fr: "Clôture propre, visuel net",
  },
  inviteHookSecondTitleClose125: {
    ru: "И это хорошо",
    en: "And that’s fine",
    es: "Y eso está bien",
    pt: "E está tudo bem",
    de: "Und das ist gut so",
    fr: "Et c’est très bien ainsi",
  },
  inviteHookSecondTitleClose126: {
    ru: "Чувствуется завершение и спокойствие",
    en: "Feels like closure and calm",
    es: "Se siente cierre y calma",
    pt: "Sensação de encerramento e calma",
    de: "Gefühl von Ruhe und Abschluss",
    fr: "Sensation de paix et de clôture",
  },
  inviteHookSecondTitleClose127: {
    ru: "Чистый финал, скоро итоги",
    en: "Smooth ending, recap soon",
    es: "Final limpio, resumen pronto",
    pt: "Encerramento limpo, resumo em breve",
    de: "Sauberer Abschluss, Fazit folgt",
    fr: "Clôture propre, résumé bientôt",
  },
  inviteHookSecondTitleClose128: {
    ru: "По плану",
    en: "All according to plan",
    es: "Todo según el plan",
    pt: "Tudo conforme o plano",
    de: "Nach Plan",
    fr: "Selon le plan",
  },
  inviteHookSecondTitleClose129: {
    ru: "Визуально — чистая точка",
    en: "Visually — a clean point",
    es: "Visualmente — punto limpio",
    pt: "Visualmente — ponto limpo",
    de: "Visuell — perfekter Punkt",
    fr: "Visuellement — point parfait",
  },
  inviteHookSecondTitleClose130: {
    ru: "Итоги будут",
    en: "Recap soon",
    es: "Resumen pronto",
    pt: "Resumo em breve",
    de: "Fazit folgt",
    fr: "Résumé à venir",
  },
  inviteHookSecondTitleClose131: {
    ru: "Всё отработало без напряжения",
    en: "All went smoothly, no tension",
    es: "Todo fluyó sin tensión",
    pt: "Tudo fluiu sem tensão",
    de: "Alles lief ruhig und kontrolliert",
    fr: "Tout s’est déroulé sans tension",
  },
  inviteHookSecondTitleClose132: {
    ru: "Теперь — спокойствие, без риска",
    en: "Now calm, no risk",
    es: "Ahora calma, sin riesgo",
    pt: "Agora calma, sem risco",
    de: "Jetzt Ruhe, kein Risiko",
    fr: "Calme maintenant, aucun risque",
  },
  inviteHookSecondTitleClose133: {
    ru: "Стабильная работа, итоги покажу, ждем",
    en: "Steady process, update coming",
    es: "Proceso constante, actualización en camino",
    pt: "Processo constante, atualização em breve",
    de: "Stabiles Ergebnis, Update folgt",
    fr: "Exécution stable, résumé à venir",
  },
  inviteHookSecondTitleClose134: {
    ru: "Терпение отработало",
    en: "Patience paid off",
    es: "La paciencia dio fruto",
    pt: "A paciência valeu a pena",
    de: "Geduld hat sich ausgezahlt",
    fr: "La patience a payé",
  },
  inviteHookSecondTitleClose135: {
    ru: "Чистое исполнение. Теперь подвести итоги",
    en: "Clean execution. Time to look back",
    es: "Ejecución limpia. Hora de revisar",
    pt: "Execução limpa. Hora de revisar",
    de: "Sauber ausgeführt. Zeit für den Rückblick",
    fr: "Exécution propre. Temps pour le débrief",
  },
  inviteHookSecondTitleClose136: {
    ru: "Сетап сыграл — теперь можно выдохнуть",
    en: "Setup worked — now time to breathe",
    es: "El setup funcionó — ahora a respirar",
    pt: "O setup funcionou — agora posso respirar",
    de: "Setup funktioniert – jetzt durchatmen",
    fr: "Setup validé – temps de respirer",
  },
  inviteHookSecondTitleClose137: {
    ru: "План выполнен ровно",
    en: "Plan followed perfectly",
    es: "Plan seguido al pie de la letra",
    pt: "Plano seguido à risca",
    de: "Plan exakt umgesetzt",
    fr: "Plan exécuté avec précision",
  },
  inviteHookSecondTitleClose138: {
    ru: "Перехожу в состояние покоя. Временно, конечно",
    en: "Switching to calm mode. Just for a while",
    es: "Modo tranquilo activado. Solo por un rato",
    pt: "Modo tranquilo ativado. Só por um tempo",
    de: "Ruhiger Modus aktiviert. Nur vorübergehend",
    fr: "Mode calme activé. Temporairement",
  },
  inviteHookSecondTitleClose139: {
    ru: "Финал спокойный, результат позже",
    en: "Quiet ending, recap later",
    es: "Cierre tranquilo, resumen después",
    pt: "Encerramento calmo, resumo depois",
    de: "Ruhiger Abschluss, Fazit später",
    fr: "Clôture tranquille, bilan à venir",
  },
  inviteHookSecondTitleClose140: {
    ru: "Всё хорошо",
    en: "All good",
    es: "Todo bien",
    pt: "Tudo certo",
    de: "Alles gut gelaufen",
    fr: "Tout est bon",
  },
  inviteHookSecondTitleClose141: {
    ru: "Сделка завершена. Всё по плану, скоро результат",
    en: "Trade finished. All as planned, recap soon",
    es: "Operación finalizada. Todo según el plan, resumen pronto",
    pt: "Operação finalizada. Tudo conforme o plano, resumo em breve",
    de: "Trade beendet. Alles nach Plan, Zusammenfassung bald",
    fr: "Trade clôturé. Tout selon le plan, résumé bientôt",
  },
  inviteHookSecondTitleClose142: {
    ru: "Без лишних эмоций",
    en: "No extra emotions",
    es: "Sin emociones extras",
    pt: "Sem emoções desnecessárias",
    de: "Ohne überflüssige Emotionen",
    fr: "Sans émotion excessive",
  },
  inviteHookSecondTitleClose143: {
    ru: "План выполнен",
    en: "Plan completed",
    es: "Plan cumplido",
    pt: "Plano cumprido",
    de: "Plan erfüllt",
    fr: "Plan respecté",
  },
  inviteHookSecondTitleClose144: {
    ru: "Всё чисто, как должно быть",
    en: "Clean as it should be",
    es: "Limpio, como debe ser",
    pt: "Limpo, como deve ser",
    de: "Alles sauber, wie es sein soll",
    fr: "Tout est propre, comme prévu",
  },
  inviteHookSecondTitleClose145: {
    ru: "Без неожиданностей — стратегия работает",
    en: "No surprises — system works",
    es: "Sin sorpresas — el sistema funciona",
    pt: "Sem surpresas — o sistema funciona",
    de: "Keine Überraschungen – System funktioniert",
    fr: "Aucune surprise – le système fonctionne",
  },
  inviteHookSecondTitleClose146: {
    ru: "Очередной результат без шума",
    en: "Another clean wrap-up",
    es: "Otro cierre limpio",
    pt: "Mais um fechamento limpo",
    de: "Wieder ein ruhiger Abschluss",
    fr: "Encore un résultat calme",
  },
  inviteHookSecondTitleClose147: {
    ru: "Всё закончилось так, как было задумано",
    en: "Ended exactly as intended",
    es: "Terminó exactamente como estaba previsto",
    pt: "Terminou exatamente como planejado",
    de: "Alles wie geplant beendet",
    fr: "Tout s’est terminé comme prévu",
  },
  inviteHookSecondTitleClose148: {
    ru: "План сработал, без случайностей",
    en: "Plan worked — no randomness",
    es: "El plan funcionó — sin azar",
    pt: "O plano funcionou — sem acaso",
    de: "Plan hat funktioniert, kein Zufall",
    fr: "Plan respecté, sans hasard",
  },
  inviteHookSecondTitleClose149: {
    ru: "Контроль и ритм сохраняю",
    en: "Keeping control and rhythm",
    es: "Manteniendo control y ritmo",
    pt: "Mantendo controle e ritmo",
    de: "Kontrolle und Rhythmus beibehalten",
    fr: "Contrôle et rythme conservés",
  },
  inviteHookSecondTitleClose150: {
    ru: "Система сделала своё",
    en: "The system did its job",
    es: "El sistema hizo su trabajo",
    pt: "O sistema fez seu trabalho",
    de: "System hat seinen Job gemacht",
    fr: "Le système a fait son travail",
  },
  inviteHookSecondTitleClose151: {
    ru: "Был ли вход точным? Похоже, да",
    en: "Was the entry precise? Looks like it",
    es: "¿La entrada fue precisa? Parece que sí",
    pt: "A entrada foi precisa? Parece que sim",
    de: "War der Einstieg präzise? Sieht so aus",
    fr: "L’entrée était-elle précise ? On dirait bien",
  },
  inviteHookSecondTitleClose152: {
    ru: "Повторится ли этот сценарий снова?",
    en: "Will this setup repeat again?",
    es: "¿Se repetirá este setup?",
    pt: "Será que esse padrão se repete?",
    de: "Wird sich dieses Muster wiederholen?",
    fr: "Ce scénario se répétera-t-il ?",
  },
  inviteHookSecondTitleClose153: {
    ru: "Интересно, когда будет похожая структура",
    en: "Wondering when a similar setup will show up",
    es: "Me pregunto cuándo aparecerá una estructura parecida",
    pt: "Quando virá uma estrutura parecida?",
    de: "Wann kommt eine ähnliche Struktur?",
    fr: "Curieux de voir quand un pattern similaire reviendra",
  },
  inviteHookSecondTitleClose154: {
    ru: "Всё прошло гладко. Закономерность?",
    en: "Everything went smoothly. Pattern confirmed?",
    es: "Todo fluyó sin problemas. ¿Patrón confirmado?",
    pt: "Tudo fluiu bem. Padrão confirmado?",
    de: "Alles lief glatt. Wiederkehrendes Muster?",
    fr: "Tout s’est déroulé sans accroc. Un schéma qui revient ?",
  },
  inviteHookSecondTitleClose155: {
    ru: "Можно ли было взять больше? Возможно, но не нужно",
    en: "Could I have held longer? Maybe, but no need",
    es: "¿Podría haberla dejado correr más? Tal vez, pero no hacía falta",
    pt: "Poderia ter deixado correr mais? Talvez, mas não era necessário",
    de: "Hätte ich mehr mitnehmen können? Vielleicht, aber unnötig",
    fr: "Aurais-je pu en tirer plus ? Peut-être, mais inutile",
  },
  inviteHookSecondTitleClose156: {
    ru: "Посмотрим дальше",
    en: "Let’s see what’s next",
    es: "Veamos qué sigue",
    pt: "Vamos ver o que vem a seguir",
    de: "Mal sehen, was als Nächstes kommt",
    fr: "On verra la suite",
  },
  inviteHookSecondTitleClose157: {
    ru: "Посмотрим, что дальше",
    en: "Let’s see what comes next",
    es: "Veamos qué viene después",
    pt: "Vamos ver o próximo movimento",
    de: "Sehen wir, was folgt",
    fr: "Voyons ce qui suit",
  },
  inviteHookSecondTitleClose158: {
    ru: "Как поведёт себя рынок дальше?",
    en: "How will the market behave next?",
    es: "¿Cómo reaccionará el mercado ahora?",
    pt: "Como o mercado vai reagir agora?",
    de: "Wie reagiert der Markt jetzt?",
    fr: "Comment le marché réagira-t-il ensuite ?",
  },
  inviteHookSecondTitleClose159: {
    ru: "Это конец цикла или начало нового",
    en: "Is this the end of the cycle or a new start?",
    es: "¿Es el final del ciclo o el inicio de uno nuevo?",
    pt: "É o fim do ciclo ou o início de um novo?",
    de: "Ende des Zyklus oder Beginn eines neuen?",
    fr: "Fin du cycle ou début d’un nouveau ?",
  },
  inviteHookSecondTitleClose160: {
    ru: "Повторим результат?",
    en: "Let’s see if we can repeat the move",
    es: "Veamos si repetimos el movimiento",
    pt: "Vamos repetir o movimento?",
    de: "Wiederholen wir das Ergebnis?",
    fr: "On répète le résultat ?",
  },
  inviteHookSecondTitleClose161: {
    ru: "По системе: вход — терпение — выход",
    en: "System logic: entry — patience — exit",
    es: "Por sistema: entrada — paciencia — salida",
    pt: "Pelo sistema: entrada — paciência — saída",
    de: "Nach System: Einstieg — Geduld — Ausstieg",
    fr: "Selon le système : entrée — patience — sortie",
  },
  inviteHookSecondTitleClose162: {
    ru: "Всё по шаблону, как всегда",
    en: "All by the playbook, as always",
    es: "Todo según el plan, como siempre",
    pt: "Tudo conforme o plano, como sempre",
    de: "Alles nach Plan, wie immer",
    fr: "Tout selon le modèle, comme toujours",
  },
  inviteHookSecondTitleClose163: {
    ru: "Дисциплина даёт предсказуемость — это ключ",
    en: "Discipline brings consistency — that’s the key",
    es: "La disciplina trae consistencia — esa es la clave",
    pt: "Disciplina gera consistência — essa é a chave",
    de: "Disziplin bringt Konstanz – das ist der Schlüssel",
    fr: "La discipline crée la constance – c’est la clé",
  },
  inviteHookSecondTitleClose164: {
    ru: "Ритуал соблюдён, структура отработала",
    en: "Routine followed, structure delivered",
    es: "Rutina seguida, estructura cumplida",
    pt: "Rotina seguida, estrutura cumprida",
    de: "Routine befolgt, Struktur erfüllt",
    fr: "Routine respectée, structure validée",
  },
  inviteHookSecondTitleClose165: {
    ru: "Стратегия сработала снова",
    en: "System proved itself again",
    es: "El sistema volvió a funcionar",
    pt: "O sistema funcionou novamente",
    de: "System funktioniert wieder",
    fr: "Le système a encore fonctionné",
  },
  inviteHookSecondTitleClose166: {
    ru: "Всё просто: правило, терпение, результат",
    en: "Simple: rule, patience, action",
    es: "Simple: regla, paciencia, acción",
    pt: "Simples: regra, paciência, execução",
    de: "Einfach: Regel, Geduld, Ergebnis",
    fr: "Simple : règle, patience, résultat",
  },
  inviteHookSecondTitleClose167: {
    ru: "Система не подводит — только следуй ей",
    en: "The method holds — just follow it",
    es: "El método se mantiene — solo hay que seguirlo",
    pt: "O método se mantém — é só seguir",
    de: "Methode bleibt stabil – nur folgen",
    fr: "Le système reste solide – il suffit de le suivre",
  },
  inviteHookSecondTitleClose168: {
    ru: "Формула та же, результат закономерен",
    en: "Same formula, consistent process",
    es: "Misma fórmula, proceso constante",
    pt: "Mesma fórmula, processo constante",
    de: "Gleiche Formel, konstanter Prozess",
    fr: "Même formule, même cohérence",
  },
  inviteHookSecondTitleClose169: {
    ru: "План выполнен — без лишних эмоций",
    en: "Plan executed — no noise",
    es: "Plan ejecutado — sin ruido",
    pt: "Plano executado — sem ruído",
    de: "Plan umgesetzt – ohne Emotionen",
    fr: "Plan exécuté – sans émotion",
  },
  inviteHookSecondTitleClose170: {
    ru: "Последовательность решает, не случай",
    en: "Consistency wins, not luck",
    es: "La consistencia gana, no la suerte",
    pt: "A consistência vence, não a sorte",
    de: "Beständigkeit siegt, nicht Zufall",
    fr: "La constance prime, pas le hasard",
  },
  inviteHookSecondTitleClose171: {
    ru: "Ещё одна сделка по плану — стабильно",
    en: "Another trade by plan — steady",
    es: "Otra operación según el plan — estable",
    pt: "Mais uma operação dentro do plano — estável",
    de: "Wieder ein Trade im Plan – stabil",
    fr: "Encore un trade selon le plan – stable",
  },
  inviteHookSecondTitleClose172: {
    ru: "Всё, как и в прошлый раз — без сюрпризов",
    en: "Same rhythm — no surprises",
    es: "Mismo ritmo — sin sorpresas",
    pt: "Mesmo ritmo — sem surpresas",
    de: "Gleiches Tempo – keine Überraschungen",
    fr: "Même rythme – aucune surprise",
  },
  inviteHookSecondTitleClose173: {
    ru: "Очередной сетап сработал по системе",
    en: "Another setup followed the system",
    es: "Otro setup cumplido por el sistema",
    pt: "Outro setup cumprido pelo sistema",
    de: "Weiterer Setup nach System erfüllt",
    fr: "Autre setup respecté selon le système",
  },
  inviteHookSecondTitleClose174: {
    ru: "Повторяемость — лучший индикатор устойчивости",
    en: "Repetition means stability",
    es: "La repetición es señal de estabilidad",
    pt: "A repetição é sinal de estabilidade",
    de: "Wiederholung ist Zeichen von Stabilität",
    fr: "La répétition prouve la solidité",
  },
  inviteHookSecondTitleClose175: {
    ru: "История снова подтвердила метод",
    en: "Once again, the pattern confirmed the method",
    es: "Una vez más, el patrón confirmó el método",
    pt: "Mais uma vez, o padrão confirmou o método",
    de: "Methode erneut bestätigt",
    fr: "La méthode confirmée une fois de plus",
  },
  inviteHookSecondTitleClose176: {
    ru: "Рынок повторяет свои привычки",
    en: "Market repeats its rhythm",
    es: "El mercado repite su ritmo",
    pt: "O mercado repete seus hábitos",
    de: "Markt wiederholt seine Gewohnheiten",
    fr: "Le marché répète ses habitudes",
  },
  inviteHookSecondTitleClose177: {
    ru: "План оправдал себя, как и прежде",
    en: "Plan stayed solid, as always",
    es: "El plan se mantuvo sólido, como siempre",
    pt: "O plano se manteve firme, como sempre",
    de: "Plan hielt, wie immer",
    fr: "Plan respecté, comme toujours",
  },
  inviteHookSecondTitleClose178: {
    ru: "Всё стабильно, без отклонений от метода",
    en: "All stable, no deviation from the method",
    es: "Todo estable, sin desviarse del método",
    pt: "Tudo estável, sem desviar do método",
    de: "Alles stabil, keine Abweichung vom System",
    fr: "Tout reste stable, aucune déviation du système",
  },
  inviteHookSecondTitleClose179: {
    ru: "Очередное подтверждение дисциплины",
    en: "Another sign of discipline",
    es: "Otra muestra de disciplina",
    pt: "Mais uma prova de disciplina",
    de: "Wieder ein Beweis für Disziplin",
    fr: "Nouvelle preuve de discipline",
  },
  inviteHookSecondTitleClose180: {
    ru: "Результат закономерен, не случайный",
    en: "Process steady, not random",
    es: "Proceso estable, nada al azar",
    pt: "Processo consistente, nada aleatório",
    de: "Konsistenter Prozess, kein Zufall",
    fr: "Processus cohérent, sans hasard",
  },
  inviteHookSecondTitleClose181: {
    ru: "Без желания «добрать»",
    en: "No urge to overtrade",
    es: "Sin ganas de sobreoperar",
    pt: "Sem vontade de forçar entrada",
    de: "Kein Bedürfnis nach Übertreibung",
    fr: "Sans chercher à en faire trop",
  },
  inviteHookSecondTitleClose182: {
    ru: "Лучше выйти по плану, чем задержаться",
    en: "Better to exit by plan than to chase moves",
    es: "Mejor salir según el plan que quedarse de más",
    pt: "Melhor sair conforme o plano do que ficar demais",
    de: "Lieber nach Plan raus als zu lange bleiben",
    fr: "Mieux vaut sortir selon le plan que rester trop longtemps",
  },
  inviteHookSecondTitleClose183: {
    ru: "Сохранил качество сделки, не гнался за объёмом",
    en: "Kept the quality, skipped the rush",
    es: "Mantuve la calidad, sin apresurarme",
    pt: "Mantive a qualidade, sem pressa",
    de: "Qualität beibehalten, keine Hektik",
    fr: "Qualité du trade préservée, sans précipitation",
  },
  inviteHookSecondTitleClose184: {
    ru: "Риск ограничен, результат покажу",
    en: "Risk controlled, update soon",
    es: "Riesgo bajo control, actualización pronto",
    pt: "Risco sob controle, atualização em breve",
    de: "Risiko begrenzt, Update folgt",
    fr: "Risque maîtrisé, mise à jour à venir",
  },
  inviteHookSecondTitleClose185: {
    ru: "Главное — стабильность, не рекорд",
    en: "Focus on consistency, not records",
    es: "Enfoque en la constancia, no en los récords",
    pt: "Foco na constância, não em recordes",
    de: "Fokus auf Stabilität, nicht Rekorde",
    fr: "L’important, c’est la stabilité, pas le record",
  },
  inviteHookSecondTitleClose186: {
    ru: "Лучше дисциплина, чем азарт",
    en: "Better discipline than excitement",
    es: "Mejor disciplina que euforia",
    pt: "Melhor disciplina do que euforia",
    de: "Disziplin besser als Euphorie",
    fr: "La discipline vaut mieux que l’euphorie",
  },
  inviteHookSecondTitleClose187: {
    ru: "Финал по правилам — капитал в безопасности",
    en: "Closed by the rules — capital safe",
    es: "Cierre según las reglas — capital seguro",
    pt: "Encerramento conforme as regras — capital protegido",
    de: "Abschluss nach Regeln – Kapital geschützt",
    fr: "Clôture selon les règles – capital protégé",
  },
  inviteHookSecondTitleClose188: {
    ru: "Всё под контролем, без эмоций и импульсов",
    en: "Everything under control — no emotions",
    es: "Todo bajo control — sin emociones",
    pt: "Tudo sob controle — sem emoções",
    de: "Alles unter Kontrolle, ohne Emotionen",
    fr: "Tout sous contrôle, sans émotions",
  },
  inviteHookSecondTitleClose189: {
    ru: "Решение обосновано, ждем результаты",
    en: "Decision solid, waiting for the recap",
    es: "Decisión sólida, esperando el resumen",
    pt: "Decisão sólida, aguardando o resumo",
    de: "Entscheidung solide, Fazit folgt",
    fr: "Décision rationnelle, résumé bientôt",
  },
  inviteHookSecondTitleClose190: {
    ru: "Закрыл вовремя — не потерял ритм",
    en: "Closed right on time — rhythm intact",
    es: "Cerré a tiempo — ritmo intacto",
    pt: "Fechei no momento certo — ritmo preservado",
    de: "Zum richtigen Zeitpunkt geschlossen – Rhythmus beibehalten",
    fr: "Fermée au bon moment – rythme conservé",
  },
  inviteHookSecondTitleClose191: {
    ru: "Ритуал: вход, ожидание, выход",
    en: "Routine: entry, patience, exit",
    es: "Rutina: entrada, paciencia, salida",
    pt: "Rotina: entrada, paciência, saída",
    de: "Routine: Einstieg, Geduld, Ausstieg",
    fr: "Routine : entrée, patience, sortie",
  },
  inviteHookSecondTitleClose192: {
    ru: "Очередной цикл — процесс жив",
    en: "Another cycle — process alive",
    es: "Otro ciclo — el proceso sigue vivo",
    pt: "Outro ciclo — o processo segue vivo",
    de: "Neuer Zyklus beginnt – Prozess lebt weiter",
    fr: "Nouveau cycle à venir – le processus continue",
  },
  inviteHookSecondTitleClose193: {
    ru: "День закончился точно по схеме",
    en: "Day ended exactly as planned",
    es: "El día terminó exactamente según el plan",
    pt: "O dia terminou exatamente conforme o plano",
    de: "Tag endete genau nach Plan",
    fr: "Journée finie exactement selon le plan",
  },
  inviteHookSecondTitleClose194: {
    ru: "Ритм сохранён, результат стабилен",
    en: "Rhythm maintained, structure solid",
    es: "Ritmo mantenido, estructura sólida",
    pt: "Ritmo mantido, estrutura estável",
    de: "Rhythmus beibehalten, Struktur stabil",
    fr: "Rythme maintenu, structure stable",
  },
  inviteHookSecondTitleClose195: {
    ru: "Всё по привычному сценарию",
    en: "Same familiar rhythm",
    es: "Mismo ritmo de siempre",
    pt: "Mesmo ritmo de sempre",
    de: "Gleiche Routine wie immer",
    fr: "Même routine que d’habitude",
  },
  inviteHookSecondTitleClose196: {
    ru: "Завершение плавное, как и должно быть",
    en: "Smooth finish, just as it should be",
    es: "Cierre fluido, como debe ser",
    pt: "Encerramento suave, como deve ser",
    de: "Ruhiger Abschluss, wie es sein soll",
    fr: "Clôture fluide, comme il se doit",
  },
  inviteHookSecondTitleClose197: {
    ru: "Формула отработала — цикл завершён",
    en: "System logic held — cycle wrapped",
    es: "El sistema funcionó — ciclo cerrado",
    pt: "O sistema funcionou — ciclo fechado",
    de: "System funktioniert – Zyklus geschlossen",
    fr: "Le système a fonctionné – cycle bouclé",
  },
  inviteHookSecondTitleClose198: {
    ru: "Ещё один спокойный финал, как по нотам",
    en: "Another calm ending, by the plan",
    es: "Otro cierre tranquilo, todo según el plan",
    pt: "Mais um fechamento tranquilo, tudo conforme o plano",
    de: "Wieder ruhiger Abschluss, alles im Plan",
    fr: "Une autre fin calme, tout selon le plan",
  },
  inviteHookSecondTitleClose199: {
    ru: "Плановый выход, без суеты",
    en: "Planned exit, no rush",
    es: "Salida planificada, sin prisa",
    pt: "Saída planejada, sem pressa",
    de: "Geplanter Ausstieg, keine Hektik",
    fr: "Sortie planifiée, sans précipitation",
  },
  inviteHookSecondTitleClose200: {
    ru: "Всё идёт своим чередом — новое впереди",
    en: "Everything in flow — next ahead",
    es: "Todo fluye como debe — lo nuevo por venir",
    pt: "Tudo segue como deve — o novo está por vir",
    de: "Alles läuft wie vorgesehen – Neues kommt",
    fr: "Tout suit son cours – la suite arrive",
  },
  disclaimer1: {
    ru: "Показываю свой шаг — не совет.",
    en: "Showing my move — not advice.",
    es: "Solo muestro mi movimiento, no es un consejo.",
    pt: "Mostro meu movimento, não é conselho.",
    de: "Ich zeige meinen Schritt – keine Empfehlung.",
    fr: "Je montre mon geste, ce n’est pas un conseil.",
  },
  disclaimer2: {
    ru: "Моё ежедневное действие — не больше.",
    en: "My daily action — nothing more.",
    es: "Mi acción diaria, nada más.",
    pt: "Minha ação diária, só isso.",
    de: "Meine tägliche Handlung, nicht mehr.",
    fr: "Mon geste du jour, rien de plus.",
  },
  disclaimer3: {
    ru: "Запись того, что я сделал — не для подражания.",
    en: "A record of what I did — not for imitation.",
    es: "Solo registro lo que hice, no es para copiar.",
    pt: "Registro o que fiz, não é para repetir.",
    de: "Nur eine Aufzeichnung dessen, was ich getan habe – kein Beispiel.",
    fr: "Un aperçu de ce que j’ai fait, pas à reproduire.",
  },
  disclaimer4: {
    ru: "Мой шаг — не призыв действовать.",
    en: "My own step — not a call to act.",
    es: "Es mi paso, no una invitación a actuar.",
    pt: "É o meu passo, não um convite à ação.",
    de: "Mein Schritt – kein Aufruf zu handeln.",
    fr: "C’est mon pas, pas un appel à agir.",
  },
  disclaimer5: {
    ru: "Один из моих шагов — не руководство.",
    en: "One of my moves — not a guide.",
    es: "Uno de mis pasos, no una guía.",
    pt: "Um dos meus passos, não é um guia.",
    de: "Einer meiner Schritte – keine Anleitung.",
    fr: "L’un de mes gestes, pas un guide.",
  },
  disclaimer6: {
    ru: "Показываю процесс — не инструкцию.",
    en: "Just showing my process — not an instruction.",
    es: "Solo muestro mi proceso, no es una instrucción.",
    pt: "Mostro meu processo, não é uma instrução.",
    de: "Ich zeige nur meinen Ablauf – keine Anleitung.",
    fr: "Je montre simplement mon processus, pas une instruction.",
  },
  disclaimer7: {
    ru: "Моё личное действие — не для повторения.",
    en: "My personal action — not for repetition.",
    es: "Mi acción personal, no para repetir.",
    pt: "Minha ação pessoal, não é para repetir.",
    de: "Meine eigene Handlung – nicht zur Nachahmung.",
    fr: "Mon action personnelle, pas à répéter.",
  },
  disclaimer8: {
    ru: "Момент из моей работы — не предложение.",
    en: "A moment from my work — not a suggestion.",
    es: "Un momento de mi trabajo, no una sugerencia.",
    pt: "Um momento do meu trabalho, não é uma sugestão.",
    de: "Ein Ausschnitt aus meiner Arbeit – kein Vorschlag.",
    fr: "Un moment de mon travail, pas une suggestion.",
  },
  disclaimer9: {
    ru: "Показываю для контекста — не для копирования.",
    en: "Shared for context — not for copying.",
    es: "Lo comparto como contexto, no para copiar.",
    pt: "Compartilho como contexto, não para copiar.",
    de: "Zur Einordnung geteilt – nicht zum Kopieren.",
    fr: "Partagé pour le contexte, pas pour copier.",
  },
  disclaimer10: {
    ru: "Мой способ — не пример.",
    en: "My way of doing — not an example.",
    es: "Así es como lo hago yo, no es un ejemplo.",
    pt: "É o meu jeito de fazer, não um exemplo.",
    de: "So mache ich es – kein Beispiel.",
    fr: "Ma façon de faire, pas un exemple.",
  },
  disclaimer11: {
    ru: "Мои шаги — не ориентир.",
    en: "Only my steps — not for direction.",
    es: "Mis pasos, no una referencia.",
    pt: "Meus passos, não uma referência.",
    de: "Meine Schritte – keine Orientierung.",
    fr: "Mes pas, pas une référence.",
  },
  disclaimer12: {
    ru: "Фиксирую свой путь — не призываю к действиям.",
    en: "Just documenting my path — not inviting action.",
    es: "Solo documento mi camino, no invito a actuar.",
    pt: "Registro meu caminho, não convido à ação.",
    de: "Ich dokumentiere nur meinen Weg – kein Aufruf zu handeln.",
    fr: "Je documente simplement mon parcours, sans inviter à agir.",
  },
  "timeframe-m10": {
    ru: "10м",
    en: "10m",
    es: "10m",
    pt: "10m",
    de: "10m",
    fr: "10m",
  },
  "timeframe-m60": {
    ru: "1ч",
    en: "1h",
    es: "1h",
    pt: "1h",
    de: "1h",
    fr: "1h",
  },
  "timeframe-day": {
    ru: "1Д",
    en: "1D",
    es: "1D",
    pt: "1D",
    de: "1T",
    fr: "1J",
  },
  "timeframe-week": {
    ru: "1Н",
    en: "1W",
    es: "1S",
    pt: "1S",
    de: "1W",
    fr: "1S",
  },
  "timeframe-month": {
    ru: "1М",
    en: "1M",
    es: "1M",
    pt: "1M",
    de: "1M",
    fr: "1M",
  },
};

export const translate = (lang: string, key: string): string => {
  return translation[key][lang];
};
